{
	"assistant": {
		"title": "Admin assistant",
		"open": "Open assistant",
		"close": "Close",
		"restart": "New conversation",
		"send": "Send",
		"stop": "Stop",
		"empty": "Ask about products, orders or customers.",
		"placeholder": "Type a message…",
		"toolActivity": "Running: {{tool}}…",
		"incomplete": "The reply was cut short.",
		"stopped": "You stopped the reply.",
		"errors": {
			"unavailable": "The assistant is unavailable right now.",
			"unprovisioned": "The assistant is not provisioned in this environment — contact your system administrator.",
			"rateLimited": "Too many requests — try again shortly.",
			"forbidden": "You don't have access to the admin assistant.",
			"tooLong": "The message or history is too long.",
			"network": "Network error — try again."
		},
		"pendingAction": {
			"title": "Pending approval",
			"body": "Action #{{id}} was queued for approval — it has NOT run.",
			"approve": "Approve",
			"reject": "Reject",
			"needsOperator": "Approval requires an operator with the System permission.",
			"approved": "Approved and executed.",
			"rejected": "Rejected — never executed.",
			"conflict": "Already handled by another operator.",
			"failed": "The action failed — check the pending-actions queue."
		}
	},
	"newsletters": {
		"subscriptions": {
			"title": "Newsletter",
			"editTitle": "Edit subscription",
			"formSubtitle": "Update the subscription's verified status.",
			"deleteTitle": "Delete subscription",
			"deleteBody": "Are you sure you want to delete the subscription {{email}}?",
			"columns": {
				"email": "E-mail",
				"verified": "Verified",
				"created": "Created",
				"updated": "Updated"
			}
		}
	},
	"giftcards": {
		"orders": {
			"title": "Gift Cards",
			"columns": {
				"code": "Code",
				"product": "Product",
				"buyer": "Buyer",
				"order": "Order",
				"amount": "Amount",
				"remaining": "Remaining",
				"payment": "Paid with",
				"status": "Status",
				"purchaseDate": "Purchase date",
				"expires": "Expires"
			},
			"details": {
				"title": "Details",
				"senderName": "Sender name",
				"recipientName": "Recipient name",
				"recipientEmail": "Recipient email",
				"message": "Message",
				"history": "History",
				"theme": "Theme",
				"defaultTheme": "Default image",
				"sendDate": "Send date",
				"emailStatus": "Email",
				"status": {
					"0": "Not scheduled yet",
					"1": "Scheduled",
					"2": "Sent",
					"3": "Cancelled"
				}
			}
		}
	},
	"gf_pending": "Pending",
	"gf_credit": "Credited",
	"gf_refund": "Refunded",
	"gf_consume": "Consumed",
	"gf_cancel": "Cancelled",
	"gf_for_consumption": "For Consumption",
	"gf_for_ConsumeCorrection": "Consume Correction",
	"menu": {
		"section": {
			"daily": "Daily",
			"catalog": "Catalog",
			"marketing": "Marketing & Content",
			"system": "System"
		},
		"dashboard": "Dashboard",
		"orders": "Orders",
		"ordersList": "Order List",
		"ordersSkroutz": "Skroutz",
		"ordersCreate": "New Order",
		"ordersFiltered": "Filtered",
		"ordersPaymentMethods": "Payment Methods",
		"ordersShippingMethods": "Shipping Methods",
		"ordersPickupPoints": "Pickup Points",
		"ordersInternalStatuses": "Internal Statuses",
		"customers": "Customers",
		"customersList": "Customer List",
		"customersCategories": "Customer Categories",
		"customersGroups": "Customer Profiles",
		"customersTiers": "Tiers",
		"customersCoupons": "Coupons",
		"customersAccessRules": "Access Rules",
		"customersBranches": "Branches",
		"reports": "Reports",
		"reportsSales": "Sales",
		"reportsBrands": "Brands",
		"reportsCategories": "Categories",
		"reportsProducts": "Products",
		"reportsCoupons": "Coupons",
		"reportsGeographic": "Geographic",
		"products": "Products",
		"productsList": "Product List",
		"productsCategories": "Categories",
		"productsManufacturers": "Manufacturers",
		"productsStatuses": "Statuses",
		"productsRelations": "Related Products",
		"productsReviews": "Reviews",
		"productsBackInStock": "Back-in-stock subscriptions",
		"productsFilters": "Filters",
		"productsSeasons": "Seasons",
		"productsModels": "Models",
		"productsWarehouses": "Warehouses",
		"productsWishlistTemplates": "Wishlist Templates",
		"productsFilterTemplates": "Filter Templates",
		"productsThemeTemplates": "Theme Templates",
		"attributes": "Attributes",
		"attributesList": "Attribute List",
		"attributesCategories": "Attribute Categories",
		"attributesMap": "Category Assignment",
		"attributesDimensions": "Dimensions",
		"attributesDimensionGrouping": "Dimension Grouping",
		"attributesSizeGuides": "Size Guides",
		"prices": "Prices",
		"pricesTypes": "Price Types",
		"pricesTaxCategories": "Tax Categories",
		"pricesTaxRules": "Tax Rules",
		"pricesCurrencyRates": "Currencies",
		"contributors": "Contributors",
		"contributorsList": "Contributor List",
		"contributorsCategories": "Contributor Categories",
		"contributorsGroups": "Contributor Groups",
		"promotions": "Promotions",
		"promotionsList": "Policy List",
		"loyalty": "Loyalty Points",
		"loyaltyOverview": "Overview",
		"loyaltyProducts": "Point Products",
		"loyaltyRanges": "Point Ranges",
		"loyaltyCustomers": "Customer Points",
		"loyaltyPerEntity": "Points per Entity",
		"giftcards": "Gift Cards",
		"giftcardsOrders": "Gift Card Orders",
		"newsletters": "Newsletters",
		"newslettersSubscriptions": "Subscriptions",
		"content": "Content",
		"contentPages": "Pages",
		"contentBanners": "Banners",
		"contentBannerGroups": "Banner Groups",
		"contentMenus": "Menus",
		"contentFooter": "Footer",
		"contentFaqs": "FAQs",
		"contentNews": "News",
		"contentEvents": "Events",
		"contentSocialMedia": "Social Media",
		"contentLogo": "Logo",
		"contentCustomMessageGroups": "Custom Message Groups",
		"contentCustomMessages": "Custom Messages",
		"contentCustomContent": "Custom Content",
		"contentNewsGroups": "News Groups",
		"contentVideoGroups": "Video Groups",
		"contentNotificationCategories": "Notification Categories",
		"contentNotifications": "Notifications",
		"contentNewsTags": "News Tags",
		"contentEventTags": "Event Tags",
		"contentContactForms": "Contact Forms",
		"contentPushSubscriptions": "Push Subscriptions",
		"contentFileManager": "File Manager",
		"contentNewsCategories": "News Categories",
		"contentEventCategories": "Event Categories",
		"contentEventLocations": "Event Locations",
		"contentVideoCategories": "Video Categories",
		"contentVideos": "Videos",
		"specialModules": "Special Modules",
		"modulesEvents": "Events",
		"modulesContests": "Contests",
		"system": "System",
		"systemSettings": "Settings",
		"systemUsers": "Users",
		"systemLanguages": "Languages",
		"systemCountries": "Countries",
		"importExport": "Import Export",
		"importExportImport": "Import",
		"importExportExport": "Export",
		"systemSites": "Sites",
		"systemCountryRegions": "Regions",
		"systemCities": "Cities",
		"systemPostalCodes": "Postal Codes",
		"systemTaxOffices": "Tax Offices",
		"systemEmailTemplates": "Email Templates",
		"systemEventSubscriptions": "Event Subscriptions",
		"systemTaskSchedules": "Task Schedules",
		"systemUserRoles": "User Roles",
		"systemApiKeys": "API Keys",
		"systemMcpKeys": "MCP Keys",
		"systemAiPendingActions": "AI pending actions",
		"systemActivityLog": "Activity Log",
		"systemRobotsFile": "robots.txt",
		"systemSitemapPages": "Sitemap Pages",
		"systemUrlRedirects": "301 Redirects",
		"systemSystemLog": "System Log",
		"systemErpLogs": "ERP Errors",
		"systemSmsTemplates": "SMS Templates",
		"systemAvailableDates": "Available Dates",
		"customersRegisterRequests": "Register Requests",
		"customersSalesPersons": "Sales Persons",
		"customersInspectors": "Inspectors",
		"bookings": "Bookings",
		"bookingsList": "Bookings",
		"bookingsTypes": "Booking Types",
		"bookingsRepresentatives": "Representatives",
		"bookingsReports": "Reports",
		"promotionsCoupons": "Coupons",
		"loyaltyTierRules": "Tier Rules",
		"modulesProductTabs": "Product Tabs",
		"productsBuyGuides": "Buy Guides",
		"productsBundles": "Bundles",
		"promotionsDiscountCaps": "Discount caps",
		"returns": "Returns",
		"returnsList": "Return requests",
		"returnsSettings": "Returns Settings"
	},
	"shell": {
		"comingSoon": "Coming soon to admin-v2",
		"toggleSidebar": "Toggle sidebar",
		"theme": {
			"toLight": "Switch to light theme",
			"toDark": "Switch to dark theme"
		},
		"search": {
			"label": "Search",
			"title": "Search",
			"placeholder": "Search menu pages...",
			"empty": "No pages found."
		},
		"site": {
			"open": "Open storefront",
			"copy": "Copy URL",
			"copied": "URL copied",
			"copyFailed": "Copy failed"
		},
		"language": {
			"label": "Language"
		},
		"notifications": {
			"label": "Notifications",
			"empty": "Coming soon"
		},
		"user": {
			"profile": "My profile",
			"settings": "Account settings",
			"activity": "Activity log",
			"signOut": "Sign out"
		}
	},
	"dashboard": {
		"title": "Dashboard",
		"comparison": "compared to",
		"refresh": "Refresh",
		"export": "Export",
		"live": "Live · {{ago}}",
		"range": {
			"today": "Today",
			"yesterday": "Yesterday",
			"7d": "7 days",
			"30d": "30 days",
			"90d": "90 days",
			"ytd": "Year to date",
			"custom": "Custom"
		},
		"chips": {
			"customers": "Customers",
			"productCodes": "Product codes",
			"productsVariants": "Products incl. variants"
		},
		"kpi": {
			"orders": "Orders",
			"revenue": "Revenue",
			"aov": "Average Order Value",
			"newCustomers": "New Customers",
			"conversion": "Conversion Rate",
			"vs": "vs",
			"prevPeriod": "prev. period",
			"placeholder": "sample",
			"conversionDisabled": "Unavailable — configure Google Analytics (GA4)",
			"error": "Failed to load"
		},
		"trend": {
			"comparePrev": "compared to the previous period",
			"peak": "Peak",
			"low": "Low",
			"current": "Current period",
			"previous": "Previous period",
			"vs": "vs",
			"empty": "No data for this period",
			"titles": {
				"revenue": "Revenue over time",
				"orders": "Orders over time",
				"aov": "Avg order value over time",
				"units": "Units over time"
			},
			"metric": {
				"revenue": "Revenue",
				"orders": "Orders",
				"aov": "Avg value",
				"units": "Units"
			}
		},
		"donut": {
			"total": "total"
		},
		"status": {
			"completed": "Completed",
			"processing": "Processing",
			"inDelivery": "In delivery",
			"pending": "Pending",
			"cancelled": "Cancelled",
			"refunded": "Refunded"
		},
		"statusDonut": {
			"title": "Status Breakdown",
			"count": "{{count}} orders",
			"empty": "No orders"
		},
		"paymentDonut": {
			"title": "Payment Methods",
			"subtitle": "By order count",
			"empty": "No payment data"
		},
		"gauge": {
			"title": "Cancellation Rate",
			"subtitle": "Selected period · target <{{target}}%",
			"healthy": "Healthy",
			"warning": "Watch",
			"danger": "High",
			"belowTarget": "Below target",
			"aboveTarget": "Above target",
			"ratio": "{{cancelled}} cancelled / {{total}}"
		},
		"category": {
			"title": "Sales by Category",
			"subtitle": "Top 6 by revenue · {{total}} total",
			"empty": "No category data"
		},
		"heatmap": {
			"title": "Orders by hour × day",
			"subtitle": "Order density · Europe/Athens time",
			"empty": "No order data",
			"peak": "Peak: {{day}} {{hour}}:00",
			"cell": "{{day}} {{hour}}:00 · {{count}} orders",
			"cellNote": "Each cell = 1 hour",
			"less": "Less",
			"more": "More",
			"mon": "Mon",
			"tue": "Tue",
			"wed": "Wed",
			"thu": "Thu",
			"fri": "Fri",
			"sat": "Sat",
			"sun": "Sun"
		},
		"alerts": {
			"pending": "orders pending",
			"lowStock": "low stock",
			"erp": "ERP sync errors",
			"failedPayments": "failed payments",
			"refunds": "refund requests",
			"oldest": "oldest {{ago}}",
			"none": "—",
			"belowThreshold": "below stock threshold",
			"lastFailed": "Last failed {{ago}}",
			"last24h": "last 24 hours",
			"atRisk": "{{amount}} at risk"
		},
		"recentOrders": {
			"title": "Recent Orders",
			"seeAll": "See all →",
			"empty": "No recent orders"
		},
		"topProducts": {
			"title": "Top Products",
			"period": "last 7 days",
			"sales": "{{count}} sales",
			"empty": "No sales data"
		},
		"geographic": {
			"title": "Orders by Region",
			"seeAll": "See full analysis →",
			"subtitle": "{{total}} orders · {{inGreece}} in Greece + {{outside}} outside",
			"rankingTitle": "Regions by orders",
			"topRegion": "Top region",
			"ofAllOrders": "{{pct}} of all orders",
			"median": "Median",
			"perRegion": "orders / region",
			"disclaimer": "Note: the map is a stylized approximation of the coastline.",
			"outsideTitle": "Outside Greece",
			"outsideTotal": "{{count}} orders · {{pct}}",
			"cyprus": "Cyprus",
			"cyprusMeta": "Nicosia, Limassol, Larnaca +",
			"otherCountries": "Other countries",
			"unknown": "Unknown region",
			"unknownMeta": "Missing or invalid postcode",
			"others": "Other",
			"empty": "No geographic data",
			"none": "—",
			"mapAria": "Order density by region"
		}
	},
	"reports": {
		"sales": {
			"title": "Orders Report",
			"statusFilter": "Status",
			"empty": "No data for this period",
			"ordersChart": {
				"title": "Orders per Day",
				"byChannel": "By channel",
				"byStatus": "By status",
				"total": "{{count}} Orders"
			},
			"totals": {
				"title": "Totals per Day",
				"net": "Net amount",
				"tax": "VAT",
				"shipping": "Shipping fee",
				"payment": "Payment fee",
				"grandTotal": "{{amount}} Grand total"
			},
			"payment": {
				"title": "Payment Methods",
				"subtitle": "By order count",
				"empty": "No payment data"
			},
			"shipping": {
				"title": "Shipping Methods",
				"subtitle": "By order count",
				"empty": "No shipping data"
			}
		},
		"brands": {
			"title": "Manufacturers Report",
			"empty": "No data for this period",
			"topQuantity": {
				"title": "Top 10 Manufacturers by Quantity",
				"subtitle": "By units",
				"empty": "No data"
			},
			"topTurnover": {
				"title": "Top 10 Manufacturers by Turnover",
				"subtitle": "By turnover",
				"empty": "No data"
			}
		},
		"categories": {
			"title": "Categories Report",
			"empty": "No data for this period"
		},
		"products": {
			"title": "Products Report",
			"empty": "No data for this period"
		},
		"coupons": {
			"title": "Coupons Report",
			"empty": "No data for this period",
			"columns": {
				"redemptions": "Redemptions",
				"redeemedAmount": "Discount amount",
				"turnover": "Turnover"
			}
		},
		"geographic": {
			"title": "Geographic Distribution",
			"empty": "No geographic data",
			"breakdownTitle": "Breakdown by area",
			"columns": {
				"region": "Area / Country",
				"orders": "Orders",
				"revenue": "Revenue"
			}
		},
		"columns": {
			"name": "Name",
			"category": "Category",
			"code": "Code",
			"quantity": "Quantity",
			"turnover": "Turnover"
		}
	},
	"common": {
		"save": "Save changes",
		"saving": "Saving…",
		"loading": "Loading",
		"cancel": "Cancel",
		"close": "Close",
		"delete": "Delete",
		"duplicate": "Duplicate",
		"edit": "Edit",
		"add": "Add",
		"remove": "Remove",
		"search": "Search",
		"filters": "Filters",
		"noResults": "No results found",
		"sections": "Sections",
		"previous": "Previous",
		"next": "Next",
		"none": "— None —",
		"general": "General",
		"settings": "Settings",
		"untitled": "Untitled",
		"retry": "Try again",
		"yes": "Yes",
		"no": "No",
		"unknown": "Unknown",
		"refresh": "Refresh",
		"select": "Select…",
		"expand": "Expand",
		"collapse": "Collapse",
		"soon": "Coming soon",
		"upload": "Upload",
		"replace": "Replace"
	},
	"fileBrowser": {
		"title": "Media library",
		"selectPrompt": "Browse and pick an existing file to link, or upload a new one — no need to re-upload the same asset twice.",
		"root": "Home",
		"insert": "Insert",
		"upload": "Upload",
		"uploading": "Uploading…",
		"empty": "This folder is empty.",
		"errorLoad": "Could not load the media library.",
		"uploadError": "The file could not be uploaded.",
		"uploadRejected": "Unsupported file type. Allowed: images, ZIP, XML, DOC, DOCX, XLS, XLSX, CSV, TXT, PDF."
	},
	"auth": {
		"login": {
			"title": "Sign in",
			"subtitle": "{{brand}} Administration",
			"username": "Email / Username",
			"password": "Password",
			"submit": "Sign in",
			"error": "Invalid credentials"
		}
	},
	"promotion": {
		"surface": {
			"editor": {
				"title": "Edit Policy"
			},
			"grid": {
				"title": "Commercial Policies",
				"new": "New Policy"
			}
		},
		"crumbs": {
			"offers": "Offers",
			"policies": "Commercial Policies"
		},
		"status": {
			"active": "Active",
			"scheduled": "Scheduled",
			"expired": "Expired",
			"draft": "Draft",
			"visible": "Visible",
			"hidden": "Hidden",
			"inactive": "Inactive"
		},
		"tabs": {
			"all": "All",
			"active": "Active",
			"scheduled": "Scheduled",
			"expired": "Expired",
			"draft": "Drafts"
		},
		"basicInfo": {
			"tab": "Basic Info",
			"identity": {
				"title": "Identity",
				"subtitle": "Core identification details for the policy",
				"name": "Name",
				"nameHelp": "The policy name as shown in management lists",
				"code": "Code",
				"codeHelp": "Unique reference code (synced with ERP)",
				"priority": "Priority",
				"priorityHelp": "Application order when multiple policies match. Lower numbers apply first."
			},
			"description": {
				"title": "Description & Badge",
				"subtitle": "Text shown in the store and management",
				"description": "Description",
				"badgeText": "Product-list badge label",
				"badgeTextHelp": "Short text shown on the product-list badge (e.g. -20%, SUMMER)",
				"frontLabel": "Storefront label",
				"frontLabelHelp": "Label shown on products covered by the policy (saved for the current language).",
				"colorHex": "Label text colour",
				"backgroundColorHex": "Label background colour",
				"externalUrl": "External link",
				"externalUrlHelp": "Optional link the storefront label points to."
			},
			"images": {
				"title": "Images",
				"subtitle": "Product badge and background for the offer page",
				"badge": "Badge image",
				"background": "Background image",
				"backgroundHelp": "Shown as a banner on the offer page. Accepts the same formats as product images."
			},
			"statusVisibility": {
				"title": "Status & Visibility",
				"subtitle": "When the policy applies and whether it is visible in the store",
				"active": "Active",
				"activeHelp": "The policy is enabled and can be applied. If inactive, its Conditions and Actions are ignored.",
				"visible": "Visible in offers",
				"visibleHelp": "The policy appears on the store's offers page and in the active discounts list.",
				"hidden": "Hide from offers",
				"hiddenHelp": "The policy applies normally but is not shown in the public offers list (useful for hidden offers, partner codes, etc.)"
			}
		},
		"conditions": {
			"tab": "Conditions",
			"timeWindow": {
				"title": "Time window",
				"subtitle": "The period within which the policy can apply",
				"from": "Valid from",
				"to": "Valid until",
				"help": "Leave the fields empty for no time limit.",
				"durationDays": "{{count}} days",
				"scheduledNote": "This policy is currently scheduled — it starts in {{count}} days."
			},
			"cartThresholds": {
				"title": "Cart limits",
				"subtitle": "Quantitative rules that must hold for the policy to apply",
				"minAmount": "Minimum amount",
				"minAmountHelp": "The cart must be worth at least this much",
				"maxAmount": "Maximum amount",
				"maxAmountHelp": "Upper limit. Leave empty for none",
				"minQuantity": "Minimum quantity",
				"minQuantityHelp": "Total number of items in the cart",
				"selectedOnly": "Apply only to selected products",
				"selectedOnlyHelp": "When on, the amount and quantity limits above are computed only for the products matching the product conditions below — not the whole cart."
			},
			"productSelection": {
				"title": "Product selection",
				"subtitle": "Which products the policy applies to",
				"banner": "Combine selections from specific products, categories and manufacturers. Leave all fields empty to apply to all products.",
				"products": "Specific products",
				"productsPlaceholder": "Search product by name, SKU or barcode…",
				"productsHelp": "Select specific products — the adjacent combinator sets whether at least one of them, or all, must be in the cart.",
				"categories": "Specific product categories",
				"categoriesPlaceholder": "Add category…",
				"categoriesHelp": "Products from any of the selected categories (subcategories included)",
				"manufacturers": "Specific manufacturers",
				"manufacturersPlaceholder": "Add manufacturer…",
				"manufacturersHelp": "Products from any of the selected publishers / manufacturers",
				"bulkImport": {
					"trigger": "Bulk import",
					"title": "Bulk import products",
					"subtitle": "Paste or upload a list of product codes/barcodes to add them to this policy. Matched products are added to the selection above and saved when you save the policy.",
					"pasteLabel": "Paste codes",
					"pastePlaceholder": "SKU-001\nSKU-002\n5200000000012",
					"pasteHelp": "One code or barcode per line (commas and semicolons also work).",
					"fileLabel": "Or upload a file",
					"fileDropHint": "Drag & drop a file here",
					"chooseFile": "Choose file",
					"allowedExtensions": "Allowed: .xlsx, .csv, .txt — codes are read from the first column.",
					"importCta": "Import",
					"summary": "Matched {{matched}} of {{total}} codes.",
					"invalidFile": "Unsupported file type. Allowed: .xlsx, .csv, .txt.",
					"allMatched": "All codes matched and were added to the selection.",
					"unmatchedTitle": "{{count}} codes matched no product:"
				}
			},
			"combinators": {
				"inner": {
					"label": "Specific products",
					"any": "OR (at least one in cart)",
					"all": "AND (all in cart)"
				},
				"outer": {
					"label": "Selection combination",
					"or": "OR — any block matches",
					"and": "AND — all blocks match"
				}
			},
			"customerRestriction": {
				"title": "Customer restriction",
				"subtitle": "Which customers the policy applies to (leave empty to apply to all)",
				"categories": "Customer categories",
				"categoriesPlaceholder": "Add customer category…",
				"categoriesHelp": "E.g. VIP, B2B, Registered, First purchase",
				"profiles": "Specific customer profiles",
				"profilesPlaceholder": "Search customer by name or email…",
				"profilesHelp": "Specific customer accounts (not a category)"
			},
			"siteScope": {
				"title": "Application scope",
				"subtitle": "Which sites the policy applies to",
				"sites": "Selected sites",
				"sitesPlaceholder": "Add specific sites…",
				"sitesLoading": "Loading sites…",
				"sitesError": "Failed to load sites",
				"sitesHelp": "Leave empty to use the scope option below",
				"allSites": "All sites",
				"allSitesHelp": "The policy applies to every site of the installation",
				"defaultSite": "Main site only",
				"defaultSiteHelp": "Applies exclusively to the default site",
				"ignoredNote": "You have selected specific sites — the option below is ignored."
			}
		},
		"action": {
			"tab": "Actions",
			"title": "Policy actions",
			"subtitle": "What this policy does when it applies. Actions run in the order shown.",
			"addAction": "Add action",
			"count": "{{count}} actions",
			"combine": "Combine",
			"duplicateAction": "Duplicate action",
			"removeAction": "Remove action",
			"types": {
				"percentageDiscount": "Percentage Discount",
				"valueDiscount": "Value Discount",
				"fixedPrice": "Fixed Price",
				"bogo": "Percentage Discount X+Y",
				"giftProduct": "Gift product",
				"perProductDiscount": "Per-product discount",
				"categoryDiscount": "Category discount",
				"shippingDiscount": "Shipping discount"
			},
			"tierMode": {
				"fixed": "Fixed",
				"byQuantity": "Tiered by quantity",
				"byAmount": "Tiered by amount",
				"addTier": "Add tier",
				"help": {
					"fixed": "With a fixed discount, a single tier sets the cart threshold and the value subtracted.",
					"byQuantity": "When tiered by quantity, the value changes with the number of items in the cart.",
					"byAmount": "When tiered by amount, the value scales with the cart value."
				},
				"sublabel": {
					"fixed": "Fixed tier",
					"byQuantity": "Tiers by quantity",
					"byAmount": "Tiers by amount"
				}
			},
			"applicationMode": {
				"label": "Application mode",
				"once": "Once",
				"perItem": "Per item",
				"help": "Determines whether the discount applies once to the whole cart or separately per item."
			},
			"perProduct": {
				"minQty": "Min",
				"discount": "Discount",
				"maxQty": "Max",
				"maxQtyTooltip": "Above this quantity, the policy does not apply at all."
			},
			"bogo": {
				"expression": "For every <0/> items in the cart, give <1/> item at <2/>% off",
				"sameProductOnly": "Must be the same product",
				"sameProductOnlyHelp": "When on, the X and Y items must be the same product. When off, any product passing the Conditions matches.",
				"percentageRequired": "Set the discount percentage, or give every offer row its own discount.",
				"percentageOptional": "Optional: every offer row has its own discount.",
				"reachPricingMode": "Products not receiving the discount are charged at",
				"reachPricingModeHelp": "Applies to the X (reach) items of each block.",
				"reachPricingAfterDiscount": "Pricelist price",
				"reachPricingBeforeDiscount": "Original (pre-discount) pricelist price",
				"offerTargets": "Products that receive the discount (optional)",
				"offerTargetsHelp": "When products or categories are set, every X items of the policy's selected products give the discount to up to Y of these items. Leave empty for the classic X+Y discount. A row without its own discount uses the percentage above. Max qty (products only) caps how many items of that product get the discount (empty = no limit).",
				"offerProducts": "Products",
				"offerCategories": "Categories",
				"product": "Product",
				"category": "Category",
				"ownDiscount": "Discount",
				"addOfferProduct": "Add product",
				"addOfferCategory": "Add category"
			},
			"gift": {
				"maxSelections": "Max selections",
				"products": "Gift products",
				"prompt": "Gift prompt message",
				"promptHelp": "Shown at checkout when the customer can pick a gift."
			},
			"shipping": {
				"method": "Method",
				"type": "Type",
				"amount": "Amount",
				"addRule": "Add rule",
				"stopProcessing": "Stop",
				"stopProcessingHelp": "Stops processing subsequent rules of this action",
				"additive": "Add",
				"additiveHelp": "Adds to the discount from previous rules",
				"typePercentage": "Percentage",
				"typeFixed": "Fixed amount",
				"typeFree": "Free",
				"rule": "Rule"
			},
			"applyOnDiscounted": {
				"label": "Behavior on discounted products",
				"none": "Do not apply",
				"max": "Maximum discount",
				"additive": "Additional discount",
				"onFinal": "On final price",
				"help": "How it behaves when the product has a discount from the price list."
			},
			"discountMode": {
				"label": "Type",
				"percentage": "Percentage (%)",
				"amount": "Fixed amount per item (€)"
			},
			"categoryDiscount": {
				"category": "Category",
				"maxChoices": "Max customer choices",
				"maxChoicesHelp": "Empty = no limit.",
				"add": "Add discount category"
			}
		},
		"rail": {
			"status": "Status",
			"summary": "Policy Summary",
			"badgePreview": "Badge Preview",
			"appliesWhen": "Applies when",
			"applies": "Applies",
			"badgePreviewCaption": "Appearance in the product list",
			"validFromTo": "Valid {{from}} – {{to}}",
			"relativeInDays": "in {{count}} days",
			"relativeAgoDays": "{{count}} days ago",
			"relativeInForce": "in force",
			"summaryCartMin": "Cart ≥ €{{amount}}",
			"summaryProducts": "{{count}} specific products",
			"summaryCategories": "{{count}} product categories",
			"summaryCategoriesNamed": "Category: {{names}}",
			"summaryCustomers": "{{count}} customer categories",
			"summaryCustomersNamed": "Customers: {{names}}",
			"summaryCombines": "Combines with other discounts",
			"summaryAllSites": "All sites",
			"summaryDefaultSite": "Main site only",
			"summarySpecificSites": "{{count}} selected sites",
			"summaryEmpty": "No conditions — applies everywhere",
			"applyDescPercentTiered": "{{from}}–{{to}}% tiered discount {{mode}}",
			"applyDescPercentFixed": "{{value}}% discount",
			"applyDescValueTiered": "€{{from}}–{{to}} tiered discount {{mode}}",
			"applyDescValueFixed": "€{{value}} fixed discount",
			"applyDescFixedPriceTiered": "Tiered price {{mode}}",
			"applyDescFixedPriceFixed": "Fixed price €{{value}}",
			"applyDescBogo": "Buy {{x}}, get {{y}} at {{z}}% off",
			"applyDescByAmount": "by cart amount",
			"applyDescByQuantity": "by quantity",
			"applyDescGift": "Gift product — {{selections}} choice of {{total}} available",
			"applyDescPerProduct": "Discount on {{count}} products",
			"applyDescCategory": "Discount on {{count}} categories",
			"applyDescShipping": "{{count}} shipping-discount rules"
		},
		"grid": {
			"columns": {
				"policy": "Policy",
				"types": "Types",
				"validity": "Validity",
				"status": "Status"
			},
			"empty": {
				"title": "No commercial policies",
				"subtitle": "Create your first policy to get started."
			},
			"error": {
				"title": "Failed to load policies",
				"subtitle": "Could not load commercial policies. Check the connection and try again."
			},
			"rowMenu": {
				"edit": "Edit",
				"duplicate": "Duplicate",
				"viewInStore": "View in store",
				"exportJson": "Export as JSON",
				"history": "Change history",
				"delete": "Delete"
			},
			"pagination": {
				"showing": "Showing {{from}}-{{to}} of {{total}}",
				"perPage": "{{count}} / page"
			},
			"validityInDays": "in {{count}} days",
			"validityAgoDays": "{{count}} days ago",
			"validityInForce": "In force",
			"validityNoLimit": "No time limit",
			"typesOverflow": "+{{count}}",
			"filtersComingSoon": "Filters: coming soon"
		},
		"discountCaps": {
			"title": "Discount caps",
			"subtitle": "{{count}} caps — how far any discount may reduce a product's unit price",
			"add": "New cap",
			"addTitle": "New discount cap",
			"editTitle": "Edit discount cap",
			"formSubtitle": "Discounts on this product (or dimension) never take the unit price below the cap. Loyalty, gift cards, cart-level coupons, forced prices and free products are not capped.",
			"searchPlaceholder": "Search by product code, name, barcode…",
			"allDimensions": "All dimensions",
			"activeFromNow": "Now",
			"deleteTitle": "Delete discount cap",
			"deleteBody": "Delete the cap of {{name}}? A cap already used by orders is closed instead of deleted.",
			"fields": {
				"product": "Product",
				"dimension": "Dimension",
				"maxDiscountPercentage": "Max discount %",
				"maxDiscountAmount": "Max discount amount",
				"minimumFinalUnitPrice": "Minimum final unit price",
				"basis": "Percentage/amount basis",
				"activeFrom": "Active from",
				"isActive": "Active"
			},
			"basis": {
				"0": "On initial price",
				"1": "On final price"
			},
			"validation": {
				"product_required": "Product is required",
				"product_not_found": "Product not found",
				"dimension_not_found": "The dimension does not belong to the product",
				"at_least_one_cap_required": "Set at least one of max %, max amount or minimum final price",
				"percentage_range": "Percentage must be above 0 and up to 100, with at most 2 decimals",
				"referenced": "Orders started using this cap; try again to close it instead",
				"amount_range": "Amount must be 0 or more, with at most 4 decimals",
				"minimum_final_unit_price_range": "Minimum final price must be 0 or more, with at most 4 decimals",
				"basis_required": "Basis is required",
				"basis_invalid": "Invalid basis",
				"duplicate_open_cap": "A cap already exists for this product/dimension",
				"closed_cap_immutable": "A superseded cap cannot be changed",
				"load_options_required": "Missing list parameters"
			}
		}
	},
	"productEditor": {
		"railLabel": "Product",
		"crumbs": {
			"catalog": "Catalog",
			"products": "Products",
			"untitled": "(untitled)"
		},
		"head": {
			"code": "Code",
			"visible": "Visible",
			"hidden": "Hidden",
			"outOfStock": "Out of stock",
			"more": "More actions",
			"menu": {
				"viewInStore": "View in store",
				"duplicate": "Duplicate",
				"archive": "Archive"
			}
		},
		"tabs": {
			"basic": "Basic",
			"categories": "Categories",
			"descriptions": "Descriptions",
			"images": "Media",
			"files": "Files",
			"prices": "Prices",
			"characteristics": "Characteristics",
			"variants": "Variants",
			"relations": "Relations",
			"states": "States",
			"awards": "Awards",
			"points": "Points",
			"garan": "GARAN",
			"faqs": "FAQs",
			"returnPolicy": "Product returns",
			"bundles": "Bundles"
		},
		"files": {
			"slot": "File {{n}}",
			"empty": "No file",
			"staged": "{{name}} (uploads on save)",
			"upload": "Upload",
			"replace": "Replace",
			"remove": "Remove",
			"undo": "Undo",
			"supportText": "Up to 5 documents shown on the product page. New files upload when you save the product."
		},
		"tabBody": {
			"saveHint": "All changes save with the page Save button",
			"comingSoon": "This section is completed in a later phase."
		},
		"rail": {
			"preview": "Preview",
			"status": "Status",
			"storefront": "Storefront",
			"stock": "Stock",
			"retailPrice": "Retail price",
			"priceValue": "{{value}} €",
			"discount": "Discount",
			"sync": "Sync",
			"lastErpSync": "Last ERP sync",
			"syncStatus": "Status"
		},
		"toasts": {
			"saveBeforeSync": "Save the product before ERP sync.",
			"uploadingImages": "Uploading {{done}} of {{total}} images…",
			"satelliteSaveFailed": "Saving “{{tab}}” failed.",
			"savedWithSatelliteFailures": "Saved; failed: {{tabs}}"
		}
	},
	"products": {
		"erpSync": {
			"synced": "Synced {{when}}",
			"upToDate": "Up to date",
			"pending": "Pending",
			"syncWithErp": "Sync with ERP"
		},
		"prices": {
			"priceLabel": "Price label",
			"price": "Price",
			"preDiscount": "Pre-discount",
			"discountPercent": "Discount %",
			"default": "Default",
			"vatIncl": "Incl. VAT",
			"vatExcl": "Excl. VAT"
		},
		"characteristics": {
			"searchPlaceholder": "Search characteristics…",
			"selectPlaceholder": "Select…",
			"searchable": "Searchable",
			"unsupportedHint": "Unsupported type — edit via ERP",
			"attributeCount": "{{count}} attributes",
			"emptyTitle": "No characteristics configured",
			"emptyHelp": "This product has no characteristic schema defined in the ERP. Sync with ERP to fetch the latest configuration.",
			"noMatches": "No characteristics found",
			"flatGroup": "General characteristics"
		},
		"points": {
			"heroActive": "{{count}} points per purchase",
			"heroDisabled": "Points are disabled",
			"heroHelp": "{{brand}} loyalty: 100 points = €1.00 in store credit.",
			"fieldLabel": "Points awarded per purchase",
			"unit": "points",
			"disabledHint": "Set to 0 to disable point rewards for this product.",
			"tabMeta": "Loyalty points awarded per purchase"
		},
		"garan": {
			"tabMeta": "Commercial guarantee of durability (EU Reg. 2025/1960)",
			"banner": "Enabling GARAN attests that the guarantee is offered by the producer, free of charge, and covers the whole product. The effective duration must be over 2 years to qualify for the label.",
			"overrides": {
				"title": "Product overrides",
				"subtitle": "Override the producer defaults for this product. Leave the switch on “Inherit” to follow the producer."
			},
			"fields": {
				"enabled": "GARAN switch",
				"enabledHelp": "Inherit uses the producer default; On/Off force it for this product.",
				"years": "Guarantee duration (years)",
				"yearsHelp": "Overrides the producer's years for this product; leave empty to inherit them. Must be over 2 years to qualify.",
				"model": "Model identifier",
				"modelHelp": "The commercial model the guarantee refers to. Falls back to the product code when empty."
			},
			"mode": {
				"inherit": "Inherit from producer",
				"on": "On",
				"off": "Off"
			},
			"computed": {
				"title": "Effective values",
				"subtitle": "Computed by the server after applying inheritance — read only.",
				"eligible": "Eligible for GARAN label",
				"notEligible": "Not eligible",
				"effectiveYears": "Effective duration",
				"effectiveProducer": "Producer",
				"effectiveModel": "Effective model",
				"yearsValue": "{{count}} years",
				"inheritNote": "This product inherits the producer's GARAN default."
			}
		},
		"categories": {
			"filterPlaceholder": "Filter categories…",
			"expandAll": "Expand all",
			"collapseAll": "Collapse all",
			"showOnlySelected": "Show only selected",
			"categoryName": "Category name",
			"main": "Main",
			"mainBadge": "Main",
			"subcategories": "{{count}} subcategories",
			"setMain": "Set as main: {{name}}",
			"expand": "Expand",
			"collapse": "Collapse",
			"noMatches": "No categories found"
		},
		"images": {
			"main": "Main",
			"replace": "Replace",
			"preview": "Preview",
			"remove": "Remove",
			"dragToReorder": "Drag to reorder",
			"uploading": "Uploading…",
			"addSlot": "Add",
			"dropTitle": "Drop images here to upload",
			"dropHelp": "or click to browse · JPG, PNG, WebP up to {{maxSize}}MB",
			"usage": "{{used}} uploaded · {{available}} slots available · max {{max}}"
		},
		"quickEdit": {
			"title": "Quick edit",
			"openFull": "Open full product",
			"visibilitySection": "Storefront visibility",
			"visibleTitle": "Visible on storefront",
			"visibleHelp": "When OFF, the product is hidden from listings and search results.",
			"availabilitySection": "Availability status",
			"availabilityPlaceholder": "Select availability",
			"availabilityHelp": "Determines the stock badge shown on the storefront.",
			"feedsSection": "Social/Shopping feeds",
			"socialFeeds": "Social/Shopping feeds",
			"flagsSection": "Product flags",
			"featured": "Featured",
			"used": "Used product",
			"newRelease": "New release",
			"onSale": "On sale",
			"limited": "Limited edition",
			"bestseller": "Bestseller",
			"unsaved": "{{count}} unsaved changes"
		},
		"descriptions": {
			"designView": "Design",
			"htmlView": "HTML",
			"htmlModeNote": "Editing raw HTML — preserved as-is on save.",
			"undo": "Undo",
			"redo": "Redo",
			"bold": "Bold",
			"italic": "Italic",
			"strike": "Strikethrough",
			"underline": "Underline",
			"textColor": "Text color",
			"clearColor": "Clear color",
			"highlight": "Highlight",
			"clearHighlight": "Clear highlight",
			"alignLeft": "Align left",
			"alignCenter": "Align center",
			"alignRight": "Align right",
			"justify": "Justify",
			"bulletList": "Bullet list",
			"orderedList": "Ordered list",
			"blockquote": "Blockquote",
			"link": "Insert link",
			"linkPrompt": "Link URL",
			"image": "Upload image",
			"browseLibrary": "Insert from media library",
			"clearFormat": "Clear formatting",
			"words": "Words",
			"characters": "Characters",
			"lines": "Lines",
			"htmlPreserved": "HTML preserved as-is on save"
		},
		"basic": {
			"identification": {
				"title": "Identification",
				"subtitle": "Required: Code"
			},
			"naming": {
				"title": "Naming & display"
			},
			"inventory": {
				"title": "Inventory & ordering",
				"subtitle": "Required: Availability, Product type"
			},
			"flags": {
				"title": "Visibility & flags",
				"subtitle": "Storefront visibility and data feeds"
			},
			"dimensions": {
				"title": "Dimensions & manufacturer"
			},
			"seo": {
				"title": "SEO",
				"subtitle": "Used by search engines and storefront meta tags"
			},
			"fields": {
				"code": "Code (SKU)",
				"barcode": "Barcode",
				"erpCode": "ERP code",
				"groupCode": "Group code",
				"seoUrl": "SEO URL",
				"name": "Name",
				"subtitle": "Subtitle",
				"headerTitle": "Header title",
				"headerTitleHelp": "Optional — overrides Name in the storefront header.",
				"availability": "Availability",
				"availabilityPlaceholder": "Select availability…",
				"productType": "Product type",
				"productTypePlaceholder": "Select type…",
				"subType": "Sub-type",
				"subTypePlaceholder": "Select sub-type…",
				"quantity": "Quantity",
				"baseMU": "Base UOM",
				"weightMU": "Weight UOM",
				"orderMinQty": "Min order qty",
				"orderMaxQty": "Max order qty",
				"orderStepQty": "Step order qty",
				"releaseDate": "Release date",
				"displayOrder": "Display order",
				"pieces": "Pieces",
				"size": "Size",
				"weight": "Weight",
				"width": "Width",
				"length": "Length",
				"height": "Height",
				"manufacturer": "Manufacturer",
				"manufacturerPlaceholder": "Select…",
				"metaTitle": "Meta title",
				"metaTitleHelp": "Falls back to product Name if empty.",
				"metaDescription": "Meta description",
				"metaKeywords": "Meta keywords",
				"canonicalUrl": "Canonical URL",
				"indexing": "Indexing"
			},
			"productTypes": {
				"Product": "Product",
				"GiftCard": "Gift card",
				"Grouped": "Grouped",
				"Bundle": "Bundle",
				"Giftbox": "Gift box",
				"Custom": "Custom"
			},
			"flagLabels": {
				"isVisible": "Visible",
				"disableShoppingCart": "Cart disabled",
				"allowOutOfStockOrdering": "Allow out-of-stock ordering",
				"hasDimensionPages": "Variant pages",
				"isUsed": "Used",
				"isFeatured": "Featured",
				"showSkroutz": "Skroutz",
				"showBestPrice": "BestPrice",
				"showYou": "You.gr",
				"showJeanious": "Jeanious",
				"showLinkwise": "Linkwise",
				"frontExclusion": "Front exclusion",
				"showSocial": "Social/Shopping feeds",
				"disableIndexation": "Disable indexation",
				"disableFollow": "Disable follow"
			},
			"flagHelp": {
				"isVisible": "Show on storefront.",
				"disableShoppingCart": "Browsing only; cannot purchase.",
				"allowOutOfStockOrdering": "Can be added to cart and purchased even at zero stock.",
				"hasDimensionPages": "Each variant gets its own page, URL and SEO.",
				"showSkroutz": "Include in Skroutz feed.",
				"frontExclusion": "Hide from storefront landing pages.",
				"showSocial": "Include in Google Shopping and Facebook Catalog."
			}
		},
		"categoriesTab": {
			"pickHint": "Pick at least one category for the product",
			"allTitle": "All categories",
			"selectedSummary": "{{count}} selected",
			"loadError": "Failed to load the category tree."
		},
		"descriptionsTab": {
			"saveHint": "Both fields save with page Save",
			"erpBanner": "Editing ERP-synced content? The Design view preserves common formatting but may normalize edge-case inline styles. To edit raw HTML directly, switch to the HTML view.",
			"shortTitle": "Short description",
			"shortSubtitle": "Appears in product cards and meta description fallback",
			"shortPlaceholder": "Short description…",
			"longTitle": "Long description",
			"longSubtitle": "Full product page content below images",
			"longPlaceholder": "Detailed product description…"
		},
		"pricesTab": {
			"meta": "Schema driven by ERP sync · {{count}} price rows configured",
			"banner": "Config-driven tab. Price labels and VAT inclusion come from the ERP schema. The storefront uses the row marked Default.",
			"sectionTitle": "Pricing",
			"vatCategory": "VAT category",
			"vatCategoryPlaceholder": "Select VAT category",
			"discountEnabled": "Discount enabled",
			"empty": "No price rows configured for this product."
		},
		"characteristicsTab": {
			"meta": "{{count}} attributes across {{groups}} groups · Schema from ERP",
			"banner": "Config-driven tab. Attributes are grouped by category name. When no category is set, they fall back to a single flat list."
		},
		"imagesTab": {
			"meta": "{{used}} of {{max}} slots used",
			"supportText": "Slot 1 is the main image (card cover and the first image on the product page). Slots 2–15 render in their slot order — drag to reorder. JPG, PNG or WebP up to 5MB each. Changes upload when you save."
		},
		"faqs": {
			"listTitle": "Product FAQs",
			"listHint": "Drag to reorder · Click any FAQ to edit",
			"empty": "No questions configured yet. Add the first one.",
			"add": "Add FAQ",
			"question": "Question",
			"questionPlaceholder": "e.g. Is it suitable for 3rd-year high-school students?",
			"answer": "Answer",
			"answerPlaceholder": "Write the answer…",
			"editing": "Editing FAQ #{{index}}",
			"untitled": "(no question)",
			"expand": "Expand",
			"collapse": "Collapse",
			"dragToReorder": "Drag to reorder",
			"mediaDisabledNote": "Images and attachments are disabled in FAQ answers.",
			"tabMeta": "{{count}} questions",
			"tabBanner": "FAQs appear on the product detail page in the storefront.",
			"loadError": "Failed to load FAQs."
		},
		"awards": {
			"listTitle": "All awards",
			"add": "Add award",
			"empty": "No awards yet.",
			"addTitle": "Add award",
			"editTitle": "Edit award",
			"dialogSubtitle": "Name, location, date, description and up to 2 images.",
			"name": "Award name",
			"namePlaceholder": "e.g. School Book Award",
			"location": "Location",
			"locationPlaceholder": "Awarding body, city or country",
			"date": "Award date",
			"description": "Description",
			"descriptionNote": "Images go in the fields below, not inside the text.",
			"image1": "Image 1 (primary)",
			"image1Hint": "Primary badge — appears in the awards gallery.",
			"image2": "Image 2 (optional)",
			"save": "Save award",
			"untitled": "(unnamed)",
			"imagesCount": "{{count}} images",
			"dragToReorder": "Drag to reorder",
			"tabMeta": "{{count}} awards",
			"requiresSystemRole": "Editing awards requires the System role. Read-only.",
			"loadError": "Failed to load awards."
		},
		"variants": {
			"listTitle": "All variants ({{count}})",
			"add": "Add variant",
			"generate": "Generate combinations",
			"empty": "No variants yet.",
			"colImage": "Image",
			"colVariant": "Variant",
			"colSku": "SKU",
			"colBarcode": "Barcode",
			"colPrice": "Price",
			"colStock": "Stock",
			"colVisible": "Visible",
			"visible": "Visible",
			"hidden": "Hidden",
			"hide": "Hide",
			"show": "Show",
			"addTitle": "Add variant",
			"addSubtitle": "New sub-SKU under {{parentSku}}",
			"dimensionFallback": "Dimension",
			"dimensionPlaceholder": "e.g. 2025",
			"dimensionHint": "Configured dimension for this product. Required.",
			"dimensionValuesHint": "Pick a value for at least one dimension.",
			"sku": "SKU",
			"skuHint": "Auto-generated from parent SKU + dimension value. Edit to override.",
			"barcode": "Barcode",
			"price": "Price",
			"preDiscount": "Pre-discount",
			"stock": "Stock",
			"visibleOnStorefront": "Visible on storefront",
			"generateTitle": "Generate variant combinations",
			"generateSubtitle": "Bulk-create variants from selected dimension values",
			"selectedCount": "({{count}} selected)",
			"generatePreview": "{{count}} new variants will be generated. Each gets a unique auto-generated SKU.",
			"defaultsLabel": "Defaults for new variants",
			"defaultPrice": "Default price",
			"defaultStock": "Default stock",
			"defaultsNote": "All new variants inherit these defaults. You can edit each one afterwards.",
			"generateAction": "Generate {{count}} variants",
			"tabMeta": "{{count}} variants",
			"loadError": "Failed to load variants.",
			"editTitle": "Edit variant",
			"disableCart": "Disable add to cart",
			"frontExclusion": "Hide from storefront",
			"releaseDate": "Release date",
			"cartDisabledBadge": "No cart",
			"frontExcludedBadge": "Hidden from store",
			"pageAction": "Page",
			"pageTitle": "Variant page",
			"pageSubtitle": "Page, URL and SEO of {{label}} (in the current language)",
			"pageInheritHint": "Empty fields inherit the product's values on the storefront. An empty slug is generated from the name.",
			"pageFlagOffNote": "Used only when \"Variant pages\" is on in the product's Basic tab.",
			"pageName": "Name",
			"pageSlug": "Slug",
			"pageSlugHelp": "Served under /products/{slug}.",
			"pageSeoTitle": "SEO",
			"pageMetaTitle": "Meta title",
			"pageMetaDescription": "Meta description",
			"pageMetaKeywords": "Meta keywords",
			"pageShortDescription": "Short description",
			"pageLongDescription": "Long description",
			"pageLoadError": "Failed to load the variant page.",
			"pageSaved": "Variant page saved.",
			"pageSaveError": "Failed to save the variant page."
		},
		"surface": {
			"title": "Products"
		},
		"actions": {
			"excelExport": "Excel export",
			"excelExportStubHint": "Coming soon — requires a server-side export endpoint",
			"newProduct": "New product"
		},
		"filters": {
			"title": "Product filters",
			"subtitle": "Narrow down the grid results.",
			"barcodePlaceholder": "Search by barcode…",
			"categoriesPlaceholder": "Select categories…",
			"statuses": "Statuses",
			"statusesPlaceholder": "Select statuses…",
			"subTypes": "Sub-types",
			"subTypesPlaceholder": "Select sub-types…",
			"availability": "Availability",
			"availabilityPlaceholder": "Select availability…",
			"priceRange": "Retail price range",
			"discountRange": "Discount range (%)",
			"quantityRange": "Stock range",
			"releaseDateRange": "Release date",
			"from": "From",
			"to": "To",
			"triAny": "Any",
			"apply": "Apply",
			"clear": "Clear"
		},
		"columns": {
			"title": "Visible columns",
			"reset": "Reset columns"
		},
		"massEdit": {
			"title": "Mass edit",
			"subtitle": "Apply changes to {{count}} selected products.",
			"keep": "No change",
			"apply": "Apply to {{count}}",
			"success": "Updated {{count}} products"
		},
		"chips": {
			"label": "Saved filters",
			"outOfStock": "Out of stock",
			"hidden": "Hidden products",
			"newReleases": "New releases",
			"featured": "Featured",
			"noImage": "No image",
			"saveCurrent": "Save current",
			"saveCurrentHint": "Coming soon"
		},
		"toolbar": {
			"searchPlaceholder": "Search by name, SKU, or barcode…",
			"columns": "Columns",
			"columnsHint": "Coming soon",
			"massEdit": "Mass edit",
			"massErpSync": "Mass ERP sync"
		},
		"selection": {
			"count": "{{count}} products selected",
			"onPage": "across page {{page}}",
			"hint": "Use Mass edit or Mass ERP sync in the toolbar above to act on the selection.",
			"clear": "Clear selection"
		},
		"gridBar": {
			"showing": "Showing",
			"of": "of",
			"comfortable": "Comfortable",
			"compact": "Compact"
		},
		"grid": {
			"selectAll": "Select all",
			"selectRow": "Select {{name}}",
			"categoryMore": "+{{count}}",
			"columns": {
				"image": "Image",
				"name": "Name",
				"sku": "SKU",
				"barcode": "Barcode",
				"category": "Category",
				"stock": "Stock",
				"preDiscount": "Pre-discount",
				"discount": "Discount",
				"retail": "Retail price",
				"visible": "Visible",
				"id": "ID",
				"subTitle": "Subtitle",
				"baseName": "Base name",
				"altCode": "Alt. code",
				"groupCode": "Group code",
				"erpCode": "ERP code",
				"manufacturer": "Manufacturer",
				"subType": "Subtype",
				"productType": "Product type",
				"availability": "Availability",
				"featured": "Featured",
				"hasDiscount": "Has discount",
				"releaseDate": "Release date",
				"sortIndex": "Sort"
			},
			"rowMenu": {
				"label": "Actions",
				"open": "Open product",
				"quickEdit": "Quick edit",
				"warehouses": "View warehouses",
				"related": "Related products",
				"sync": "Sync with ERP",
				"duplicate": "Duplicate",
				"delete": "Delete"
			}
		},
		"pager": {
			"rowsPerPage": "Rows per page:",
			"first": "First",
			"prev": "Previous",
			"next": "Next",
			"last": "Last",
			"page": "Page {{page}}"
		},
		"empty": {
			"title": "No products",
			"subtitle": "No products found.",
			"filteredTitle": "No matches",
			"filteredSubtitle": "No products match the current filters.",
			"clearFilters": "Clear filters"
		},
		"error": {
			"title": "Something went wrong",
			"subtitle": "Could not load products."
		},
		"type": {
			"book": "Book",
			"toy": "Toy"
		},
		"availability": {
			"0": "Available (warehouse)",
			"1": "Available",
			"2": "Limited",
			"3": "Exhausted",
			"4": "Pre-order",
			"5": "After order"
		},
		"deleteDialog": {
			"title": "Delete product",
			"body": "Are you sure you want to delete \"{{name}}\"?",
			"confirm": "Delete"
		},
		"toasts": {
			"deleted": "Product deleted",
			"duplicated": "Product duplicated",
			"quickEditSaved": "Changes saved",
			"actionFailed": "Action failed",
			"erpSyncDone": "ERP sync completed",
			"comingSoon": "Coming soon"
		},
		"states": {
			"meta": "{{active}} of {{total}} active",
			"banner": "States appear as storefront badges (NEW, BEST SELLER, etc.). Toggle on the ones that apply to this product.",
			"empty": "No states available.",
			"loadError": "Failed to load states."
		},
		"relations": {
			"tabMeta": "{{count}} relations",
			"productCount": "{{count}} products",
			"banner": "Relations connect this product to others for storefront cross-sell and complementary suggestions.",
			"searchPlaceholder": "Search product by name or code…",
			"searchEmpty": "No products found.",
			"noTypes": "No relation types configured.",
			"loadError": "Failed to load relations."
		}
	},
	"orders": {
		"surface": {
			"title": "Order List"
		},
		"actions": {
			"export": "Export",
			"exportStubHint": "Coming soon — requires a server-side export endpoint",
			"newOrder": "New order"
		},
		"chips": {
			"label": "Saved",
			"todaysPending": "Today's pending",
			"boxNow": "BOX NOW",
			"failedPayment": "Failed payment",
			"couriered": "Couriered",
			"invoiceOrders": "Invoice orders",
			"saveCurrent": "Save current",
			"saveCurrentHint": "Coming soon"
		},
		"toolbar": {
			"searchPlaceholder": "Search by email, phone, UID, or order code…",
			"columns": "Columns"
		},
		"gridBar": {
			"showing": "Showing",
			"of": "of",
			"density": "Density",
			"comfortable": "Comfortable",
			"compact": "Compact"
		},
		"grid": {
			"purchasedAt": "Placed {{when}}",
			"unknownPayment": "Unknown method",
			"guestYes": "Guest",
			"guestNo": "Registered",
			"columns": {
				"order": "Order",
				"date": "Date",
				"customer": "Customer",
				"payment": "Payment",
				"shipping": "Shipping",
				"document": "Document",
				"quantity": "Qty",
				"total": "Total",
				"status": "Status",
				"id": "ID",
				"erpCode": "ERP code",
				"methodOfPurchase": "Method",
				"deliveryDate": "Delivery date",
				"guest": "Guest",
				"transactionId": "Transaction ID"
			},
			"rowMenu": {
				"label": "Actions",
				"open": "Open order",
				"copyUrl": "Copy URL",
				"cancel": "Cancel"
			}
		},
		"mop": {
			"0": "Online",
			"1": "Phone",
			"2": "App"
		},
		"columns": {
			"title": "Visible columns",
			"reset": "Reset columns"
		},
		"document": {
			"retail": "Retail",
			"invoice": "Invoice"
		},
		"onlinePayment": {
			"title": "Online payment",
			"provider": "Provider",
			"status": "Payment status",
			"transactionId": "Transaction ID",
			"transactionStatus": "Transaction status",
			"amount": "Amount",
			"date": "Date",
			"providerDetails": "Provider details",
			"empty": "No online payment information for this order.",
			"error": "Could not load the online payment information.",
			"xpay": {
				"orderId": "XPay order ID",
				"empty": "No XPay transactions recorded.",
				"success": "Success",
				"failed": "Failed",
				"authCode": "Auth code",
				"eventId": "Event",
				"rawRequest": "Request",
				"rawResponse": "Response",
				"rawPayload": "Notification payload",
				"kind": {
					"hpp": "Payment session (HPP)",
					"query": "Status check",
					"notification": "Notification (webhook)"
				}
			}
		},
		"payment": {
			"paid": "Paid",
			"pending": "Pending",
			"onDelivery": "On delivery",
			"cancelled": "Cancelled",
			"declined": "Declined",
			"failed": "Failed",
			"aborted": "Aborted",
			"timeout": "Timed out"
		},
		"status": {
			"pending": "Pending",
			"processing": "Processing",
			"inDelivery": "In delivery",
			"completed": "Completed",
			"partiallyDelivered": "Partially delivered",
			"notDelivered": "Not delivered",
			"checkingStock": "Checking stock",
			"refund": "Refund",
			"partiallyReturned": "Partially returned",
			"returned": "Returned",
			"invoiced": "Invoiced",
			"readyForPickup": "Ready for pickup",
			"cancelled": "Cancelled",
			"na": "N/A",
			"unknown": "—"
		},
		"filters": {
			"title": "Order filters",
			"subtitle": "Narrow down the table results.",
			"sections": {
				"identifier": "Search by identifier",
				"dates": "Dates"
			},
			"uid": "Order code or UID",
			"uidPlaceholder": "e.g. CVITG-3289221",
			"internalId": "Internal ID",
			"internalIdPlaceholder": "100, 101…",
			"barcode": "Barcode",
			"barcodePlaceholder": "Scan…",
			"tracking": "Tracking code",
			"trackingPlaceholder": "ACS / Box Now / Courier",
			"purchaseDate": "Purchase date",
			"deliveryDate": "Delivery date",
			"statuses": "Order status",
			"statusesPlaceholder": "Select statuses…",
			"receiptType": "Document type",
			"paymentMethod": "Payment method",
			"paymentMethodPlaceholder": "Any method",
			"shippingMethod": "Shipping method",
			"shippingMethodPlaceholder": "Any method",
			"customer": "Customer",
			"customerPlaceholder": "Name, email or phone…",
			"totalRange": "Total (€)",
			"quantityRange": "Quantity",
			"flags": "Flags",
			"flagIsPaid": "Is paid",
			"flagHasProcessing": "Has policies",
			"flagHasCoupon": "Has coupon",
			"flagHasGiftcard": "Has giftcard",
			"flagHasLoyalty": "Has loyalty",
			"flagIsDraft": "Is draft",
			"from": "From",
			"to": "To",
			"triAny": "Any",
			"apply": "Apply filters",
			"clear": "Clear all"
		},
		"pager": {
			"rowsPerPage": "Rows per page:",
			"first": "First",
			"prev": "Previous",
			"next": "Next",
			"last": "Last",
			"page": "Page {{page}}"
		},
		"empty": {
			"title": "No orders yet",
			"subtitle": "No orders found.",
			"filteredTitle": "No results",
			"filteredSubtitle": "No orders match these criteria.",
			"clearFilters": "Clear filters"
		},
		"error": {
			"title": "Something went wrong",
			"subtitle": "Could not load orders.",
			"useDemo": "View sample data"
		},
		"cancelDialog": {
			"title": "Cancel order",
			"body": "Are you sure you want to cancel order #{{uid}}?",
			"confirm": "Cancel order"
		},
		"toasts": {
			"urlCopied": "URL copied",
			"cancelComingSoon": "Order cancellation is coming soon",
			"comingSoon": "Coming soon",
			"actionFailed": "Action failed"
		},
		"create": {
			"title": "New order",
			"required": "Required",
			"optional": "Optional",
			"crumbs": {
				"orders": "Orders"
			},
			"nav": {
				"title": "Order steps",
				"customer": "Customer",
				"cart": "Cart",
				"address": "Addresses",
				"shipping": "Shipping",
				"payment": "Payment",
				"adjustments": "Adjustments",
				"notes": "Notes"
			},
			"customer": {
				"email": "Email",
				"guestLabel": "Guest",
				"created": "Customer created"
			},
			"cart": {
				"searchPlaceholder": "Search by SKU, barcode, or product name…",
				"product": "Product",
				"variation1": "Variation 1",
				"variation2": "Variation 2",
				"qty": "Qty",
				"unit": "Unit",
				"total": "Total",
				"sku": "SKU",
				"chooseVariation": "Choose",
				"priceModified": "Modified",
				"addLine": "Add line",
				"empty": "Cart is empty"
			},
			"address": {
				"title": "Addresses",
				"sameAddress": "Same billing & shipping address",
				"billing": "Billing address",
				"shipping": "Shipping address"
			},
			"shipping": {
				"title": "Shipping method",
				"recommended": "Recommended",
				"available": "Supported",
				"free": "Free",
				"evaluatedFor": "Delivery options evaluated for postcode",
				"enterPostcodeHint": "Enter the postcode to see shipping recommendations.",
				"none": "No shipping methods available.",
				"pickupPoint": "Pickup point",
				"chooseStore": "Choose store",
				"changeStore": "Change",
				"storePickerTitle": "Select Store",
				"storeSearchPlaceholder": "Search by store name or area…",
				"storeSelect": "Select",
				"storeSelected": "Selected",
				"storeSelectUseAddress": "Select & Use Address"
			},
			"payment": {
				"title": "Payment method"
			},
			"adjustments": {
				"title": "Discounts & coupons",
				"coupon": "Coupon",
				"couponPlaceholder": "Coupon code",
				"applied": "applied",
				"apply": "Apply",
				"giftCard": "Gift card",
				"giftCardHelp": "Enter the gift card code to redeem.",
				"giftCardPlaceholder": "Gift card code",
				"loyalty": "Loyalty points",
				"loyaltyGuestHelp": "Available for a registered customer (not a guest).",
				"loyaltyPlaceholder": "Points to redeem",
				"loyaltyBalance": "The customer has {{points}} points.",
				"loyaltyInactive": "Loyalty points are switched off.",
				"loyaltyRefused": "The checkout did not accept these points; pick again.",
				"loyaltyNone": "No points",
				"loyaltyNoOptions": "No options for this order",
				"loyaltyOption": "{{points}} points · −{{amount}}"
			},
			"notes": {
				"title": "Notes",
				"customerComments": "Customer comments",
				"customerPlaceholder": "Anything the customer said about this order…",
				"adminNotes": "Admin notes",
				"adminPlaceholder": "Notes for the fulfillment team, dispatch instructions, etc.",
				"communication": "Communication",
				"email": "Email",
				"phone": "Phone"
			},
			"summary": {
				"title": "Order summary",
				"customer": "Customer",
				"noCustomer": "No customer selected",
				"cart": "Cart",
				"itemCount": "{{count}} items",
				"emptyCart": "Empty cart",
				"recalculating": "Recalculating…"
			},
			"checklist": {
				"customer": "Customer set",
				"items": "At least 1 item",
				"address": "Valid addresses",
				"shipping": "Shipping method",
				"payment": "Payment method"
			},
			"actions": {
				"submit": "Create order",
				"saveAsDraft": "Save as draft",
				"created": "Order created successfully"
			},
			"validation": {
				"required": "Required field",
				"email": "Please enter a valid email",
				"cartEmpty": "Add at least one product",
				"variationRequired": "Choose a variation",
				"incomplete": "Complete all required fields",
				"impersonation": "Could not identify the customer/guest"
			}
		},
		"components": {
			"totals": {
				"quantity": "Quantity",
				"net": "Net amount",
				"vat": "VAT",
				"totalDiscount": "Total discount",
				"paymentSurcharge": "Payment surcharge",
				"shipping": "Shipping charge",
				"otherCharges": "Other charges",
				"finalTotal": "Final amount",
				"initialPaid": "Initial paid amount",
				"recalcNote": "Manual adjustments will not auto-recalculate."
			},
			"address": {
				"title": "Address title",
				"titlePlaceholder": "e.g. Home, Office",
				"firstName": "First name",
				"lastName": "Last name",
				"company": "Company",
				"vatNo": "VAT no.",
				"floorBell": "Floor / Bell",
				"addressLine": "Address",
				"city": "City",
				"postcode": "Postcode",
				"country": "Country",
				"region": "Region",
				"mobile": "Mobile",
				"phone": "Phone",
				"postcodeInvalid": "Postcode must be {{count}} digits",
				"copyToShipping": "Copy to shipping",
				"copyFromBilling": "Copy from billing"
			},
			"timeline": {
				"showAll": "Show all ({{count}})",
				"draftUnsaved": "Draft · Unsaved",
				"draftHint": "Will be saved when you click Save changes.",
				"discardDraft": "Discard draft",
				"type": {
					"status": "Status",
					"comment": "Comment",
					"notification": "Notification",
					"emailChange": "Email",
					"created": "Created",
					"draft": "Draft"
				}
			},
			"stock": {
				"available": "Available",
				"limited": "Limited",
				"outOfStock": "Out of stock"
			},
			"lines": {
				"product": "Product",
				"availability": "Availability",
				"flags": "Flags",
				"qty": "Qty",
				"unit": "Unit",
				"vat": "VAT",
				"discount": "Discount",
				"total": "Total",
				"sku": "SKU",
				"barcode": "Barcode",
				"gift": "Gift",
				"addLine": "Add line"
			},
			"lineSheet": {
				"lineOf": "Line {{index}} of {{total}}",
				"prev": "Previous",
				"next": "Next",
				"product": "Product",
				"productMeta": "Read-only — to change the product, remove this line and add a new one",
				"catalogPrice": "Catalog price",
				"stock": "Stock",
				"category": "Category",
				"pricing": "Pricing",
				"quantity": "Quantity",
				"unitPrice": "Unit price (€)",
				"override": "Override",
				"catalogHint": "Catalog: {{price}}",
				"vatRate": "VAT rate",
				"discount": "Discount",
				"discountAmount": "Amount (€)",
				"flags": "Flags",
				"markAsGift": "Mark as gift",
				"markAsGiftHelp": "Hides price on packing slip and adds gift wrap.",
				"comment": "Line comment",
				"commentMeta": "Appears on packing slip",
				"commentPlaceholder": "e.g. With a Happy Birthday card…",
				"previewMeta": "Updates as you type",
				"lineTotal": "Line total",
				"previewNet": "{{qty}} × {{unit}} (net)",
				"previewVat": "VAT ({{pct}})",
				"previewDiscount": "Discount",
				"removeLine": "Remove line",
				"apply": "Apply"
			},
			"productPicker": {
				"title": "Add product",
				"searchPlaceholder": "Search by SKU, barcode, or product name…",
				"startTyping": "Start typing to search products",
				"add": "Add",
				"increase": "Increase quantity",
				"decrease": "Decrease quantity"
			},
			"customerPicker": {
				"guestToggle": "Continue as guest",
				"searchPlaceholder": "Search by name, email, phone, or ERP code…",
				"localGroup": "{{count}} local customers",
				"local": "Local",
				"orders": "{{count}} orders",
				"createNamed": "Create new customer \"{{name}}\"",
				"createTitle": "Create new customer",
				"createHint": "Minimal info for this order. Full customer profile can be enriched later.",
				"firstName": "First name",
				"lastName": "Last name",
				"email": "Email",
				"taxCategory": "Tax category",
				"taxRetail": "Retail",
				"taxInvoice": "Invoice",
				"mobile": "Mobile",
				"phone": "Phone (optional)",
				"useCustomer": "Use this customer",
				"statOrders": "Orders",
				"statSpend": "Lifetime spend",
				"statLastOrder": "Last order"
			}
		},
		"detail": {
			"header": {
				"title": "Order",
				"backToList": "Back to list",
				"guest": "Guest",
				"channelGuest": "Guest checkout",
				"channelAccount": "Account"
			},
			"actions": {
				"syncErp": "Sync with ERP",
				"print": "Print",
				"notify": "Notify customer",
				"changeEmail": "Change email",
				"send": "Send order",
				"save": "Save changes"
			},
			"lines": {
				"title": "Order lines",
				"itemCount": "{{count}} items"
			},
			"totals": {
				"title": "Totals",
				"recalculate": "Calculate"
			},
			"info": {
				"title": "Order information",
				"savesWithPage": "Edits save with the page Save button",
				"purchaseDate": "Purchase date",
				"documentType": "Document type",
				"docRetail": "Retail",
				"docInvoice": "Invoice",
				"currency": "Currency",
				"language": "Language",
				"totalWeight": "Total weight",
				"erpCode": "ERP sync code",
				"paymentWallet": "Paid with",
				"paymentMethod": "Payment method",
				"shippingMethod": "Shipping method",
				"courier": "Courier",
				"communicationType": "Communication type",
				"contactMethod_0": "Email",
				"contactMethod_1": "Mobile",
				"shippingDate": "Shipping date",
				"trackingNumber": "Tracking number",
				"notSet": "Not set",
				"newsletter": "Newsletter signup",
				"promo": "Promotional actions",
				"personalizedMessages": "Personalized messages",
				"isGift": "Is a gift"
			},
			"erpSyncLog": {
				"button": "ERP Sync Log",
				"title": "ERP Sync Log",
				"subtitle": "Every ERP sync attempt for this order (request + response), newest first.",
				"success": "Success",
				"failed": "Failed",
				"edit": "Edit",
				"receiptNo": "Receipt No",
				"returnValue": "Return value",
				"error": "Error",
				"request": "Request",
				"response": "Response",
				"loading": "Loading ERP sync log...",
				"noData": "No ERP sync attempts recorded for this order."
			},
			"comments": {
				"customerTitle": "Customer comments",
				"customerMeta": "Visible to customer",
				"customerPlaceholder": "Customer's comment on this order, if any…",
				"adminTitle": "Admin notes",
				"adminMeta": "Internal only",
				"adminPlaceholder": "Notes for the team — never visible to the customer…"
			},
			"address": {
				"billing": "Billing address",
				"shipping": "Shipping address"
			},
			"customer": {
				"title": "Customer",
				"orders": "Orders",
				"lifetimeSpend": "Lifetime spend",
				"lastOrder": "Last order"
			},
			"status": {
				"title": "Order status",
				"placeholder": "Status…",
				"subStatusPlaceholder": "Sub-status…",
				"recentActivity": "Recent activity",
				"viewFullHistory": "View full history"
			},
			"history": {
				"title": "Order history",
				"eventCount": "{{count}} events",
				"commentPlaceholder": "Add a comment to this order's history…",
				"addToHistory": "Add to history",
				"empty": "No history yet."
			},
			"notify": {
				"placeholder": "Message to send to the customer…",
				"send": "Send"
			},
			"toasts": {
				"sent": "Order sent.",
				"notified": "Customer notified.",
				"emailChanged": "Email updated.",
				"erpSynced": "Synced to ERP.",
				"historyAdded": "Added to history.",
				"recalculated": "Totals recalculated."
			}
		},
		"orderStates": {
			"title": "Internal Statuses",
			"add": "New status",
			"addTitle": "New internal status",
			"editTitle": "Edit internal status",
			"formSubtitle": "Fill in the internal order status details.",
			"deleteTitle": "Delete status",
			"deleteBody": "Delete the status “{{name}}”? This action cannot be undone.",
			"columns": {
				"code": "Code",
				"name": "Name",
				"erpCode": "ERP code",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"paymentTypes": {
			"title": "Payment Methods",
			"add": "New payment method",
			"untitled": "New payment method",
			"notFound": "Payment method not found.",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete payment method",
			"deleteBody": "Delete the payment method “{{name}}”? This action cannot be undone.",
			"erpCode2": "ERP code (2)",
			"anyCountry": "All countries",
			"anyRegion": "All regions",
			"customerGroups": "Customer profiles",
			"allCustomerGroups": "All profiles",
			"excludedCustomerGroups": "Excluded customer profiles",
			"noExcludedCustomerGroups": "No exclusions",
			"minWeight": "Min weight",
			"maxWeight": "Max weight",
			"installmentsLogic": "Installments logic",
			"installmentsHelp": "e.g. 90:3,180:6 (from €90 up to 3 installments, from €180 up to 6). Must be supported by your bank.",
			"thresholdHelp": "Basket value threshold above which the charge applies.",
			"supportStoredCards": "Support stored cards",
			"allowEditOrder": "Allow order editing",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"descriptionPlaceholder": "Description text…",
			"tabs": {
				"general": "General",
				"rules": "Rules & Charges",
				"content": "Body",
				"image": "Image"
			},
			"columns": {
				"image": "Image",
				"name": "Name",
				"onlineType": "Online payment",
				"country": "Country",
				"countries": "Available Countries",
				"region": "Region",
				"regions": "Available Regions",
				"code": "Code",
				"erpCode": "ERP code",
				"flatRate": "Flat rate",
				"threshold": "Basket threshold",
				"minPrice": "Min basket price",
				"maxPrice": "Max basket price",
				"retailOnly": "Receipt only",
				"invoiceOnly": "Invoice only",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"takeawayStores": {
			"title": "Pickup Points",
			"add": "New pickup point",
			"untitled": "New pickup point",
			"notFound": "Pickup point not found.",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete pickup point",
			"deleteBody": "Delete the pickup point “{{name}}”? This action cannot be undone.",
			"selectCountry": "Select a country…",
			"anyRegion": "All regions",
			"manager": "Store manager",
			"email": "Email",
			"telephone": "Telephone",
			"transitDays": "Transit days",
			"flatRate": "Flat rate",
			"threshold": "Basket threshold",
			"erpCode": "ERP code",
			"addressLine": "Address",
			"addressLine2": "Address (2)",
			"area": "Area",
			"city": "City",
			"postalCode": "Postal code",
			"latitude": "Latitude",
			"longitude": "Longitude",
			"openHourStart": "Opening hour",
			"openHourEnd": "Closing hour",
			"workHours": "Working hours",
			"workHoursPlaceholder": "Working hours…",
			"descriptionPlaceholder": "Description text…",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"tabs": {
				"general": "General",
				"address": "Address",
				"hours": "Hours",
				"content": "Body",
				"images": "Images"
			},
			"columns": {
				"image": "Image",
				"name": "Name",
				"country": "Country",
				"region": "Region",
				"address": "Address",
				"email": "Email",
				"visible": "Visible",
				"sort": "Sort"
			},
			"warehouseCode": "Warehouse code",
			"warehouseCodeHelp": "Code of the warehouse that holds this store’s stock (must match the warehouse code exactly); used by the in-stock filter."
		},
		"skroutz": {
			"title": "Skroutz Orders",
			"searchPlaceholder": "Search by name, email, phone or code…",
			"searchId": "Search by ID",
			"searchIdPlaceholder": "ID, e.g. 100,101,500",
			"noLink": "No link available for this order.",
			"linkError": "Failed to fetch the Skroutz order.",
			"columns": {
				"code": "Skroutz code",
				"purchaseDate": "Purchase date",
				"firstName": "First name",
				"lastName": "Last name",
				"email": "E-mail",
				"phone": "Phone",
				"status": "Skroutz status",
				"total": "Grand total",
				"quantity": "Qty"
			},
			"actions": {
				"details": "Order details",
				"showOnSkroutz": "Show on Skroutz",
				"printVoucher": "Print voucher"
			}
		},
		"shippingTypes": {
			"title": "Shipping Methods",
			"add": "New shipping method",
			"untitled": "New shipping method",
			"notFound": "Shipping method not found.",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete shipping method",
			"deleteBody": "Delete the shipping method “{{name}}”? This action cannot be undone.",
			"anyCountry": "All countries",
			"anyRegion": "All regions",
			"customerGroups": "Customer profiles",
			"allCustomerGroups": "All profiles",
			"excludedCustomerGroups": "Excluded customer profiles",
			"noExcludedCustomerGroups": "No exclusions",
			"erpCode2": "ERP code (2)",
			"activeMaxCartPrice": "Active max cart price",
			"activeMaxCartPriceHelp": "The method becomes unavailable once the cart products total (after discounts) reaches this amount. Empty = no limit.",
			"trackingUrlTemplate": "Tracking URL template",
			"trackingUrlTemplateHelp": "Handlebars template that must produce an absolute http(s) link, e.g. https://courier.example/track/{{variable}}. Also available: OrderUid, ShippingTypeCode, ShippingTypeName. Empty = no link.",
			"storeTakeAway": "Store pickup",
			"contactlessDelivery": "Contactless delivery",
			"courierDelivery": "Courier delivery",
			"transportCourier": "Transport / courier",
			"minWeight": "Min weight",
			"maxWeight": "Max weight",
			"maxLength": "Max length",
			"maxWidth": "Max width",
			"maxHeight": "Max height",
			"maxVolWeight": "Max volumetric weight",
			"maxWeightPerProduct": "Max weight per product",
			"savePayments": "Save payment methods",
			"saveFirst": "Save the shipping method first to manage this section.",
			"descriptionPlaceholder": "Description text…",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"tabs": {
				"general": "General",
				"delivery": "Delivery",
				"constraints": "Constraints",
				"charges": "Charges",
				"payments": "Payment methods",
				"postal": "Postal codes",
				"content": "Body",
				"image": "Image"
			},
			"columns": {
				"image": "Image",
				"name": "Name",
				"country": "Country",
				"countries": "Available Countries",
				"region": "Region",
				"regions": "Available Regions",
				"code": "Code",
				"erpCode": "ERP code",
				"flatRate": "Flat rate",
				"threshold": "Basket threshold",
				"storeTakeAway": "Pickup",
				"default": "Default",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"shippingCharges": {
			"add": "New charge",
			"addTitle": "New shipping charge",
			"editTitle": "Edit shipping charge",
			"formSubtitle": "Define the scope, the charge and the price / weight / volume conditions.",
			"deleteTitle": "Delete charge",
			"deleteBody": "Delete this charge? This action cannot be undone.",
			"empty": "No charges yet.",
			"scope": "Scope",
			"allDestinations": "All destinations",
			"classification": "Country classification",
			"country": "Country",
			"region": "Region",
			"postalCode": "Postal code",
			"flatRate": "Flat rate",
			"percentageOrder": "Order percentage (%)",
			"combineOperator": "Combine operator",
			"sort": "Sort",
			"chargePerPiece": "Charge per piece",
			"priceGroup": "Price condition",
			"weightGroup": "Weight condition",
			"volumeGroup": "Volume condition",
			"operator": "Operator",
			"from": "From",
			"to": "To",
			"step": "Step",
			"stepRate": "Step rate",
			"any": "— Any —"
		},
		"shippingPostal": {
			"add": "Add",
			"addAll": "Add all",
			"removeAll": "Remove all",
			"removeAllTitle": "Remove all postal codes",
			"removeAllBody": "Remove all postal codes from this shipping method?",
			"pickPlaceholder": "Search postal code…",
			"empty": "No postal codes assigned.",
			"code": "Code",
			"area": "Area",
			"city": "City"
		},
		"filtered": {
			"title": "Filtered Orders",
			"searchPlaceholder": "Search by code, customer, email or phone…",
			"details": "Order details",
			"columns": {
				"code": "Code",
				"purchaseDate": "Purchase date",
				"deliveryDate": "Delivery date",
				"customer": "Customer",
				"quantity": "Qty",
				"total": "Total",
				"shipping": "Shipping",
				"status": "Status",
				"salesPersons": "Sales persons"
			}
		},
		"returns": {
			"title": "Returns & replacements",
			"moduleDisabled": "The returns module is not enabled for this store.",
			"loadFailed": "Loading failed",
			"request": "Return request",
			"requestSubtitle": "Everything the customer submitted is read-only. The platform records — it never moves money and never sends replacements.",
			"piece": "Piece",
			"show": "Show",
			"hide": "Hide",
			"deliveryAddress": "Delivery address",
			"returnMethod": "Return method",
			"carrierReference": "Carrier reference",
			"columns": {
				"id": "Id",
				"order": "Order",
				"customer": "Customer",
				"product": "Product",
				"piece": "Piece #",
				"unitValue": "Piece value",
				"reason": "Return reason",
				"desiredAction": "Customer wish",
				"paymentMethod": "Payment method",
				"deliveryMethod": "Delivery method",
				"refundExecutedAt": "Refund executed",
				"submittedAt": "Submitted",
				"status": "Status"
			},
			"toolbar": {
				"columns": "Columns",
				"resetColumns": "Reset columns",
				"export": "Export"
			},
			"actions": {
				"open": "Open request"
			},
			"status": {
				"new": "New request",
				"underReview": "Under review",
				"approved": "Approved",
				"awaitingProduct": "Awaiting product",
				"inProgress": "In progress",
				"completed": "Completed",
				"rejected": "Rejected",
				"unknown": "—"
			},
			"reason": {
				"none": "Not declared",
				"changedMind": "Withdrawal",
				"poorCondition": "Poor condition",
				"defective": "Defective",
				"wrongProduct": "Wrong product",
				"missingPart": "Missing part",
				"fewerPieces": "Fewer pieces",
				"morePieces": "More pieces",
				"wrongColour": "Wrong colour",
				"wrongSize": "Wrong size"
			},
			"action": {
				"none": "Not declared",
				"refund": "Refund",
				"replacement": "Replacement",
				"credit": "Credit"
			},
			"refundMethod": {
				"notExecuted": "Not executed",
				"bankTransfer": "Bank transfer",
				"providerReversal": "Payment provider reversal",
				"originalInstrument": "Original payment instrument",
				"cashInStore": "Cash in store",
				"coupon": "Coupon"
			},
			"method": {
				"courierPickup": "Courier pickup",
				"lockerDropOff": "Locker drop-off",
				"freightCarrier": "Freight carrier"
			},
			"queue": {
				"approvedUnpaid": "Approved & unpaid"
			},
			"settlement": {
				"pending": "Pending",
				"done": "Done"
			},
			"filters": {
				"orderUid": "Order code",
				"customer": "Customer",
				"customerHint": "Name, email, phone or VAT number",
				"product": "Product",
				"productHint": "Title, code or barcode",
				"workQueue": "Work queue",
				"workQueueHint": "Pins the status and the wish on its own",
				"statuses": "Statuses",
				"defaultOpen": "Open requests",
				"desiredAction": "Customer wish",
				"refundExecution": "Refund execution",
				"submittedFrom": "Submitted from",
				"submittedTo": "Submitted to",
				"any": "Any",
				"clear": "Clear filters"
			},
			"gate": {
				"refundExecutionRequired": "the refund has to be recorded first",
				"replacementDispatchRequired": "the replacement dispatch has to be recorded first"
			},
			"statusChange": {
				"title": "Change status",
				"current": "Current status",
				"pickTarget": "Pick a new status",
				"terminal": "This piece is in a final status and cannot be moved further.",
				"confirm": "Confirm change"
			},
			"bulk": {
				"title": "Bulk status change",
				"subtitle_one": "{{count}} selected piece moves on its own. The change is applied to it or to nothing.",
				"subtitle_other": "{{count}} selected pieces move together. The change is applied to all of them or to none.",
				"selected_one": "{{count}} selected",
				"selected_other": "{{count}} selected",
				"changeStatus": "Change status",
				"clear": "Clear",
				"selectAll": "Select every piece on this page",
				"selectRow": "Select this piece",
				"noTargets": "No status can take the whole selection. Narrow it down or work the pieces one by one.",
				"apply_one": "Move {{count}} piece",
				"apply_other": "Move {{count}} pieces",
				"applied_one": "{{count}} piece moved",
				"applied_other": "{{count}} pieces moved",
				"blocked": {
					"count": "{{blocked}} of {{count}} cannot",
					"settled": "already paid or dispatched, so they cannot be rejected",
					"illegal": "not reachable from their current status"
				}
			},
			"checklist": {
				"title": "To close this request",
				"allClear": "Every record is in place — the open pieces can be marked as completed.",
				"refundPending": "Piece #{{piece}} ({{product}}): execute the refund and record it",
				"couponPending": "Piece #{{piece}} ({{product}}): create the coupon by hand and record it as the settlement",
				"dispatchPending": "Piece #{{piece}} ({{product}}): record the replacement dispatch",
				"basketDispatchPending_one": "Record the dispatch of {{count}} replacement item in the basket",
				"basketDispatchPending_other": "Record the dispatch of {{count}} replacement items in the basket",
				"remainderPending": "Return the unspent leftover of {{amount}} to the customer — coupon or refund, by hand"
			},
			"discard": {
				"title": "Discard unsaved changes?",
				"body_one": "{{count}} piece carries unsaved changes. Closing now discards them.",
				"body_other": "{{count}} pieces carry unsaved changes. Closing now discards them.",
				"keep": "Keep editing",
				"discard": "Discard changes"
			},
			"sections": {
				"request": "Request details",
				"refundBankDetails": "Bank details for the refund",
				"refundBankDetailsHint": "The account the customer supplied. Each piece carries its own settlement record.",
				"replacementBasket": "Replacement basket"
			},
			"refund": {
				"iban": "IBAN",
				"beneficiary": "Beneficiary",
				"bank": "Bank",
				"method": "Refund method",
				"amount": "Amount",
				"amountMax": "Up to {{max}}",
				"transactionReference": "Transaction reference",
				"executedAt": "Executed on",
				"executedAtHint": "When the money actually left",
				"recordedBy": "Execution recorded by"
			},
			"item": {
				"submissionDetails": "Submission details",
				"edited": "Unsaved changes",
				"refundRecordTitle": "Refund settlement record",
				"couponRecordTitle": "Coupon settlement record",
				"replacementBlockTitle": "Replacement & dispatch",
				"unitValue": "Piece value",
				"reason": "Return reason",
				"lastStatusChange": "Last status change",
				"customerComment": "Customer comment",
				"photos": "Photos",
				"status": "Status",
				"statusHelp": "Only the allowed next statuses, as the server returns them",
				"statusUnchanged": "Unchanged",
				"desiredAction": "Customer wish",
				"policyNoRefund": "not supported by the returns policy",
				"creditDisabled": "credit is not enabled",
				"manualCoupon": "Manual action: create a coupon for this piece's value and record it below as the settlement. The platform does not create coupons automatically.",
				"targetInBasket": "The requested items and their dispatch live on the replacement basket above — this request came from the customer, whose wallet is pooled across pieces.",
				"replacementProduct": "Replacement product",
				"pickReplacementProduct": "Pick a product",
				"replacementVariant": "Replacement variant",
				"noVariant": "No variant",
				"variantUnavailable": "{{variant}} — no longer available",
				"replacementSearchHint": "Type at least 2 characters to search for a product",
				"dispatchedAt": "Replacement dispatched on",
				"dispatchedAtHelp": "Records a dispatch that has already happened",
				"dispatchReference": "Dispatch reference",
				"dispatchRecordedBy": "Dispatch recorded by",
				"adminNotes": "Administrator notes",
				"settlementIncomplete": "Incomplete record: the method, the amount and the execution date are all needed before it can be saved.",
				"amountOutOfRange": "The amount has to be greater than zero and no more than this piece's value.",
				"recordsNeedOpenApproval": "Approve the item first: a refund or dispatch is recorded only on an approved item that is still open.",
				"dispatchIncomplete": "Incomplete record: the dispatch date is needed before it can be saved."
			},
			"delete": {
				"title": "Delete return request",
				"body": "Delete this request? Allowed only while every piece is still \"New request\"."
			},
			"policy": {
				"tabMeta": "Saved separately from the product",
				"saved": "The returns policy was saved",
				"saveEntityFirst": "Save the record first to set a returns policy.",
				"notDeclared": "Not declared",
				"allowed": "Allowed",
				"blocked": "Blocked",
				"flagsTitle": "Return restrictions",
				"flagsSubtitle": "Tri-state: \"Not declared\" leaves the category policy in charge.",
				"noReturns": "Returns not supported",
				"noReturnsHint": "Blocks every request for the item",
				"noWithdrawal": "Withdrawal not supported",
				"noWithdrawalHint": "Blocks the \"Withdrawal\" reason",
				"noRefund": "Refund not supported",
				"noRefundHint": "Blocks refund and credit",
				"blockedMethods": "Blocked return methods",
				"blockedMethodsHint": "Switch on any method that is not allowed for the item."
			},
			"toasts": {
				"saved": "Changes saved",
				"deleted": "The request was deleted",
				"statusChanged": "Status changed",
				"recordIncomplete": "Nothing was saved — complete or clear the incomplete records marked on the pieces first.",
				"photoFailed": "The photo could not be opened",
				"exportTruncated": "Exported {{exported}} of {{total}} rows — narrow the filters for a complete export."
			},
			"basket": {
				"wallet": "Value being returned",
				"charge": "Value requested",
				"remainder": "Leftover",
				"remainderAction": "Manual action: {{amount}} is left over. Return it to the customer as a coupon or a refund — the platform issues neither automatically.",
				"overdrawn": "The basket asks for {{amount}} more than the value being returned. Recheck the pieces' wishes — a piece moved off \"Replacement\" shrinks the wallet without rechecking the basket.",
				"pendingDispatch_one": "{{count}} item not dispatched yet. A replacement piece cannot be completed until every line is recorded.",
				"pendingDispatch_other": "{{count}} items not dispatched yet. A replacement piece cannot be completed until every line is recorded.",
				"sameItem": "the same item again, counted at the value paid",
				"dispatched": "Dispatched",
				"notDispatched": "Not dispatched",
				"dispatchedAt": "Dispatched on",
				"recordDispatch": "Record dispatch",
				"showLines": "Show items ({{count}})",
				"hideLines": "Hide items"
			},
			"settings": {
				"title": "Returns Settings",
				"subtitle": "Every configurable variable of the returns module. A variable with no stored value uses the default shown.",
				"usingDefault": "Not set — the default applies",
				"defaultHint": "Default: {{value}}. Clear the field to restore it.",
				"reset": "Reset to default",
				"resetTitle": "Reset to default",
				"resetBody": "Remove the stored value of {{name}}? The default ({{value}}) applies again.",
				"resetNotStored": "{{name}} has no stored value — it is already running on its default, so there is nothing to reset.",
				"resetDone": "{{name}} restored to its default",
				"columns": {
					"name": "Variable name",
					"value": "Variable value",
					"description": "Variable description",
					"defaultValue": "Default",
					"kind": "Type",
					"scope": "Scope"
				},
				"kind": {
					"boolean": "Yes / No",
					"integer": "Number",
					"stringList": "Text list",
					"integerList": "Number list",
					"windowAnchor": "Window anchor",
					"methodFlags": "Return methods"
				},
				"scope": {
					"unset": "Not set",
					"allSites": "All sites",
					"thisSite": "This site"
				}
			}
		}
	},
	"system": {
		"languages": {
			"title": "Languages",
			"count": "{{count}} languages",
			"add": "New language",
			"addTitle": "New language",
			"editTitle": "Edit language",
			"deleteTitle": "Delete language",
			"deleteBody": "Delete language “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"localName": "Local Name",
				"iso2": "ISO-2 Code",
				"culture": "Culture Code",
				"visible": "Visible",
				"sort": "Order"
			},
			"formSubtitle": "Fill in the language details."
		},
		"countries": {
			"title": "Countries",
			"count": "{{count}} countries",
			"add": "New country",
			"addTitle": "New country",
			"editTitle": "Edit country",
			"formSubtitle": "Fill in the country details.",
			"classificationPlaceholder": "Select classification",
			"deleteTitle": "Delete country",
			"deleteBody": "Delete country “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"iso2": "ISO-2 Code",
				"classification": "Classification",
				"visible": "Visible",
				"sort": "Order"
			},
			"pagination": {
				"showing": "{{from}}–{{to}} of {{total}}"
			}
		},
		"users": {
			"title": "Users",
			"count": "{{count}} users",
			"add": "New user",
			"addTitle": "New user",
			"editTitle": "Edit user",
			"formSubtitle": "Fill in the user details.",
			"rolePlaceholder": "Select role",
			"password": "Password",
			"passwordEdit": "New password",
			"passwordKeep": "Leave blank to keep current",
			"deleteTitle": "Delete user",
			"deleteBody": "Delete user “{{name}}”? This cannot be undone.",
			"columns": {
				"role": "Role",
				"email": "Email",
				"firstName": "First name",
				"lastName": "Last name",
				"visible": "Visible",
				"sort": "Order"
			},
			"pagination": {
				"showing": "{{from}}–{{to}} of {{total}}"
			}
		},
		"settings": {
			"title": "Settings",
			"count": "{{count}} settings",
			"add": "New setting",
			"addTitle": "New setting",
			"editTitle": "Edit setting",
			"formSubtitle": "Fill in the setting details.",
			"baseSite": "Base (all sites)",
			"deleteTitle": "Delete setting",
			"deleteBody": "Delete setting “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Parameter",
				"value": "Value",
				"site": "Site"
			},
			"pagination": {
				"showing": "{{from}}–{{to}} of {{total}}"
			}
		},
		"grid": {
			"showing": "Showing",
			"of": "of",
			"columns": "Columns",
			"columnsTitle": "Visible columns",
			"columnsReset": "Reset columns",
			"export": "Export to Excel",
			"rowsPerPage": "Rows per page",
			"comfortable": "Comfortable",
			"compact": "Compact",
			"first": "First page",
			"prev": "Previous",
			"next": "Next",
			"last": "Last page"
		},
		"countryRegions": {
			"title": "Regions",
			"add": "New region",
			"addTitle": "New region",
			"editTitle": "Edit region",
			"formSubtitle": "Fill in the region details.",
			"countryPlaceholder": "Select country",
			"deleteTitle": "Delete region",
			"deleteBody": "Delete region “{{name}}”? This cannot be undone.",
			"columns": {
				"country": "Country",
				"name": "Name",
				"code": "Code",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"cities": {
			"title": "Cities",
			"add": "New city",
			"addTitle": "New city",
			"editTitle": "Edit city",
			"formSubtitle": "Fill in the city details.",
			"regionPlaceholder": "Select region",
			"deleteTitle": "Delete city",
			"deleteBody": "Delete city “{{name}}”? This cannot be undone.",
			"columns": {
				"region": "Region",
				"name": "Name",
				"code": "Code",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"systemLog": {
			"title": "System Log",
			"columns": {
				"date": "Date",
				"level": "Level",
				"module": "Module",
				"message": "Message",
				"raw": "Raw Data"
			}
		},
		"erpLogs": {
			"title": "ERP Errors",
			"columns": {
				"date": "Date",
				"severity": "Severity",
				"service": "Service",
				"host": "Host",
				"task": "Task",
				"message": "Message",
				"trace": "Trace ID"
			},
			"viewDetail": "View details",
			"detail": {
				"title": "ERP error detail",
				"copy": "Copy message",
				"copied": "Copied"
			}
		},
		"activityLog": {
			"title": "Activity Log",
			"columns": {
				"when": "When",
				"actorRole": "User / Role",
				"role": "Role",
				"action": "Action",
				"entity": "Record",
				"changedFields": "Changed fields",
				"permissions": "Role permissions",
				"ip": "IP Address",
				"endpoint": "Endpoint"
			},
			"filters": {
				"period": "Period",
				"last1": "24 hours",
				"last7": "7 days",
				"last30": "30 days",
				"action": "Action",
				"allActions": "All actions",
				"role": "Role",
				"allRoles": "All roles"
			},
			"actions": {
				"insert": "Create",
				"update": "Modify",
				"delete": "Delete",
				"restore": "Restore",
				"login": "Login",
				"logout": "Logout",
				"loginFailed": "Failed login",
				"impersonationStart": "Impersonation started"
			},
			"actorKinds": {
				"system": "System",
				"customer": "Customer",
				"customerEmployee": "Customer employee",
				"salesPerson": "Sales person",
				"apiKey": "API key"
			},
			"changedFields": {
				"title": "Changed fields",
				"open": "Show all changed fields"
			},
			"permissionsCount_one": "{{count}} permission",
			"permissionsCount_other": "{{count}} permissions"
		},
		"robotsFile": {
			"title": "robots.txt",
			"subtitle": "Served as plain text to search engine crawlers; also used to filter the sitemap.",
			"notManaged": "This is the robots.txt currently served by the storefront and has not been saved here yet. Save it to start managing it from the admin.",
			"notManagedPill": "Not saved yet",
			"size": "{{kb}} KB of {{maxKb}} KB",
			"lastModified": "Last saved {{date}}",
			"propagationHint": "The storefront picks up changes within about 5 minutes.",
			"saved": "robots.txt saved",
			"loadFailed": "Failed to load robots.txt",
			"noAccess": "You do not have access to this page.",
			"errors": {
				"empty": "The content cannot be empty",
				"tooLarge": "The content exceeds the maximum allowed size"
			}
		},
		"sitemapPages": {
			"title": "Sitemap Pages",
			"add": "New page",
			"addTitle": "New sitemap page",
			"editTitle": "Edit sitemap page",
			"formSubtitle": "Fill in the page details.",
			"deleteTitle": "Delete page",
			"deleteBody": "Delete page “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"url": "Navigate URL"
			}
		},
		"urlRedirects": {
			"title": "301 Redirects",
			"add": "New redirect",
			"addTitle": "New redirect",
			"editTitle": "Edit redirect",
			"formSubtitle": "Enter the source and destination URLs.",
			"deleteTitle": "Delete redirect",
			"deleteBody": "Delete redirect “{{name}}”? This cannot be undone.",
			"columns": {
				"from": "From",
				"to": "To",
				"modified": "Modified"
			}
		},
		"smsTemplates": {
			"title": "SMS Templates",
			"add": "New template",
			"addTitle": "New SMS template",
			"editTitle": "Edit SMS template",
			"formSubtitle": "Fill in the template details.",
			"channelSms": "SMS",
			"channelViber": "Viber",
			"viberImageUrl": "Viber Image URL",
			"viberActionUrl": "Viber Action URL",
			"viberActionText": "Viber Action Text",
			"deleteTitle": "Delete template",
			"deleteBody": "Delete template “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"channel": "Channel",
				"body": "Body",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"taxOffices": {
			"title": "Tax Offices",
			"add": "New tax office",
			"addTitle": "New tax office",
			"editTitle": "Edit tax office",
			"formSubtitle": "Fill in the tax office details.",
			"noCountry": "— None —",
			"deleteTitle": "Delete tax office",
			"deleteBody": "Delete tax office “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"country": "Country",
				"description": "Description",
				"address": "Address",
				"city": "City",
				"postalCode": "Postal Code",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"userRoles": {
			"title": "User Roles",
			"add": "New role",
			"addTitle": "New role",
			"editTitle": "Edit role",
			"formSubtitle": "Fill in the role details and permissions.",
			"permissions": "Permissions",
			"permissionCount": "{{count}} / {{total}} permissions",
			"deleteTitle": "Delete role",
			"deleteBody": "Delete role “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"permissions": "Permissions",
				"visible": "Visible",
				"sort": "Order"
			},
			"perms": {
				"perm_dashboard": "Dashboard",
				"perm_clg": "Catalog",
				"perm_prc": "Pricing",
				"perm_cust": "Customers",
				"perm_ord": "Orders",
				"perm_oe": "Order Entry",
				"perm_oa": "Order Approval",
				"perm_prompol": "Promotion Policies",
				"perm_cms": "Content (CMS)",
				"perm_rep": "Reports",
				"perm_bookings": "Bookings",
				"perm_sys": "System"
			}
		},
		"postalCodes": {
			"title": "Postal Codes",
			"add": "New postal code",
			"addTitle": "New postal code",
			"editTitle": "Edit postal code",
			"formSubtitle": "Fill in the postal code details.",
			"none": "— None —",
			"deleteTitle": "Delete postal code",
			"deleteBody": "Delete postal code “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"country": "Country",
				"region": "Region",
				"area": "Area",
				"city": "City",
				"district": "District",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"eventSubscriptions": {
			"title": "Event Subscriptions",
			"editTitle": "Edit subscription",
			"formSubtitle": "Edit the notification email and status.",
			"active": "Active",
			"disabled": "Disabled",
			"deleteTitle": "Delete subscription",
			"deleteBody": "Delete subscription “{{name}}”? This cannot be undone.",
			"columns": {
				"type": "Type",
				"email": "Email",
				"payload": "Payload",
				"status": "Status",
				"disabled": "Disabled"
			}
		},
		"sites": {
			"title": "Sites",
			"add": "New site",
			"addTitle": "New site",
			"editTitle": "Edit site",
			"formSubtitle": "Edit the site details.",
			"deleteTitle": "Delete site",
			"deleteBody": "Delete site “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"name": "Name",
				"crawlState": "Crawl State",
				"defLanguage": "Def. Language",
				"defCurrency": "Def. Currency",
				"appendLanguagePrefix": "Lang Prefix",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"taskSchedules": {
			"title": "Task Schedules",
			"add": "New task",
			"addTitle": "New scheduled task",
			"editTitle": "Edit task",
			"formSubtitle": "Fill in the task details.",
			"noVerbosity": "— Default —",
			"errorEmail": "Error email",
			"run": "Run now",
			"runQueued": "Run queued.",
			"deleteTitle": "Delete task",
			"deleteBody": "Delete task “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"enabled": "Enabled",
				"interval": "Interval",
				"lastRun": "Last Run",
				"nextRun": "Next Run",
				"verbosity": "Log Level",
				"lastOutcome": "Last Outcome",
				"heartbeat": "Heartbeat"
			},
			"outcomeOk": "OK",
			"outcomeFailed": "Failed"
		},
		"aiPendingActions": {
			"title": "AI pending actions",
			"tabs": {
				"pending": "Pending ({{count}})",
				"all": "All ({{count}})"
			},
			"columns": {
				"id": "#",
				"tool": "Tool",
				"arguments": "Arguments",
				"requestedBy": "Requested by",
				"estimated": "Est. affected",
				"status": "Status",
				"requestedAt": "Requested at",
				"decidedBy": "Decided by",
				"decidedAt": "Decided at",
				"keyId": "Key"
			},
			"status": {
				"Pending": "Pending",
				"Executing": "Executing",
				"Executed": "Executed",
				"Rejected": "Rejected",
				"Failed": "Failed"
			},
			"details": "Details",
			"detailsTitle": "Action #{{id}}",
			"detailsMeta": "Requested by {{requestedBy}} at {{requestedAt}}",
			"detailsDecision": "Decided by {{decidedBy}} at {{decidedAt}}",
			"approve": "Approve",
			"approveTitle": "Approve action #{{id}}?",
			"approveBody": "\"{{tool}}\" will run immediately with the arguments below. Execution cannot be undone.",
			"approveConfirm": "Approve and run",
			"approvedToast": "Action approved and executed.",
			"executionFailedToast": "Action was approved but execution failed — check the history.",
			"reject": "Reject",
			"rejectTitle": "Reject action #{{id}}?",
			"rejectBody": "\"{{tool}}\" will never run.",
			"rejectedToast": "Action rejected — never executed.",
			"conflictToast": "Already handled by another operator."
		},
		"apiKeys": {
			"title": "API Keys",
			"add": "New key",
			"addTitle": "New API key",
			"editTitle": "Edit API key",
			"formSubtitle": "Set a name, description and the allowed endpoints.",
			"description": "Description",
			"endpoints": "Endpoints",
			"endpointsPlaceholder": "Select endpoints…",
			"endpointCount": "{{count}} endpoints",
			"generate": "Generate",
			"active": "Active",
			"revoked": "Revoked",
			"regenerate": "Regenerate key",
			"revoke": "Revoke",
			"revokedToast": "Key revoked.",
			"copy": "Copy",
			"copied": "Copied to clipboard.",
			"copyFailed": "Copy failed.",
			"secretTitle": "Secret key: {{name}}",
			"secretSubtitle": "Copy it now — it will not be shown again.",
			"secretWarning": "This is the only time the full key is shown. Store it securely.",
			"secretDone": "I have saved it",
			"revokeTitle": "Revoke API key",
			"revokeBody": "Revoke key “{{name}}”? It will stop working immediately.",
			"deleteTitle": "Delete API key",
			"deleteBody": "Delete key “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"key": "Key",
				"endpoints": "Endpoints",
				"lastUsed": "Last Used",
				"status": "Status"
			}
		},
		"mcpKeys": {
			"title": "MCP Keys",
			"add": "New key",
			"addTitle": "Mint MCP key",
			"editTitle": "Edit MCP key",
			"formSubtitle": "Bind a backing identity, pick tool grants and mint the one-time token.",
			"context": "Context",
			"contextAdmin": "Admin",
			"contextFrontEnd": "Storefront",
			"backingIdentity": "Backing identity",
			"backingHint": "The key can never exceed the backing account's permissions. Bind Admin keys to a dedicated least-privilege service user — never a personal account.",
			"backingUser": "Service user",
			"backingUserPlaceholder": "Select user…",
			"backingPickExisting": "Pick existing user",
			"backingCreateNew": "Create service user",
			"serviceUserEmail": "Email",
			"serviceUserPassword": "Password",
			"serviceUserFirstName": "First name",
			"serviceUserLastName": "Last name",
			"serviceUserRole": "Role",
			"serviceUserRolePlaceholder": "Select role…",
			"serviceUserCreated": "Service user {{email}} created.",
			"serviceUserFailed": "Service user creation failed.",
			"backingCustomer": "Customer Id",
			"siteId": "Site Id (optional)",
			"identityFrozen": "{{context}} key · backing identity: {{backing}} (cannot change after minting)",
			"grants": "Tool grants",
			"grantsSummary": "{{granted}} tools · {{gated}} approval-gated",
			"riskSafe": "Safe — reads",
			"riskSensitive": "Sensitive — writes",
			"riskDestructive": "Destructive — approval always required",
			"approval": "Approval",
			"approvalFor": "Require approval for {{tool}}",
			"requiresPerms": "requires: {{perms}}",
			"sensitiveWaiverWarning": "Sensitive tools without approval: {{tools}}. Calls under the blast-radius threshold will execute without human approval.",
			"missingPermsWarning": "Role “{{role}}” lacks: {{perms}}. Granted tools that need them will be denied at the gate.",
			"mint": "Mint key",
			"active": "Active",
			"revoked": "Revoked",
			"regenerate": "Regenerate token",
			"revoke": "Revoke",
			"revokedToast": "Key revoked.",
			"copy": "Copy",
			"copied": "Copied to clipboard.",
			"copyFailed": "Copy failed.",
			"secretTitle": "MCP token: {{name}}",
			"secretSubtitle": "Copy it now — it will not be shown again.",
			"secretWarning": "This is the only time the full token is shown. Only its hash is stored.",
			"connectHint": "Connect your MCP client (e.g. Claude Code) to /mcp with the header",
			"secretDone": "I have saved it",
			"revokeTitle": "Revoke MCP key",
			"revokeBody": "Revoke key “{{name}}”? Agent access stops immediately.",
			"deleteTitle": "Delete MCP key",
			"deleteBody": "Delete key “{{name}}”? This cannot be undone.",
			"toolCount": "{{count}} tools",
			"columns": {
				"name": "Name",
				"key": "Key",
				"context": "Context",
				"tools": "Tools",
				"lastUsed": "Last Used",
				"status": "Status"
			}
		},
		"emailTemplates": {
			"title": "Email Templates",
			"add": "New template",
			"addTitle": "New email template",
			"editTitle": "Edit email template",
			"formSubtitle": "Fill in the details, recipients and body.",
			"untitled": "New template",
			"settings": "Settings",
			"recipientsSubtitle": "Separate multiple values with a comma or new line.",
			"bodySubtitle": "The HTML content of the email.",
			"engineBizweb": "Bizweb",
			"engineHandlebars": "Handlebars",
			"allSites": "All sites",
			"fromName": "From Name",
			"toNames": "To Names",
			"toEmails": "To Emails",
			"ccNames": "Cc Names",
			"ccEmails": "Cc Emails",
			"bccNames": "Bcc Names",
			"bccEmails": "Bcc Emails",
			"deleteTitle": "Delete template",
			"deleteBody": "Delete template “{{name}}”? This cannot be undone.",
			"tabs": {
				"basics": "Basics",
				"recipients": "Recipients",
				"body": "Body"
			},
			"columns": {
				"code": "Code",
				"subject": "Subject",
				"fromEmail": "From Email",
				"type": "Type",
				"site": "Site",
				"body": "Body (HTML)",
				"visible": "Visible",
				"sort": "Order"
			},
			"preview": {
				"open": "Preview",
				"title": "Preview “{{code}}”",
				"subtitle": "Renders the current, unsaved draft with the data below. Nothing is saved or sent.",
				"loadFromOrder": "Load data from an order",
				"orderSearchPlaceholder": "Order code, customer name or e-mail",
				"noOrders": "No orders found",
				"orderNotFound": "The order was not found",
				"orderLoadFailed": "Could not load the order data",
				"sampleData": "Sample data (JSON)",
				"resetSample": "Reset sample",
				"invalidJson": "Invalid JSON: {{error}}",
				"handlebarsOnly": "Preview is available for Handlebars templates only. Switch the template type to Handlebars to preview it.",
				"frameTitle": "E-mail preview"
			}
		},
		"availableDates": {
			"title": "Available Dates",
			"add": "New calendar",
			"addTitle": "New work calendar",
			"editTitle": "Edit calendar",
			"formSubtitle": "Set the year and calendar options.",
			"manageWorkDays": "Work days",
			"manageExceptions": "Exceptions",
			"workDaysTitle": "Work days — {{year}}",
			"exceptionDaysTitle": "Exception days — {{year}}",
			"addDay": "Add day",
			"addException": "Add exception",
			"startTime": "Start",
			"endTime": "End",
			"startTime2": "Start (2)",
			"endTime2": "End (2)",
			"cutOffTime": "Cut-off time",
			"fc": "Prep days",
			"deleteTitle": "Delete calendar",
			"deleteBody": "Delete the {{year}} calendar? This cannot be undone.",
			"days": {
				"Monday": "Monday",
				"Tuesday": "Tuesday",
				"Wednesday": "Wednesday",
				"Thursday": "Thursday",
				"Friday": "Friday",
				"Saturday": "Saturday",
				"Sunday": "Sunday"
			},
			"dayTypes": {
				"Working": "Working",
				"NonWorking": "Non-working"
			},
			"columns": {
				"year": "Year",
				"weeklyLimit": "Weekly limit",
				"visible": "Visible",
				"sort": "Order",
				"day": "Day",
				"date": "Date",
				"dayType": "Type"
			}
		},
		"fields": {
			"erpCode": "ERP Code",
			"phone": "Phone",
			"paramGroup": "Param Group",
			"description": "Description",
			"createdAt": "Created",
			"createdBy": "Created by",
			"lastUsedIp": "Last used IP",
			"userAgent": "User Agent",
			"revokedAt": "Revoked at",
			"lastRunEnd": "Last run end",
			"firstRun": "First run",
			"fromName": "From name",
			"body": "Body"
		}
	},
	"catalog": {
		"relationTypes": {
			"title": "Relation Types",
			"add": "New relation type",
			"addTitle": "New relation type",
			"editTitle": "Edit relation type",
			"formSubtitle": "Fill in the relation type details.",
			"deleteTitle": "Delete relation type",
			"deleteBody": "Delete relation type “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"description": "Description",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"seasons": {
			"title": "Seasons",
			"add": "New season",
			"addTitle": "New season",
			"editTitle": "Edit season",
			"formSubtitle": "Fill in the season details.",
			"deleteTitle": "Delete season",
			"deleteBody": "Delete season “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"name": "Name",
				"startDate": "Start Date",
				"endDate": "End Date",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"models": {
			"title": "Models",
			"add": "New model",
			"addTitle": "New model",
			"editTitle": "Edit model",
			"formSubtitle": "Fill in the model details.",
			"deleteTitle": "Delete model",
			"deleteBody": "Delete model “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"erpCode": "ERP Code",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"warehouses": {
			"title": "Warehouses",
			"add": "New warehouse",
			"addTitle": "New warehouse",
			"editTitle": "Edit warehouse",
			"formSubtitle": "Fill in the warehouse details.",
			"deleteTitle": "Delete warehouse",
			"deleteBody": "Delete warehouse “{{name}}”? This cannot be undone.",
			"selectType": "Select a type…",
			"columns": {
				"code": "Code",
				"name": "Name",
				"type": "Type",
				"disabled": "Disabled",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"themeTemplates": {
			"title": "Theme Templates",
			"add": "New theme template",
			"addTitle": "New theme template",
			"editTitle": "Edit theme template",
			"formSubtitle": "Fill in the theme template details.",
			"deleteTitle": "Delete theme template",
			"deleteBody": "Delete template “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"isForProducts": "For Products",
				"isForCategories": "For Categories"
			}
		},
		"wishlistTemplates": {
			"title": "Wishlist Templates",
			"add": "New wishlist template",
			"addTitle": "New wishlist template",
			"editTitle": "Edit wishlist template",
			"formSubtitle": "Fill in the template details and products.",
			"deleteTitle": "Delete wishlist template",
			"deleteBody": "Delete template “{{name}}”? This cannot be undone.",
			"searchProducts": "Search products…",
			"columns": {
				"name": "Name",
				"code": "Code",
				"products": "Products",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"filterTemplates": {
			"title": "Filter Templates",
			"add": "New filter template",
			"addTitle": "New filter template",
			"editTitle": "Edit filter template",
			"formSubtitle": "Fill in the template details.",
			"deleteTitle": "Delete filter template",
			"deleteBody": "Delete template “{{name}}”? This cannot be undone.",
			"filters": "Filters",
			"filtersTitle": "Template filters",
			"filterCount": "{{count}} filters",
			"orderHint": "Drag the rows to set the order the storefront shows these filters in. Filters not listed here are hidden.",
			"dragToReorder": "Drag to reorder",
			"addFilters": "Add filters",
			"addFiltersTitle": "Add filters",
			"addFiltersSubtitle": "Select filters to add to the template.",
			"noAvailableFilters": "No available filters.",
			"addSelected": "Add ({{count}})",
			"deleteFilterTitle": "Remove filter",
			"deleteFilterBody": "Remove filter “{{name}}” from the template?",
			"copy": "Make a copy",
			"copyTitle": "Copy of “{{name}}”",
			"copyBody": "The copy gets all the filters and no categories, and is listed right under the original. The categories stay on the original template; to use the copy on a category, select it in the category's “Filter template” field.",
			"copyNameSuffix": "Copy",
			"copied": "Copy created",
			"columns": {
				"name": "Name",
				"isDefault": "Default",
				"visible": "Visible",
				"sort": "Order",
				"isManufacturerDefault": "Manufacturer default"
			},
			"filterColumns": {
				"name": "Filter",
				"extended": "Extended",
				"singleSelect": "Single select",
				"showInWizard": "In wizard",
				"featured": "Featured",
				"imageFilter": "Image filter"
			},
			"settings": {
				"title": "Filter settings",
				"toolTip": "Tooltip",
				"toolTipPlaceholder": "Hover text shown next to the filter…",
				"categoryFilterMode": "Category display",
				"modes": {
					"default": "Default (subcategories)",
					"subcategories": "Subcategories",
					"siblings": "Sibling categories",
					"byLevel": "Categories of a level"
				},
				"categoryNestingDepth": "Nesting depth",
				"categoryNestingDepthHelp": "How many subcategory levels to show. Empty or 1 = direct children only, -1 = all depths.",
				"categoryLevel": "Category level",
				"categoryLevelHelp": "Tree level whose categories are shown (1 = top level). Empty or -1 = all levels."
			}
		},
		"statuses": {
			"title": "Statuses",
			"add": "New status",
			"untitled": "New status",
			"notFound": "Status not found.",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"schedulingTitle": "Scheduling",
			"schedulingSubtitle": "Optional display time window.",
			"startDate": "Start date",
			"endDate": "End date",
			"deleteTitle": "Delete status",
			"deleteBody": "Delete status “{{name}}”? This cannot be undone.",
			"entityUrl": "Page URL",
			"color": "Color",
			"textColor": "Text color",
			"headerTitle": "Header title (H1)",
			"metaTitle": "Meta title",
			"metaKeywords": "Meta keywords",
			"metaDescription": "Meta description",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Disable indexation",
			"disableFollow": "Disable follow",
			"image": "Image",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"bodyPlaceholder": "Description text…",
			"tabs": {
				"general": "General",
				"seo": "SEO",
				"content": "Body",
				"image": "Image"
			},
			"columns": {
				"image": "Image",
				"code": "Code",
				"name": "Name",
				"disableCart": "Disable cart",
				"showAsTag": "Show as tag",
				"visible": "Visible",
				"sort": "Order"
			},
			"tooltip": "Tooltip",
			"tooltipHelp": "Hover text shown next to the status on the storefront."
		},
		"manufacturers": {
			"title": "Manufacturers",
			"add": "New manufacturer",
			"untitled": "New manufacturer",
			"notFound": "Manufacturer not found.",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete manufacturer",
			"deleteBody": "Delete manufacturer “{{name}}”? This cannot be undone.",
			"code": "Code",
			"entityUrl": "Page URL",
			"landingUrl": "Landing URL",
			"erpCode": "ERP code",
			"erpCode2": "ERP code 2",
			"filterTemplate": "Filter template",
			"selectFilterTemplate": "Select template…",
			"noFilterTemplate": "— None —",
			"isTopPage": "Top page",
			"headerTitle": "Header title (H1)",
			"metaTitle": "Meta title",
			"metaKeywords": "Meta keywords",
			"metaDescription": "Meta description",
			"disableIndexation": "Disable indexation",
			"disableFollow": "Disable follow",
			"descriptionPlaceholder": "Manufacturer description…",
			"image1": "Image 1",
			"image2": "Image 2",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"garan": {
				"title": "GARAN defaults",
				"subtitle": "Commercial guarantee of durability (EU Reg. 2025/1960). Applied by default to this producer's products; each product may override.",
				"enabled": "Enable GARAN by default",
				"years": "Default duration (years)",
				"yearsHelp": "Must be over 2 years to qualify for the label."
			},
			"tabs": {
				"general": "General",
				"seo": "SEO",
				"content": "Description",
				"images": "Images"
			},
			"columns": {
				"image": "Image",
				"name": "Name",
				"code": "Code",
				"featured": "Featured",
				"visible": "Visible",
				"sort": "Order"
			},
			"staticPageUrl": "Static page URL",
			"staticPageUrlHelp": "When set, storefront links to this manufacturer point here instead of the default manufacturer page."
		},
		"categories": {
			"title": "Categories",
			"subtitle": "{{count}} categories",
			"add": "New category",
			"untitled": "New category",
			"notFound": "Category not found.",
			"dynamic": "Dynamic",
			"hidden": "Hidden",
			"productCount": "Products",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"flagsTitle": "Options",
			"customerGroupsTitle": "Customer profiles",
			"customerGroupsSubtitle": "Restrict visibility to specific customer profiles.",
			"selectCustomerGroups": "Select profiles…",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete category “{{name}}”? This cannot be undone.",
			"deleteWithChildrenBody": "“{{name}}” has subcategories. Delete them too, or move them up one level?",
			"deleteKeepChildren": "Keep subcategories",
			"deleteAll": "Delete all",
			"code": "Code",
			"entityUrl": "Page URL",
			"productSort": "Product sort",
			"discount": "Discount (%)",
			"erpCode": "ERP code",
			"filterTemplate": "Filter template",
			"selectFilterTemplate": "Select template…",
			"noFilterTemplate": "— None —",
			"categoryWizard": "Category wizard",
			"noCategoryWizard": "— None —",
			"cacheRevalidation": "Cache revalidation",
			"cacheRevalidationInterval": "Revalidation interval (min)",
			"isDynamic": "Dynamic category",
			"filtersSubtitle": "Auto-populate this category from product filters.",
			"productFilters": "Product filters",
			"excludedProductFilters": "Excluded product filters",
			"selectProductFilters": "Select filters…",
			"infoText": "Description text ({{n}})",
			"infoTextPlaceholder": "Category description…",
			"image": "Image {{n}}",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"headerTitle": "Header title (H1)",
			"metaTitle": "Meta title",
			"metaKeywords": "Meta keywords",
			"metaDescription": "Meta description",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Disable indexation",
			"disableFollow": "Disable follow",
			"parent": "Parent category",
			"noParent": "— Top level —",
			"color": "Color",
			"walkTree": "Walk tree",
			"showZeroQty": "Show zero quantity",
			"landingPage": "Landing page",
			"topPage": "Top page",
			"excludeFromSubcategory": "Exclude from subcategory",
			"excludeFromRelated": "Exclude from related categories",
			"frontExclusion": "Front exclusion",
			"highlighted": "Highlighted",
			"tabs": {
				"general": "General",
				"filters": "Dynamic filters",
				"descriptions": "Descriptions",
				"images": "Images",
				"seo": "SEO",
				"returnPolicy": "Product returns"
			},
			"columns": {
				"name": "Name",
				"visible": "Visible",
				"sort": "Order",
				"dynamic": "Dynamic",
				"productSort": "Product sort",
				"filterTemplate": "Filter template",
				"color": "Color",
				"productCount": "Products",
				"code": "Code",
				"erpCode": "ERP code",
				"categoryWizard": "Category wizard",
				"walkTree": "Walk tree",
				"showZeroQty": "Zero qty",
				"landingPage": "Landing",
				"topPage": "Top page",
				"excludeSubcategory": "Excl. subcat.",
				"excludeRelated": "Excl. related",
				"frontExclusion": "Front excl.",
				"highlighted": "Highlighted"
			},
			"relations": {
				"manage": "Manage",
				"products": "Products",
				"manufacturers": "Manufacturers",
				"news": "News",
				"attributes": "Attributes",
				"faq": "FAQs",
				"themeTemplates": "Theme templates",
				"count": "{{count}} items",
				"capped": "Showing first {{shown}} of {{total}} — refine your search",
				"colName": "Name",
				"colCode": "Code",
				"colSort": "Order",
				"colFeatured": "Featured",
				"colHidden": "Hidden",
				"colTitle": "Title",
				"productsTitle": "Featured products · {{name}}",
				"productsSubtitle": "Toggle which products are featured in this category.",
				"manufacturersTitle": "Manufacturers · {{name}}",
				"manufacturersSubtitle": "Add, reorder, feature or remove manufacturers in this category.",
				"selectManufacturer": "Select a manufacturer…",
				"newsTitle": "News · {{name}}",
				"newsSubtitle": "Reorder, feature or remove news entries in this category.",
				"newsAddDeferred": "Adding new entries is done from the News page (deferred here).",
				"attributesTitle": "Attributes · {{name}}",
				"attributesSubtitle": "Toggle hidden / featured for this category's attributes."
			},
			"buyGuide": "Buy guide",
			"buyGuideHelp": "Shown on the pages of products in this category.",
			"noBuyGuide": "— None —",
			"staticPageUrl": "Static page URL",
			"staticPageUrlHelp": "When set, breadcrumbs and related-category links point here instead of the default category page.",
			"googleTaxonomyId": "Google taxonomy ID",
			"googleTaxonomyIdHelp": "Google product category id used in product feeds."
		},
		"filters": {
			"title": "Product Filters",
			"add": "New filter",
			"addTitle": "New product filter",
			"editTitle": "Edit product filter",
			"formSubtitle": "Name and describe the filter; build its conditions separately.",
			"editDefinition": "Edit conditions",
			"builderTitle": "Conditions · {{name}}",
			"builderSubtitle": "Combine conditions with AND / ANY / NOT to define which products match.",
			"deleteTitle": "Delete filter",
			"deleteBody": "Delete filter “{{name}}”? This cannot be undone.",
			"selectFilter": "Select a condition…",
			"combine": "Combine",
			"conditions": "Conditions",
			"addCondition": "Add condition",
			"unwrap": "Remove this group (keep first condition)",
			"operand": "Operator",
			"operandRequired": "Operator is required",
			"from": "From",
			"to": "To",
			"value": "Value",
			"limit": "Limit",
			"topSellingLimit": "Limit",
			"dayWindow": "Day window",
			"searchFields": "Fields (empty = any)",
			"term": "Term",
			"selectEntities": "Select…",
			"metricType": "Metric type…",
			"addMetricCondition": "Add metric condition",
			"manualRun": "Manual run",
			"manualRunHelp": "Skipped by the background sweep; populated and assigned only by Run.",
			"run": "Run now",
			"runDone": "Filter populated",
			"neverRun": "Never run",
			"assignments": {
				"edit": "Assignments",
				"title": "Assignments: {{name}}",
				"subtitle": "Statuses and attribute values given to the products this filter matches, and taken back when a product stops matching. Values a product already has are left alone.",
				"manualNote": "Manual run is on: they are applied on the next Run.",
				"statuses": "Statuses",
				"attributes": "Attributes",
				"attribute": "Attribute…",
				"addAttribute": "Add attribute"
			},
			"advancedUnsupported": "Advanced condition — edit in the legacy admin (preserved on save).",
			"columns": {
				"name": "Name",
				"description": "Description",
				"manualRun": "Manual run (last)"
			},
			"types": {
				"daysSinceCreation": "Days since creation",
				"daysSinceRelease": "Days since release",
				"discount": "Discount",
				"initialPrice": "Initial price",
				"finalPrice": "Final price",
				"quantity": "Quantity",
				"bestSellers": "Best sellers",
				"topSelling": "Top selling",
				"searchTerm": "Search term",
				"inCategories": "In categories",
				"hasStatuses": "Has statuses",
				"hasManufacturers": "Has manufacturers",
				"hasSubTypes": "Has subtypes",
				"hasAvailabilities": "Has availabilities",
				"hasAvailableStock": "Available in warehouse",
				"metricTypes": "Metric types",
				"hasModels": "Has models",
				"productAttribute": "Product attribute",
				"discountBetweenPriceTypes": "Discount between price types",
				"promotedByPolicy": "Promoted by policy",
				"partakesInPolicy": "Participates in policy"
			}
		},
		"reviews": {
			"excludedGroups": {
				"button": "Excluded customer profiles",
				"title": "Excluded customer profiles",
				"subtitle": "Members of these profiles cannot write reviews.",
				"group": "Customer profile",
				"selectGroup": "Select a profile…",
				"add": "Add"
			},
			"title": "Reviews",
			"editTitle": "Edit review",
			"title_field": "Title",
			"comment": "Comment",
			"featured": "Featured",
			"allStatuses": "All statuses",
			"any": "Any",
			"ratingFrom": "Rating from",
			"ratingTo": "Rating to",
			"dateFrom": "Date from",
			"dateTo": "Date to",
			"clearFilters": "Clear filters",
			"approve": "Approve",
			"decline": "Decline",
			"deleteTitle": "Delete review",
			"deleteBody": "Delete this review? This cannot be undone.",
			"addButton": "Add review",
			"addTitle": "New contributor review",
			"addSubtitle": "A review by a contributor or a publication, shown on the product page.",
			"openTarget": "Open in the shop",
			"targetType": "Reviewed item type",
			"allTargetTypes": "All item types",
			"targetReadOnly": "Only a product can be changed; a review of another kind of item stays on it.",
			"targets": {
				"product": "Product",
				"contributor": "Contributor",
				"brand": "Brand",
				"contentPage": "Content page",
				"customer": "Customer",
				"other": "Other"
			},
			"author": {
				"customer": "Customer",
				"editorial": "Editorial"
			},
			"tabs": {
				"customer": "Customer comments",
				"contributor": "Contributor reviews",
				"recommendations": "Recommendations"
			},
			"columns": {
				"product": "Product",
				"target": "Reviewed item",
				"reviewer": "Reviewer",
				"rating": "Rating",
				"status": "Status",
				"date": "Date",
				"comment": "Comment",
				"visible": "Visible",
				"sort": "Order",
				"helpful": "Helpful",
				"openReports": "Open reports"
			},
			"fields": {
				"contributor": "Contributor",
				"category": "Contributor category",
				"reviewer": "Reviewer (text)",
				"source": "Source",
				"pickContributor": "Select a contributor…",
				"searchContributor": "Search by name or surname…",
				"searchContributorHint": "Type a name to search"
			},
			"export": {
				"button": "Export",
				"targetType": "Item type",
				"targetCode": "Item code",
				"email": "Email",
				"truncated": "Exported {{exported}} of {{total}} reviews — narrow the filters for a complete export."
			},
			"details": {
				"title": "Review details",
				"review": "Review",
				"customer": "Customer",
				"name": "Name",
				"registered": "Registered",
				"orders": "Completed orders",
				"reviews": "Products reviewed",
				"target": "Reviewed item",
				"category": "Category",
				"publisher": "Publisher / manufacturer"
			},
			"copy": {
				"title": "Copy to grouped products",
				"subtitle": "Copy the review of “{{product}}” to the products of the same group.",
				"none": "The product belongs to no group with other products.",
				"selectAll": "Select all",
				"submit_one": "Copy to {{count}} product",
				"submit_other": "Copy to {{count}} products",
				"done_one": "Copied to {{count}} product.",
				"done_other": "Copied to {{count}} products.",
				"partial": "Copied to {{ok}}, failed for {{failed}} — see the list.",
				"copied": "Copied"
			},
			"recalculate": {
				"button": "Recalculate ratings",
				"title": "Recalculate product ratings",
				"body": "Rebuilds every product's rating and review count from the accepted reviews. Normally this happens on its own; use it after bulk imports.",
				"confirm": "Recalculate",
				"done": "Product ratings recalculated."
			},
			"recommendations": {
				"customer": "Customers",
				"contributor": "Contributors",
				"from": "Recommended by",
				"deleteTitle": "Delete recommendation",
				"deleteBody": "Delete this recommendation? This cannot be undone."
			},
			"photos": {
				"title": "Photos",
				"count_one": "{{count}} photo",
				"count_other": "{{count}} photos",
				"open": "Open photo",
				"delete": "Remove photo",
				"deleted": "Photo removed.",
				"deleteTitle": "Remove photo",
				"deleteBody": "Remove this photo from the review? The customer will not see it again either. This cannot be undone."
			},
			"reports": {
				"title": "Reports",
				"none": "No customer reported this review.",
				"resolve": "Mark reports resolved",
				"resolved": "Reports marked as resolved.",
				"stateOpen": "Open",
				"stateResolved": "Resolved",
				"onlyReported": "Only reported",
				"openCount_one": "{{count}} open report",
				"openCount_other": "{{count}} open reports",
				"reasons": {
					"spam": "Spam or advertising",
					"offensive": "Offensive or abusive",
					"offTopic": "Not about the product",
					"misleading": "Fake or misleading",
					"other": "Other"
				}
			},
			"bulk": {
				"selected_one": "{{count}} review selected",
				"selected_other": "{{count}} reviews selected",
				"clear": "Clear selection",
				"selectAll": "Select all on this page",
				"selectRow": "Select review",
				"approveTitle_one": "Approve {{count}} review",
				"approveTitle_other": "Approve {{count}} reviews",
				"declineTitle_one": "Decline {{count}} review",
				"declineTitle_other": "Decline {{count}} reviews",
				"deleteTitle_one": "Delete {{count}} review",
				"deleteTitle_other": "Delete {{count}} reviews",
				"approveBody_one": "The review will be shown on the product page.",
				"approveBody_other": "The reviews will be shown on the product pages.",
				"approveCustomerBody_one": "The review will be shown on the product page. Its author gets the \"review accepted\" e-mail and the review's loyalty points, as with a single approval.",
				"approveCustomerBody_other": "The reviews will be shown on the product pages. Each author gets the \"review accepted\" e-mail and the review's loyalty points, as with a single approval.",
				"declineBody_one": "The review will not be shown on the product page.",
				"declineBody_other": "The reviews will not be shown on the product pages.",
				"deleteBody_one": "Delete the selected review? This cannot be undone.",
				"deleteBody_other": "Delete the {{count}} selected reviews? This cannot be undone.",
				"approveConfirm_one": "Approve",
				"approveConfirm_other": "Approve {{count}}",
				"declineConfirm_one": "Decline",
				"declineConfirm_other": "Decline {{count}}",
				"deleteConfirm_one": "Delete",
				"deleteConfirm_other": "Delete {{count}}",
				"done": {
					"approve_one": "{{count}} review approved.",
					"approve_other": "{{count}} reviews approved.",
					"decline_one": "{{count}} review declined.",
					"decline_other": "{{count}} reviews declined.",
					"delete_one": "{{count}} review deleted.",
					"delete_other": "{{count}} reviews deleted."
				}
			}
		},
		"backInStock": {
			"title": "Back-in-stock subscriptions",
			"noAccess": "You need the Catalog role to view back-in-stock subscriptions.",
			"variant": "variant #{{id}}",
			"columns": {
				"email": "E-mail",
				"product": "Product",
				"language": "Language",
				"status": "Status",
				"requested": "Requested",
				"confirmed": "Confirmed",
				"notified": "Notified"
			},
			"status": {
				"pendingConfirmation": "Awaiting confirmation",
				"pendingNotification": "Waiting for stock",
				"notified": "Notified",
				"disabled": "Disabled"
			}
		},
		"buyGuides": {
			"title": "Buy Guides",
			"add": "New buy guide",
			"untitled": "New buy guide",
			"notFound": "Buy guide not found.",
			"noAccess": "You need the Catalog permission to manage buy guides.",
			"statusTitle": "Status",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete buy guide",
			"deleteBody": "Delete buy guide “{{name}}”? This cannot be undone.",
			"backgroundColor": "Background colour",
			"image": "Image",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"contentPlaceholder": "Buy guide content…",
			"categories": "Categories",
			"categoriesSubtitle": "Products in these categories show this buy guide on their page.",
			"categoriesHelp": "A category shows a single buy guide; selecting one that already has another guide moves it here.",
			"categoriesPlaceholder": "Select categories…",
			"otherGuide": "Other guide",
			"tabs": {
				"general": "General",
				"content": "Content",
				"categories": "Categories"
			},
			"columns": {
				"image": "Image",
				"name": "Name",
				"background": "Background",
				"categories": "Categories",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"bundles": {
			"title": "Bundles",
			"subtitle": "Bundle and gift box products and their contents. Create the product itself in the product editor, then manage its contents here.",
			"add": "New bundle",
			"noAccess": "You need the Catalog permission to manage bundles.",
			"notFound": "Bundle not found — the product does not exist or is not a Bundle / Gift box.",
			"loadError": "Could not load bundles.",
			"newTitle": "Choose a bundle product",
			"newBody": "Bundle and gift box products without contents. Pick one to set up its contents; create new bundle products in the product editor.",
			"newEmpty": "Every bundle / gift box product already has contents. Create a new product of type Bundle or Gift box in the product editor first.",
			"openProduct": "Open product",
			"activeWindow": "Active period",
			"activeWindowHelp": "Leave empty for no start / end limit.",
			"activeFrom": "Active from",
			"activeTo": "Active to",
			"datesInvalid": "The end date must be after the start date.",
			"contents": "Contents",
			"contentsHelpBundle": "All rows are saved together. Hidden rows are kept but do not count.",
			"contentsHelpGiftbox": "Each row needs a product or a description. All rows are saved together.",
			"addRow": "Add row",
			"removeRow": "Remove row",
			"noRows": "No contents yet. Add a row to start.",
			"summary": "Summary",
			"totalsPending_one": "{{count}} row has no known price yet; totals update after save.",
			"totalsPending_other": "{{count}} rows have no known price yet; totals update after save.",
			"saved": "Bundle saved",
			"pickProduct": "Pick a product…",
			"searchProduct": "Search by code or name…",
			"searchHint": "Type to search products",
			"clearProduct": "Clear product",
			"types": {
				"bundle": "Bundle",
				"giftbox": "Gift box"
			},
			"status": {
				"active": "Active",
				"inactive": "Inactive",
				"activeBanner": "Active — this bundle applies at checkout.",
				"inactiveBanner": "Inactive — this bundle does not apply at checkout:"
			},
			"filters": {
				"type": "Type",
				"allTypes": "All types",
				"status": "Status",
				"allStatuses": "All statuses",
				"containsProduct": "Contains product…"
			},
			"columns": {
				"image": "Image",
				"name": "Name",
				"code": "Code",
				"type": "Type",
				"count": "Products",
				"regularTotal": "Regular total",
				"bundleTotal": "Bundle total",
				"saving": "Saving",
				"status": "Status",
				"dates": "Active period",
				"product": "Product",
				"qty": "Qty",
				"livePrice": "Live price",
				"bundlePrice": "Bundle price",
				"priceBd": "Price BD",
				"refPrice": "Reference price",
				"description": "Description",
				"sort": "Order",
				"visible": "Visible",
				"unitSaving": "Saving / unit",
				"lineTotal": "Line total"
			},
			"reasons": {
				"BundleProductMissing": "The bundle product does not exist",
				"BundleProductDeleted": "The bundle product is deleted",
				"BundleProductHidden": "The bundle product is hidden",
				"NotABundleProduct": "The product is not a Bundle / Gift box",
				"NotStarted": "The active period has not started yet",
				"Ended": "The active period has ended",
				"CustomerHasNoAccess": "Customers have no access to the bundle product",
				"NoContents": "No contents",
				"InvalidRow": "A row is invalid",
				"ChildInTwoRows": "A product appears in two rows",
				"ChildMissing": "A contained product does not exist",
				"ChildDeleted": "A contained product is deleted",
				"ChildHidden": "A contained product is hidden",
				"ChildNotASimpleProduct": "A contained product is not a simple product",
				"ChildCustomerHasNoAccess": "Customers have no access to a contained product"
			},
			"warnings": {
				"ChildMissing": "Product does not exist",
				"ChildDeleted": "Product is deleted",
				"ChildHidden": "Product is hidden",
				"ChildNotASimpleProduct": "Not a simple product",
				"ChildHasDimensions": "Product has dimensions (variants)",
				"NoSaving": "No saving: bundle price is not below the live price",
				"InvalidRow": "Invalid row",
				"ChildInTwoRows": "Product appears in another row"
			},
			"productTab": {
				"contentsTitle": "Bundle contents",
				"manage": "Manage contents",
				"saveTypeFirst": "Save the product as Bundle or Gift box to manage its contents.",
				"partOfTitle": "Part of bundles",
				"partOfHelp": "Bundles and gift boxes that contain this product.",
				"partOfEmpty": "This product is not part of any bundle.",
				"saveFirst": "Save the product first to see its bundles."
			}
		}
	},
	"loyalty": {
		"ranges": {
			"title": "Point Ranges",
			"add": "New range",
			"addTitle": "New point range",
			"editTitle": "Edit point range",
			"formSubtitle": "Fill in the point range details.",
			"guide": "Adding a points value that already exists will cancel the previous one.",
			"deleteTitle": "Delete point range",
			"deleteBody": "Delete the {{points}}-point range? This action cannot be undone.",
			"deleteResult": {
				"already_cancelled": "The range was already cancelled.",
				"expired_successfully": "The range expired successfully.",
				"deleted_sucessfully": "The range was deleted successfully."
			},
			"columns": {
				"points": "Points",
				"discount": "Discount",
				"minimumAmount": "Minimum amount",
				"activeFrom": "Active from",
				"activeTo": "Active to",
				"updated": "Updated"
			}
		},
		"perEntity": {
			"title": "Points per Entity",
			"editTitle": "Edit point assignment",
			"formSubtitle": "Set the points awarded for this event.",
			"columns": {
				"name": "Parameter",
				"description": "Description",
				"points": "Points",
				"activeFrom": "Active from",
				"activeTo": "Active to",
				"updated": "Updated"
			}
		},
		"overview": {
			"title": "Parameters",
			"editTitle": "Edit parameter",
			"formSubtitle": "Fill in the parameter details.",
			"deleteTitle": "Delete parameter",
			"deleteBody": "Delete the parameter “{{name}}”? This action cannot be undone.",
			"columns": {
				"name": "Parameter",
				"value": "Value",
				"description": "Description"
			},
			"valueHint": {
				"onOff": "Enter 1 (on) or 0 (off).",
				"wholeNumber": "Enter a whole number, 0 or more.",
				"amount": "Enter an amount, such as 0.5."
			}
		},
		"products": {
			"title": "Point Products",
			"subtitle": "{{count}} products",
			"searchPlaceholder": "Search by name or code…",
			"pageInfo": "Page {{page}} / {{pages}} · {{total}} total",
			"columns": {
				"name": "Name",
				"code": "Code",
				"barcode": "Barcode",
				"points": "Points",
				"activeFrom": "Active from",
				"activeTo": "Active to"
			},
			"showHistory": "Show past values"
		},
		"customers": {
			"title": "Customer Points",
			"columns": {
				"name": "Name",
				"surname": "Surname",
				"points": "Points",
				"email": "E-mail",
				"mobile": "Mobile",
				"expiration": "Expiry date",
				"reserved": "Reserved"
			},
			"history": {
				"action": "History",
				"title": "Points history",
				"subtitle": "The customer's points transaction history.",
				"columns": {
					"description": "Description",
					"date": "Date",
					"points": "Points",
					"status": "Status"
				},
				"noteBy": "{{note}} — {{admin}}"
			},
			"eventTypes": {
				"1": "Pending product order",
				"2": "Points credited on order",
				"3": "Points redeemed on order",
				"4": "Product return",
				"5": "Birthday",
				"6": "Registration",
				"7": "For consumption",
				"8": "Gender entry",
				"9": "Newsletter subscription",
				"10": "Birth date entry",
				"11": "Appointment booked",
				"12": "Article read",
				"13": "Video viewed",
				"14": "Refer a friend",
				"15": "Friend referral accepted",
				"16": "Review",
				"17": "Points reverted",
				"18": "Appointment cancelled",
				"19": "Points expired",
				"20": "Manual adjustment"
			},
			"pointStatus": {
				"1": "Approved points",
				"2": "Pending points",
				"3": "Reserved points"
			},
			"subtitle": "{{count}} customers with points",
			"searchPlaceholder": "Search by name, e-mail or mobile",
			"export": "Export",
			"exportTruncated": "Exported {{exported}} of {{total}} customers — narrow the search for a complete export.",
			"adjust": {
				"action": "Adjust points",
				"anyCustomer": "Adjust a customer's points",
				"title": "Adjust points",
				"subtitle": "{{name}} · {{points}} points now",
				"pickCustomer": "Pick the customer whose points you are adjusting.",
				"customer": "Customer",
				"points": "Points",
				"pointsHint": "A positive number adds points, a negative one takes them away. Points taken beyond the balance become a debt.",
				"pointsInvalid": "Enter whole points other than 0, from -100000 to 100000",
				"note": "Reason (only admins see it)",
				"expiry": "Expiry date",
				"expiryHint": "Empty: as the expiry setting says.",
				"expiryInvalid": "The expiry has to be in the future",
				"submit": "Adjust",
				"saved": "Points adjusted. The customer now has {{points}} points."
			}
		},
		"tierRules": {
			"title": "Tier Rules",
			"add": "New Rule",
			"addTitle": "New Tier Rule",
			"editTitle": "Edit Rule",
			"formSubtitle": "Thresholds that promote customers between loyalty tiers.",
			"deleteTitle": "Delete rule",
			"deleteBody": "Delete the rule for “{{name}}”? This action cannot be undone.",
			"fields": {
				"tier": "Tier",
				"criteriaType": "Criteria type",
				"value": "Value",
				"timeFrameMonth": "Time frame (months)",
				"description": "Description",
				"active": "Active"
			}
		},
		"loadError": "Could not load the loyalty data."
	},
	"customers": {
		"list": {
			"title": "Customers",
			"subtitle": "{{count}} customers",
			"add": "New customer",
			"addTitle": "New customer",
			"editTitle": "Edit customer",
			"formSubtitle": "Account, classification, commercial and company details.",
			"searchPlaceholder": "Search by name, email or phone…",
			"pageInfo": "Page {{page}} / {{pages}} · {{total}} total",
			"deleteTitle": "Delete customer",
			"deleteBody": "Delete customer “{{name}}”? This cannot be undone.",
			"columns": {
				"email": "Email",
				"name": "First name",
				"surname": "Last name",
				"category": "Category",
				"active": "Active",
				"confirmed": "Confirmed"
			},
			"sections": {
				"account": "Account",
				"classification": "Classification",
				"commercial": "Commercial",
				"company": "Company / Invoicing",
				"flags": "Preferences",
				"erp": "ERP Codes",
				"image": "Image"
			},
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"fields": {
				"username": "Username",
				"password": "Password",
				"passwordEdit": "Password (leave blank to keep)",
				"tier": "Tier",
				"gender": "Gender",
				"dob": "Date of birth",
				"discount": "Discount",
				"priceType": "Price type",
				"paymentType": "Payment type",
				"shippingType": "Shipping type",
				"takeawayStore": "Pickup store",
				"company": "Company",
				"descriptiveTitle": "Descriptive title",
				"vat": "VAT number",
				"irs": "Tax office",
				"tel": "Telephone",
				"mobile": "Mobile",
				"fax": "Fax",
				"newsletter": "Receive newsletters",
				"promoOptin": "Promo opt-in",
				"personalizedMessages": "Personalized messages",
				"hiddenReader": "Hidden reader",
				"image": "Customer image"
			},
			"actions": {
				"branches": "Branches",
				"coupons": "Coupons",
				"groupOverrides": "Assign to profiles",
				"impersonate": "Impersonate",
				"referrals": "Referrals"
			},
			"branches": {
				"title": "Branches",
				"subtitle": "Branches for this customer.",
				"add": "New branch",
				"code": "Code",
				"name": "Name",
				"email": "Email",
				"tel": "Telephone",
				"address": "Address",
				"area": "Area",
				"city": "City",
				"postalCode": "Postal code",
				"erpCode": "ERP code",
				"sort": "Order",
				"visible": "Visible"
			},
			"coupons": {
				"title": "Coupons",
				"subtitle": "Coupons for this customer.",
				"add": "New coupon",
				"code": "Code",
				"name": "Name",
				"barcode": "Barcode",
				"amount": "Amount",
				"discount": "Discount",
				"registerDate": "Register date",
				"expiryDate": "Expiry date",
				"description": "Description",
				"active": "Active"
			},
			"groupOverrides": {
				"title": "Assign to profiles",
				"subtitle": "Assign this customer to profiles or exclude them, regardless of each profile's criteria.",
				"included": "Included in profiles",
				"excluded": "Excluded from profiles",
				"none": "No profiles"
			},
			"referrals": {
				"title": "Referrals",
				"subtitle": "Refer a friend",
				"code": "Referral code",
				"noCode": "No code yet",
				"copy": "Copy code",
				"copied": "Copied",
				"copyFailed": "Could not copy",
				"createdOn": "Created on {{date}}",
				"referredBy": "Referred by",
				"regenerate": "New code",
				"regenerateWarning": "The customer gets a new code and the current one stops working: invitations already sent with it will no longer apply.",
				"regenerated": "New code created",
				"none": "No customer has joined with this customer's code yet.",
				"customer": "Customer",
				"email": "E-mail",
				"joined": "Joined",
				"status": "Status",
				"statusJoined": "Joined",
				"statusRewarded": "Rewarded (+{{points}} points)",
				"statusReversed": "Reward reversed",
				"showingNewest": "Showing the newest {{shown}} of {{total}}."
			}
		},
		"groups": {
			"title": "Customer Profiles",
			"add": "New profile",
			"addTitle": "New profile",
			"editTitle": "Edit profile",
			"formSubtitle": "Fill in the customer profile details. Membership criteria are edited separately.",
			"columns": {
				"code": "Code",
				"name": "Name",
				"description": "Description"
			},
			"criteria": {
				"title": "Criteria editor",
				"subtitle": "Define which customers belong to this profile.",
				"selectFilter": "Select condition",
				"combine": "Combine",
				"conditions": "Conditions",
				"operand": "Op",
				"addCondition": "Add condition",
				"tier": "Tier",
				"ageFrom": "Age from",
				"ageTo": "Age to",
				"selectGenders": "Select genders…",
				"selectCustomers": "Search customers…",
				"selectCategories": "Select customer categories…",
				"advanced": "advanced",
				"advancedPreserved": "Advanced condition — edit in the legacy admin (preserved)",
				"types": {
					"customerTier": "Customer Tier",
					"customerGender": "Customer Gender",
					"customerAge": "Customer Age",
					"customerId": "Customer Selection",
					"customerCategory": "Customer Category",
					"customerOrderStats": "Order Statistics"
				}
			},
			"members": {
				"title": "Members",
				"subtitle": "Customers currently matching this profile.",
				"name": "Name",
				"email": "Email"
			},
			"memberOverrides": {
				"title": "Assign/exclude customers",
				"subtitle": "Assign or exclude specific customers to/from this profile, regardless of its criteria.",
				"included": "Assigned customers",
				"excluded": "Excluded customers",
				"search": "Search customers…",
				"none": "None"
			}
		},
		"categories": {
			"title": "Customer Categories",
			"subtitle": "{{count}} categories",
			"add": "New category",
			"addTitle": "New category",
			"editTitle": "Edit category",
			"formSubtitle": "Fill in the customer category details.",
			"rootParent": "— No parent (root) —",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete category “{{name}}”? This cannot be undone.",
			"deleteWithChildrenBody": "Delete category “{{name}}” and all its sub-categories? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"parent": "Parent category",
				"discount": "Discount",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"tiers": {
			"title": "Customer Tiers",
			"add": "New tier",
			"addTitle": "New tier",
			"editTitle": "Edit tier",
			"formSubtitle": "Fill in the customer tier details.",
			"deleteTitle": "Delete tier",
			"deleteBody": "Delete tier “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"description": "Description",
				"level": "Level",
				"multiplier": "Multiplier",
				"color": "Color",
				"visible": "Visible",
				"active": "Active",
				"sort": "Order",
				"purchaseAmountFrom": "Purchases from (€)"
			},
			"bullets": {
				"title": "Privileges",
				"empty": "No privileges yet.",
				"placeholder": "New privilege text",
				"add": "Add"
			}
		},
		"registerRequests": {
			"title": "Register Requests",
			"editTitle": "Edit Request",
			"formSubtitle": "Details of a customer who submitted a registration request.",
			"deleteTitle": "Delete request",
			"deleteBody": "Delete request “{{name}}”? This action cannot be undone.",
			"columns": {
				"email": "E-mail",
				"name": "Name",
				"surname": "Surname",
				"company": "Company",
				"vat": "VAT",
				"tel": "Phone",
				"mobile": "Mobile",
				"irs": "Tax Office",
				"createDate": "Created"
			},
			"fields": {
				"email": "E-mail",
				"createDate": "Created",
				"name": "Name",
				"surname": "Surname",
				"company": "Company",
				"descriptiveTitle": "Descriptive title",
				"vat": "VAT",
				"irs": "Tax Office",
				"address": "Address",
				"tel": "Phone",
				"mobile": "Mobile",
				"fax": "Fax",
				"gender": "Gender",
				"dob": "Date of birth",
				"newsletter": "Receive newsletters",
				"promoOptin": "Promotional opt-in"
			}
		},
		"links": {
			"linked": "Linked",
			"inspectors": "Inspectors",
			"customers": "Customers",
			"inspectorsTitle": "Inspectors: {{name}}",
			"customersTitle": "Customers: {{name}}"
		},
		"inspectors": {
			"title": "Inspectors",
			"add": "New Inspector",
			"addTitle": "New Inspector",
			"editTitle": "Edit Inspector",
			"formSubtitle": "Inspector details.",
			"deleteTitle": "Delete inspector",
			"deleteBody": "Delete inspector “{{name}}”? This action cannot be undone.",
			"fields": {
				"name": "Name",
				"surname": "Surname",
				"email": "E-mail",
				"tel": "Phone",
				"mobile": "Mobile",
				"visible": "Visible",
				"sort": "Sort",
				"createDate": "Created"
			}
		},
		"salesPersons": {
			"title": "Sales Persons",
			"add": "New Sales Person",
			"addTitle": "New Sales Person",
			"editTitle": "Edit Sales Person",
			"formSubtitle": "Sales-person account and replacement details.",
			"deleteTitle": "Delete sales person",
			"deleteBody": "Delete sales person “{{name}}”? This action cannot be undone.",
			"fields": {
				"username": "Username",
				"password": "Password",
				"passwordEdit": "Password (blank to keep)",
				"name": "Name",
				"surname": "Surname",
				"email": "E-mail",
				"active": "Active",
				"confirmed": "Confirmed",
				"erpCode": "ERP Code",
				"replaceSalesPerson": "Replacement",
				"replaceStart": "Replacement start",
				"replaceEnd": "Replacement end"
			}
		},
		"coupons": {
			"title": "Coupons",
			"subtitle": "{{count}} coupons",
			"add": "New Coupon",
			"addTitle": "New Coupon",
			"editTitle": "Edit Coupon",
			"formSubtitle": "Coupon details, application rules and actions.",
			"searchPlaceholder": "Search by code or name",
			"deleteTitle": "Delete coupon",
			"deleteBody": "Delete coupon “{{name}}”? This action cannot be undone.",
			"tabs": {
				"basic": "Basic Info",
				"conditions": "Rules",
				"actions": "Actions"
			},
			"columns": {
				"code": "Code",
				"name": "Name",
				"amount": "Discount (€)",
				"discount": "Discount %",
				"turnover": "Turnover",
				"redeemedAmount": "Redeemed",
				"isRedeemed": "Redeemed?",
				"startDate": "Start Date",
				"endDate": "End Date"
			},
			"fields": {
				"code": "Code",
				"name": "Name",
				"sort": "Sort",
				"description": "Description",
				"active": "Active",
				"visible": "Visible",
				"generatePerCustomer": "Generate per customer",
				"codeTemplate": "Code template",
				"bulkCount": "Bulk generation (count)",
				"onceOff": "Once-off",
				"partialRedemption": "Partial redemption",
				"allowMultRedeem": "Allow multiple redemptions",
				"activeFrom": "Active from",
				"activeTo": "Active to",
				"amountThreshold": "Amount threshold",
				"nonDiscountAmountThreshold": "Amount threshold (non-discounted)",
				"allowedDomains": "Allowed domains",
				"emailExceptions": "Email exceptions",
				"assignedToEmails": "Assigned to emails",
				"customers": "Customers",
				"customerCategories": "Customer categories",
				"shippingDiscount": "Shipping discount",
				"amount": "Discount amount (€)",
				"discount": "Discount %",
				"discountMode": "Discount application mode",
				"maxRedeemableItems": "Max redeemable items",
				"products": "Products",
				"categories": "Categories",
				"ignoreDiscExceptions": "Ignore discount exceptions",
				"productApplicationScope": "Discount applies to",
				"productApplicationScopeHint": "Each eligible item: the amount is spread over the matching items. Cart total: the amount is applied once to the cart when at least one matching item is in the cart (max redeemable items is ignored)."
			},
			"discountModes": {
				"0": "Product",
				"2": "Maximum",
				"3": "Add",
				"4": "Combine"
			},
			"applicationScopes": {
				"0": "Each eligible item",
				"1": "Cart total"
			},
			"validation": {
				"percentage": "Discount must be between 0 and 100."
			}
		}
	},
	"prices": {
		"priceTypes": {
			"title": "Price Types",
			"add": "New price type",
			"addTitle": "New price type",
			"editTitle": "Edit price type",
			"formSubtitle": "Fill in the price type details.",
			"deleteTitle": "Delete price type",
			"deleteBody": "Delete price type “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"base": "Base",
				"tax": "VAT",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"currencies": {
			"title": "Currencies",
			"add": "New currency",
			"addTitle": "New currency",
			"editTitle": "Edit currency",
			"formSubtitle": "Fill in the currency details.",
			"deleteTitle": "Delete currency",
			"deleteBody": "Delete currency “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"iso": "ISO-3 Code",
				"format": "Format String",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"taxCategories": {
			"title": "Tax Categories",
			"add": "New tax category",
			"addTitle": "New tax category",
			"editTitle": "Edit tax category",
			"formSubtitle": "Fill in the tax category details.",
			"noCountry": "— None —",
			"deleteTitle": "Delete tax category",
			"deleteBody": "Delete tax category “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"type": "Tax Type",
				"status": "Tax Status",
				"country": "Country",
				"rate": "Rate",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"taxRules": {
			"title": "Tax Rules",
			"add": "New tax rule",
			"addTitle": "New tax rule",
			"editTitle": "Edit tax rule",
			"formSubtitle": "Map a geographic scope (country / region / postal code) to a tax status.",
			"selectCountry": "Select country…",
			"noRegion": "— All regions —",
			"deleteTitle": "Delete tax rule",
			"deleteBody": "Delete the tax rule for “{{name}}”? This cannot be undone.",
			"columns": {
				"country": "Country",
				"region": "Region",
				"postalCode": "Postal Code",
				"taxStatus": "Tax Status"
			}
		}
	},
	"validation": {
		"required": "Required field",
		"tooLong": "Exceeds maximum length",
		"email": "Invalid email address",
		"passwordMin": "At least 8 characters",
		"wholeNumber": "Enter a whole number, 0 or more",
		"positiveNumber": "Enter a number above 0",
		"notNegative": "Cannot be negative",
		"endBeforeStart": "The end has to be after the start",
		"ratingMax": "At most 5"
	},
	"attributes": {
		"sizeGuides": {
			"title": "Size Guides",
			"add": "New size guide",
			"untitled": "New size guide",
			"notFound": "Size guide not found.",
			"detailsTitle": "Details",
			"bodyTitle": "Body",
			"bodyPlaceholder": "Size guide content…",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete size guide",
			"deleteBody": "Delete size guide “{{name}}”? This cannot be undone.",
			"columns": {
				"title": "Title",
				"code": "Code",
				"visible": "Visible"
			}
		},
		"dimensions": {
			"title": "Dimensions",
			"add": "New dimension",
			"addTitle": "New dimension",
			"editTitle": "Edit dimension",
			"formSubtitle": "Fill in the dimension details.",
			"deleteTitle": "Delete dimension",
			"deleteBody": "Delete dimension “{{name}}”? This cannot be undone.",
			"selectType": "Select a type…",
			"values": "Values",
			"filterableHint": "Show this dimension as a filter on product lists",
			"columns": {
				"erpCode": "ERP code",
				"name": "Name",
				"type": "Type",
				"visible": "Visible",
				"sort": "Order",
				"filterable": "Storefront filter"
			}
		},
		"dimensionGroupings": {
			"title": "Dimension Grouping",
			"add": "New grouping",
			"addTitle": "New grouping",
			"editTitle": "Edit grouping",
			"formSubtitle": "Fill in the grouping details.",
			"deleteTitle": "Delete grouping",
			"deleteBody": "Delete grouping “{{name}}”? This cannot be undone.",
			"selectType": "Select a type…",
			"values": "Values",
			"noDimension": "— None —",
			"columns": {
				"erpCode": "ERP code",
				"name": "Name",
				"color": "Color",
				"code": "Code",
				"type": "Type",
				"visible": "Visible",
				"sort": "Order",
				"dimension": "Dimension"
			}
		},
		"dimensionValues": {
			"title": "Dimension values",
			"add": "New value",
			"addTitle": "New dimension value",
			"editTitle": "Edit dimension value",
			"formSubtitle": "Fill in the value details.",
			"deleteTitle": "Delete value",
			"deleteBody": "Delete value “{{name}}”? This cannot be undone.",
			"count": "{{count}} values",
			"noGrouping": "— None —",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"columns": {
				"erpCode": "ERP code",
				"value": "Value",
				"code": "Code",
				"color": "Color",
				"grouping": "Grouping",
				"altValue1": "Alt value 1",
				"altValue2": "Alt value 2",
				"image": "Image",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"categories": {
			"title": "Attribute Categories",
			"add": "New category",
			"addTitle": "New category",
			"editTitle": "Edit category",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete category “{{name}}”? This cannot be undone.",
			"formSubtitle": "Fill in the attribute-category details.",
			"columns": {
				"name": "Name",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"list": {
			"title": "Attributes",
			"add": "New attribute",
			"addTitle": "New attribute",
			"editTitle": "Edit attribute",
			"deleteTitle": "Delete attribute",
			"deleteBody": "Delete attribute “{{name}}”? This cannot be undone.",
			"formSubtitle": "Fill in the attribute details.",
			"displayName": "Display Name",
			"categoryPlaceholder": "Select a category",
			"noCategory": "— None —",
			"valueFormat": "Value Format",
			"valueFormatHelp": "Optional value formatting (e.g. {0} pages).",
			"erpCode": "ERP Code",
			"infoText": "Info Text",
			"infoTextHelp": "Descriptive text shown in the storefront.",
			"image": "Image",
			"imageHelp": "PNG, JPG or WebP up to 2MB.",
			"disableFromFilters": "Hide from filters",
			"mandatory": "Mandatory",
			"searchable": "Searchable",
			"infoVisible": "Info visible",
			"columns": {
				"code": "Code",
				"name": "Name",
				"category": "Category",
				"type": "Type",
				"valueDataType": "Data Type",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"values": {
			"title": "Attribute Values",
			"add": "New value",
			"addTitle": "New value",
			"editTitle": "Edit value",
			"deleteTitle": "Delete value",
			"deleteBody": "Delete value “{{name}}”? This cannot be undone.",
			"formSubtitle": "Fill in the value details.",
			"colorHelp": "Optional color (e.g. #FF0000).",
			"erpCode": "ERP Code",
			"image": "Image",
			"imageHelp": "PNG, JPG or WebP up to 2MB.",
			"columns": {
				"value": "Value",
				"code": "Code",
				"color": "Color",
				"visible": "Visible",
				"sort": "Order"
			}
		},
		"types": {
			"1": "Single value",
			"2": "List of values"
		},
		"valueDataTypes": {
			"1": "Text",
			"2": "Integer",
			"3": "Decimal",
			"4": "Yes/No",
			"5": "Date"
		},
		"map": {
			"title": "Assign Attributes to Categories",
			"subtitle": "Pick a category and choose the attributes assigned to it.",
			"categories": "Categories",
			"attributes": "Attributes",
			"selectCategory": "Select a category to manage its attributes.",
			"assignedCount": "{{count}} assigned attributes",
			"selectAll": "Select all",
			"clearAll": "Clear",
			"expandAll": "Expand all",
			"collapseAll": "Collapse all",
			"expand": "Expand",
			"collapse": "Collapse"
		}
	},
	"content": {
		"pages": {
			"title": "Content Pages",
			"add": "New page",
			"untitled": "Untitled",
			"notFound": "Page not found.",
			"clone": "Clone",
			"cloned": "Page cloned",
			"cloneTitle": "Clone page",
			"cloneBody": "Enter a code and title for the copy. It will be created hidden.",
			"deleteTitle": "Delete page",
			"deleteBody": "Delete the page “{{name}}”? This cannot be undone.",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"columns": {
				"code": "Code",
				"title": "Title",
				"parent": "Group",
				"visible": "Visible",
				"created": "Created",
				"sort": "Sort"
			},
			"tabs": {
				"general": "General",
				"content": "Content",
				"seo": "SEO"
			},
			"entityUrl": "Page URL",
			"entityUrlHelp": "The friendly URL the page is served at.",
			"bodyPlaceholder": "Write the page content…",
			"seoSubtitle": "Metadata and indexing settings.",
			"metaTitle": "Meta Title",
			"headerTitle": "Header (H1)",
			"metaDescription": "Meta Description",
			"metaKeywords": "Meta Keywords",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Disable indexation (noindex)",
			"disableFollow": "Disable follow (nofollow)",
			"statusTitle": "Status",
			"parentHelp": "Group under a parent page.",
			"noParent": "None"
		},
		"bannerGroups": {
			"title": "Banner Groups",
			"add": "New group",
			"addTitle": "New banner group",
			"editTitle": "Edit banner group",
			"formSubtitle": "Name, code, parent group and sort order.",
			"deleteTitle": "Delete group",
			"deleteBody": "Delete the group “{{name}}”? This cannot be undone.",
			"noParent": "None",
			"columns": {
				"name": "Name",
				"code": "Code",
				"parent": "Parent group",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"banners": {
			"title": "Banners",
			"add": "New banner",
			"untitled": "Untitled",
			"notFound": "Banner not found.",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"setAsHero": "Set as hero",
			"heroSet": "Set as hero banner",
			"deleteTitle": "Delete banner",
			"deleteBody": "Delete the banner “{{name}}”? This cannot be undone.",
			"selectGroup": "Select a group…",
			"columns": {
				"image": "Image",
				"title": "Title",
				"group": "Group",
				"visible": "Visible",
				"sort": "Sort",
				"window": "Window"
			},
			"tabs": {
				"general": "General",
				"links": "Links",
				"content": "Content",
				"images": "Images"
			},
			"subtitle": "Subtitle",
			"videoUrl": "Video URL",
			"videoUrlMobile": "Video URL (mobile)",
			"color": "Color",
			"colorHelp": "Banner background/accent color.",
			"linksSubtitle": "Up to 4 call-to-action links.",
			"ctaN": "Link {{n}}",
			"ctaText": "Text",
			"ctaUrl": "URL",
			"ctaTarget": "Opens",
			"targetDefault": "Default",
			"targetSelf": "Same tab",
			"targetBlank": "New tab",
			"bodyPlaceholder": "Banner text…",
			"imagesSubtitle": "Primary and secondary image (e.g. desktop/mobile).",
			"image1": "Image 1",
			"image2": "Image 2",
			"uploadImage": "Upload",
			"replaceImage": "Replace",
			"statusTitle": "Status",
			"startDate": "Start",
			"endDate": "End",
			"targetingTitle": "Targeting",
			"targetingSubtitle": "Show only to selected customer profiles (empty = everyone).",
			"targetingPlaceholder": "All profiles"
		},
		"menus": {
			"title": "Menu Items",
			"add": "New item",
			"untitled": "Untitled",
			"notFound": "Menu item not found.",
			"addChild": "Add child item",
			"expand": "Expand",
			"collapse": "Collapse",
			"highlighted": "Highlighted",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete menu item",
			"deleteBody": "Delete “{{name}}”? This cannot be undone.",
			"deleteBodyChildren": "“{{name}}” has sub-items. Choose whether to delete them too or keep them (they move up one level).",
			"deleteWithChildren": "Delete with sub-items",
			"deleteKeepChildren": "Keep sub-items",
			"columns": {
				"title": "Title",
				"code": "Code",
				"url": "Link",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			},
			"tabs": {
				"general": "General",
				"content": "Content",
				"images": "Images"
			},
			"erpCode": "ERP code",
			"url": "Link (URL)",
			"urlHelp": "Relative path or full URL.",
			"target": "Opens",
			"targetDefault": "Default",
			"targetSelf": "Same tab",
			"targetBlank": "New tab",
			"contentSubtitle": "Optional text/description for the menu item.",
			"imagesSubtitle": "Optional images, each with its own link.",
			"image1": "Image 1",
			"image2": "Image 2",
			"imageLink": "Image link (URL)",
			"uploadImage": "Upload",
			"replaceImage": "Replace",
			"statusTitle": "Status",
			"parent": "Parent item",
			"parentHelp": "Place under another item.",
			"topLevel": "Top level"
		},
		"footer": {
			"title": "Footer",
			"subtitle": "Columns of the storefront footer and their links.",
			"add": "New item",
			"untitled": "Untitled",
			"notFound": "Footer item not found.",
			"addChild": "Add link",
			"expand": "Expand",
			"collapse": "Collapse",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete footer item",
			"deleteBody": "Delete “{{name}}”? This cannot be undone.",
			"deleteBodyChildren": "“{{name}}” has sub-items. Choose whether to delete them too or keep them (they move up one level).",
			"deleteWithChildren": "Delete with sub-items",
			"deleteKeepChildren": "Keep sub-items",
			"columns": {
				"title": "Title",
				"code": "Code",
				"url": "Link",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			},
			"tabs": {
				"general": "General",
				"image": "Image"
			},
			"codeHelp": "Optional stable key the storefront can rely on (e.g. about_us).",
			"url": "Link (URL)",
			"urlHelp": "Relative path or full URL. The image links here too.",
			"target": "Opens",
			"targetDefault": "Default",
			"targetSelf": "Same tab",
			"targetBlank": "New tab",
			"imageSubtitle": "Optional image shown with the item, linked to the item's URL.",
			"image": "Image",
			"uploadImage": "Upload",
			"replaceImage": "Replace",
			"statusTitle": "Status",
			"parent": "Column / parent",
			"parentHelp": "Top-level items are the footer columns.",
			"topLevel": "Top level (column)"
		},
		"faqs": {
			"title": "FAQs",
			"add": "New group",
			"untitled": "Untitled",
			"notFound": "Group not found.",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"deleteTitle": "Delete group",
			"deleteBody": "Delete the group “{{name}}” and all its questions? This cannot be undone.",
			"columns": {
				"title": "Title",
				"path": "Path",
				"section": "Section",
				"count": "Questions",
				"visible": "Visible",
				"sort": "Sort"
			},
			"detailsTitle": "Group details",
			"path": "Path",
			"pathHelp": "Optional page where the group is shown.",
			"section": "Section",
			"sectionHelp": "Optional grouping/section.",
			"statusTitle": "Status",
			"questionsTitle": "Questions",
			"questionsSubtitle": "Questions and answers in this group.",
			"addQuestion": "New question",
			"editQuestion": "Edit question",
			"questionSubtitle": "Question and a rich-text answer.",
			"question": "Question",
			"answer": "Answer",
			"noQuestions": "No questions yet.",
			"saveGroupFirst": "Save the group first to add questions.",
			"entryCount": "{{count}} questions",
			"deleteQuestionTitle": "Delete question",
			"deleteQuestionBody": "Delete this question? This cannot be undone.",
			"pathOrSectionRequired": "Provide a path or a section."
		},
		"events": {
			"title": "Events",
			"add": "New event",
			"untitled": "Untitled",
			"notFound": "Event not found.",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"featured": "Featured",
			"deleteTitle": "Delete event",
			"deleteBody": "Delete the event “{{name}}”? This cannot be undone.",
			"columns": {
				"title": "Title",
				"category": "Category",
				"placed": "Mode",
				"location": "Location",
				"interest": "Expression of interest",
				"visible": "Visible",
				"sort": "Sort"
			},
			"tabs": {
				"general": "General",
				"taxonomy": "Categories & Tags",
				"content": "Content",
				"media": "Media",
				"dates": "Dates",
				"participations": "Participations",
				"seo": "SEO"
			},
			"subtitle": "Subtitle",
			"summary": "Summary",
			"editor": "Editor",
			"entityUrl": "SEO Url",
			"entityUrlHelp": "The friendly URL for the event.",
			"placed": "Mode",
			"location": "Location",
			"selectPlaceholder": "Select…",
			"noLocation": "None",
			"noLocationsHint": "No locations available. Add them under “Event Locations”.",
			"startDate": "Display from",
			"endDate": "Display until",
			"taxonomySubtitle": "Event categories and tags.",
			"categories": "Categories",
			"categoriesPlaceholder": "Select categories",
			"tags": "Tags",
			"tagsPlaceholder": "Select tags",
			"body": {
				"bd": "Body",
				"bd2": "Online viewing",
				"bd3": "Sponsors"
			},
			"bodyMainSubtitle": "The main event body.",
			"mediaSubtitle": "Primary and secondary image.",
			"image1": "Image 1",
			"image2": "Image 2",
			"uploadImage": "Upload",
			"replaceImage": "Replace",
			"seoSubtitle": "Metadata and indexing.",
			"metaTitle": "Meta Title",
			"headerTitle": "Header (H1)",
			"metaDescription": "Meta Description",
			"metaKeywords": "Meta Keywords",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Disable indexation (noindex)",
			"disableFollow": "Disable follow (nofollow)",
			"statusTitle": "Status",
			"showFront": "Show on homepage",
			"sort": "Sort",
			"interestTitle": "Expression of interest",
			"acceptInterest": "Accept expression of interest",
			"externalFormUrl": "Interest form URL",
			"datesSubtitle": "Dates/times the event takes place.",
			"dates": {
				"add": "Add date",
				"empty": "No dates yet.",
				"start": "Start",
				"end": "End",
				"addTitle": "New date",
				"editTitle": "Edit date",
				"deleteTitle": "Delete date",
				"invalidRange": "Enter a valid start and end date."
			},
			"participationsSubtitle": "Customer participations for the event.",
			"participationsEmpty": "No participations yet.",
			"participations": {
				"start": "Start",
				"end": "End",
				"firstName": "First name",
				"lastName": "Last name",
				"email": "Email",
				"mobile": "Mobile"
			}
		},
		"news": {
			"title": "News",
			"add": "New article",
			"untitled": "Untitled",
			"notFound": "Article not found.",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"featured": "Featured",
			"deleteTitle": "Delete article",
			"deleteBody": "Delete the article “{{name}}”? This cannot be undone.",
			"columns": {
				"title": "Title",
				"category": "Category",
				"publishDate": "Published",
				"featured": "Featured",
				"visible": "Visible",
				"sort": "Sort"
			},
			"tabs": {
				"general": "General",
				"taxonomy": "Categories & Tags",
				"content": "Content",
				"media": "Media",
				"seo": "SEO"
			},
			"subtitle": "Subtitle",
			"summary": "Summary",
			"editor": "Editor",
			"group": "News group",
			"noGroup": "None",
			"source": "Source",
			"sourceInternal": "Internal",
			"sourceExternal": "External",
			"externalUrl": "External URL",
			"entityUrl": "Article URL",
			"entityUrlHelp": "The friendly URL for the article.",
			"minutesToRead": "Minutes to read",
			"publishDate": "Publish date",
			"startDate": "Start",
			"endDate": "End",
			"taxonomySubtitle": "Article categories and tags.",
			"categories": "Categories",
			"categoriesPlaceholder": "Select categories",
			"tags": "Tags",
			"tagsPlaceholder": "Select tags",
			"body": {
				"bd": "Main body",
				"bd2": "Body (online)",
				"bd3": "Body (sponsors)"
			},
			"bodyMainSubtitle": "The main article body.",
			"mediaSubtitle": "Primary and secondary image.",
			"image1": "Image 1",
			"image2": "Image 2",
			"uploadImage": "Upload",
			"replaceImage": "Replace",
			"ctaTitle": "Call to action",
			"ctaSubtitle": "Optional call-to-action button.",
			"ctaText": "Text",
			"ctaUrl": "URL",
			"ctaTarget": "Opens",
			"targetDefault": "Default",
			"targetSelf": "Same tab",
			"targetBlank": "New tab",
			"seoSubtitle": "Metadata and indexing.",
			"metaTitle": "Meta Title",
			"headerTitle": "Header (H1)",
			"metaDescription": "Meta Description",
			"metaKeywords": "Meta Keywords",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Disable indexation (noindex)",
			"disableFollow": "Disable follow (nofollow)",
			"statusTitle": "Status",
			"showFront": "Show on homepage",
			"sort": "Sort",
			"sortFront": "Homepage sort",
			"sortFeatured": "Featured sort",
			"productsDisplayMode": "Products display",
			"productsDisplayModeHelp": "How linked products render under the article.",
			"productsDisplayMode_0": "Classic",
			"productsDisplayMode_1": "Product list (PLP)",
			"visibility": "Visibility",
			"visibilityHelp": "Hidden articles are left out of listings but open by direct link; drafts are never shown.",
			"visibility_0": "Published",
			"visibility_1": "Draft",
			"visibility_2": "Hidden",
			"bulk": {
				"selected": "{{count}} selected",
				"setDisplayMode": "Set display mode",
				"clear": "Clear",
				"title": "Set products display mode",
				"subtitle": "Apply to {{count}} selected article(s).",
				"apply": "Apply to {{count}}",
				"applied": "Updated {{count}} article(s)",
				"selectAll": "Select all on page",
				"selectRow": "Select article"
			}
		},
		"socialMedia": {
			"title": "Social Media",
			"add": "New platform",
			"addTitle": "New social media platform",
			"editTitle": "Edit platform",
			"formSubtitle": "Platform name, link, visibility and image.",
			"deleteTitle": "Delete platform",
			"deleteBody": "Delete the platform “{{name}}”? This cannot be undone.",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"tabs": {
				"basic": "Basic info",
				"image": "Image"
			},
			"columns": {
				"platformName": "Platform name",
				"url": "URL",
				"visible": "Visible",
				"showOnFooter": "Show on footer",
				"showOnHeader": "Show on header",
				"sort": "Sort",
				"image": "Image"
			}
		},
		"logo": {
			"title": "Logo",
			"add": "New logo",
			"addTitle": "New logo",
			"editTitle": "Edit logo",
			"formSubtitle": "Name, code, link, visibility and up to two images.",
			"deleteTitle": "Delete logo",
			"deleteBody": "Delete the logo “{{name}}”? This cannot be undone.",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"navigateUrl": "Navigate URL",
			"tabs": {
				"basic": "Basic info",
				"images": "Images"
			},
			"columns": {
				"name": "Name",
				"code": "Code",
				"url": "URL",
				"visible": "Visible",
				"sort": "Sort",
				"image": "Image"
			}
		},
		"customMessageGroups": {
			"title": "Custom Message Groups",
			"add": "New group",
			"addTitle": "New custom message group",
			"editTitle": "Edit custom message group",
			"formSubtitle": "Name, code, visibility and sort order.",
			"deleteTitle": "Delete group",
			"deleteBody": "Delete the group “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"customMessages": {
			"title": "Custom Messages",
			"add": "New message",
			"addTitle": "New custom message",
			"editTitle": "Edit custom message",
			"formSubtitle": "Schedule, group, body and call-to-action links.",
			"deleteTitle": "Delete message",
			"deleteBody": "Delete the message “{{name}}”? This cannot be undone.",
			"noGroup": "None",
			"cta": "Link {{n}}",
			"tabs": {
				"basic": "Basic info",
				"content": "Content",
				"links": "Links"
			},
			"columns": {
				"code": "Code",
				"group": "Group",
				"color": "Color",
				"startDate": "Start date",
				"endDate": "End date",
				"visible": "Visible",
				"sort": "Sort",
				"navigateUrl": "URL",
				"urlTarget": "Target",
				"ctaLabel": "Label"
			}
		},
		"pageBuilder": {
			"open": "Open in storefront Page Builder",
			"summary": "Blocks: {{count}}",
			"handoffFailed": "Could not open the Page Builder",
			"entityRequired": "Page Builder content is edited in the storefront, which opens it through the page, product or other record it belongs to. This content is not attached to one, so it cannot be opened from here."
		},
		"customContent": {
			"title": "Custom Content",
			"deleteTitle": "Delete content",
			"deleteBody": "Delete the content record “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"entityType": "Entity type",
				"entityId": "Entity id",
				"published": "Published",
				"visible": "Visible",
				"schema": "Content type",
				"sort": "Sort"
			},
			"add": "New content",
			"untitled": "No code",
			"statusPublished": "Published",
			"statusUnpublished": "Unpublished",
			"generalTitle": "General",
			"dataTitle": "Content",
			"dataSubtitle": "The record's payload (data), depending on its schema.",
			"dataPlaceholder": "Enter the content…",
			"statusTitle": "Status",
			"entityTitle": "Entity binding",
			"entitySubtitle": "This record is attached to an entity and is not managed standalone.",
			"entityKey": "Content key",
			"codeHelp": "Unique reference code for the content.",
			"codeEntityHelp": "This content is attached to an entity and has no code.",
			"notFound": "Custom content not found.",
			"lexicalNotice": "Lexical content is stored as serialized JSON. The raw state is shown here — edit with care.",
			"schema": {
				"html": "Html",
				"plainText": "Plain text",
				"markdown": "Markdown",
				"puck": "Page Builder",
				"lexical": "Lexical"
			}
		},
		"newsGroups": {
			"title": "News Groups",
			"add": "New group",
			"addTitle": "New news group",
			"editTitle": "Edit news group",
			"formSubtitle": "Name, code, visibility and sort order.",
			"deleteTitle": "Delete group",
			"deleteBody": "Delete the group “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"videoGroups": {
			"title": "Video Groups",
			"add": "New group",
			"addTitle": "New video group",
			"editTitle": "Edit video group",
			"formSubtitle": "Name, code, visibility and sort order.",
			"deleteTitle": "Delete group",
			"deleteBody": "Delete the group “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"notificationCategories": {
			"title": "Notification Categories",
			"add": "New category",
			"addTitle": "New notification category",
			"editTitle": "Edit notification category",
			"formSubtitle": "Name, code, visibility and sort order.",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete the category “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"notifications": {
			"title": "Notifications",
			"add": "New notification",
			"addTitle": "New notification",
			"editTitle": "Edit notification",
			"formSubtitle": "Title, category, target URL, body and image.",
			"deleteTitle": "Delete notification",
			"deleteBody": "Delete the notification “{{name}}”? This cannot be undone.",
			"noCategory": "None",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"tabs": {
				"basic": "Basic info",
				"content": "Content",
				"image": "Image"
			},
			"columns": {
				"title": "Title",
				"code": "Code",
				"category": "Category",
				"url": "URL",
				"image": "Image",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"newsTags": {
			"title": "News Tags",
			"add": "New tag",
			"addTitle": "New news tag",
			"editTitle": "Edit news tag",
			"formSubtitle": "Name, code, color, visibility, sort order and tag display.",
			"deleteTitle": "Delete tag",
			"deleteBody": "Delete the tag “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"color": "Color",
				"showAsTag": "Show as tag",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"eventTags": {
			"title": "Event Tags",
			"add": "New tag",
			"addTitle": "New event tag",
			"editTitle": "Edit event tag",
			"formSubtitle": "Name, code, color, visibility, sort order and tag display.",
			"deleteTitle": "Delete tag",
			"deleteBody": "Delete the tag “{{name}}”? This cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"color": "Color",
				"showAsTag": "Show as tag",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"contactForms": {
			"title": "Contact Forms",
			"add": "New form",
			"addTitle": "New contact form",
			"editTitle": "Edit contact form",
			"formSubtitle": "Email routing for a storefront contact form.",
			"deleteTitle": "Delete form",
			"deleteBody": "Delete the form “{{name}}”? This cannot be undone.",
			"columns": {
				"code": "Code",
				"fromName": "From name",
				"fromEmail": "From email",
				"subject": "Subject",
				"toNames": "To names",
				"toEmails": "To emails",
				"cc": "CC",
				"body": "Body",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"pushSubscriptions": {
			"title": "Push Subscriptions",
			"add": "New subscription",
			"addTitle": "New push subscription",
			"editTitle": "Edit push subscription",
			"formSubtitle": "Registered device subscription for push messages.",
			"deleteTitle": "Delete subscription",
			"deleteBody": "Delete this subscription? This cannot be undone.",
			"columns": {
				"deviceToken": "Device token",
				"deviceType": "Device type",
				"entityType": "Entity type",
				"entityId": "Entity id",
				"environment": "Environment",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"fileManager": {
			"title": "File Manager",
			"root": "Root",
			"newFolder": "New folder",
			"newFolderPrompt": "Folder name",
			"upload": "Upload",
			"uploading": "Uploading…",
			"uploaded": "File uploaded",
			"uploadRejected": "Unsupported file type. Allowed: images, ZIP, XML, DOC, DOCX, XLS, XLSX, CSV, TXT, PDF.",
			"copyLink": "Copy link",
			"linkCopied": "Link copied to clipboard",
			"copyFailed": "Could not copy the link.",
			"preview": "Preview",
			"image": "Image",
			"file": "File",
			"noPreview": "No preview available for this file type.",
			"openInNewTab": "Open in new tab",
			"download": "Download",
			"rename": "Rename",
			"renamePrompt": "New name",
			"deleteTitle": "Delete item",
			"deleteBody": "Delete “{{name}}”? This cannot be undone.",
			"errorLoad": "Failed to load files.",
			"empty": "This folder is empty."
		},
		"newsCategories": {
			"title": "News Categories",
			"add": "New category",
			"addTitle": "New news category",
			"editTitle": "Edit news category",
			"formSubtitle": "Title, code, visibility and SEO metadata.",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete the category “{{name}}”? This cannot be undone.",
			"tabs": {
				"basic": "Basic info",
				"seo": "SEO"
			},
			"columns": {
				"title": "Title",
				"code": "Code",
				"sort": "Sort",
				"erpCode": "ERP code",
				"visible": "Visible",
				"showFront": "Show on front",
				"entityUrl": "URL slug",
				"canonicalUrl": "Canonical URL",
				"h1": "H1 heading",
				"metaTitle": "Meta title",
				"metaKeywords": "Meta keywords",
				"metaDescription": "Meta description",
				"disableIndexation": "Disable indexation",
				"disableFollow": "Disable follow",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"eventCategories": {
			"title": "Event Categories",
			"add": "New category",
			"addTitle": "New event category",
			"editTitle": "Edit event category",
			"formSubtitle": "Title, subtitle, code, URL slug, visibility and sort.",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete the category “{{name}}”? This cannot be undone.",
			"columns": {
				"title": "Title",
				"subtitle": "Subtitle",
				"code": "Code",
				"entityUrl": "URL slug",
				"erpCode": "ERP code",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"eventLocations": {
			"title": "Event Locations",
			"add": "New location",
			"addTitle": "New event location",
			"editTitle": "Edit event location",
			"formSubtitle": "Venue, address, country/region and coordinates.",
			"deleteTitle": "Delete location",
			"deleteBody": "Delete the location “{{name}}”? This cannot be undone.",
			"none": "None",
			"columns": {
				"name": "Name",
				"url": "URL",
				"address1": "Address 1",
				"address2": "Address 2",
				"area": "Area",
				"city": "City",
				"postalCode": "Postal code",
				"country": "Country",
				"region": "Region",
				"lat": "Latitude",
				"lng": "Longitude",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"videoCategories": {
			"title": "Video Categories",
			"add": "New category",
			"addTitle": "New video category",
			"editTitle": "Edit video category",
			"formSubtitle": "Title, URL slug, visibility and sort.",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete the category “{{name}}”? This cannot be undone.",
			"columns": {
				"title": "Title",
				"entityUrl": "URL slug",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		},
		"videos": {
			"title": "Videos",
			"add": "New video",
			"addTitle": "New video",
			"editTitle": "Edit video",
			"formSubtitle": "Title, group, source URL, body and images.",
			"deleteTitle": "Delete video",
			"deleteBody": "Delete the video “{{name}}”? This cannot be undone.",
			"selectGroup": "Select a group",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"tabs": {
				"basic": "Basic info",
				"content": "Content",
				"images": "Images"
			},
			"columns": {
				"title": "Title",
				"group": "Group",
				"videoUrl": "Video URL",
				"duration": "Duration",
				"entityUrl": "URL slug",
				"image": "Image",
				"showFront": "Show on front",
				"visible": "Visible",
				"sort": "Sort",
				"startDate": "Start date",
				"endDate": "End date"
			}
		}
	},
	"contributors": {
		"categories": {
			"title": "Contributor Categories",
			"add": "New category",
			"addTitle": "New contributor category",
			"editTitle": "Edit contributor category",
			"formSubtitle": "Name, code, colour and visibility of the category.",
			"deleteTitle": "Delete category",
			"deleteBody": "Delete category “{{name}}”? This action cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"color": "Group Colour",
				"assignToProduct": "Assign to product",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"groups": {
			"title": "Contributor Groups",
			"add": "New group",
			"addTitle": "New contributor group",
			"editTitle": "Edit contributor group",
			"formSubtitle": "Name, code, description and visibility of the group.",
			"deleteTitle": "Delete group",
			"deleteBody": "Delete group “{{name}}”? This action cannot be undone.",
			"columns": {
				"name": "Name",
				"code": "Code",
				"description": "Description",
				"visible": "Visible",
				"sort": "Sort"
			}
		},
		"list": {
			"title": "Contributors",
			"subtitle": "{{count}} contributors",
			"add": "New contributor",
			"addTitle": "New contributor",
			"editTitle": "Edit contributor",
			"formSubtitle": "Basic details, images and SEO of the contributor.",
			"searchPlaceholder": "Search by name or surname…",
			"pageInfo": "Page {{page}} / {{pages}} · {{total}} total",
			"deleteTitle": "Delete contributor",
			"deleteBody": "Delete contributor “{{name}}”? This action cannot be undone.",
			"filters": {
				"toggle": "Additional filtering",
				"name": "Search by name/surname",
				"categories": "Categories",
				"pendingReview": "Pending reviews",
				"award": "Awarded",
				"erp": "ERP Code",
				"all": "All",
				"yes": "Yes",
				"apply": "Apply",
				"clear": "Clear"
			},
			"columns": {
				"name": "Name",
				"surname": "Surname",
				"country": "Country",
				"categories": "Categories",
				"reviews": "Reviews",
				"awards": "Awards",
				"visible": "Visible",
				"erp": "ERP Code"
			},
			"tabs": {
				"basic": "Basic Info",
				"images": "Images",
				"seo": "SEO"
			},
			"fields": {
				"name": "Name",
				"surname": "Surname",
				"country": "Country",
				"dob": "Date of Birth",
				"sort": "Sort",
				"visible": "Visible",
				"frontExclusion": "Front Exclusion",
				"groups": "Contributor Groups",
				"erp": "ERP Code",
				"seoUrl": "SEO URL",
				"landingUrl": "Landing URL"
			},
			"images": {
				"slot": "Image {{n}}",
				"upload": "Upload image",
				"replace": "Replace image",
				"remove": "Remove image",
				"saveFirst": "Save the contributor before uploading images."
			},
			"actions": {
				"categories": "Categories",
				"reviews": "Reviews",
				"awards": "Awards"
			},
			"subviews": {
				"categoryMap": {
					"title": "Contributor categories",
					"add": "New assignment",
					"category": "Category",
					"summary": "Summary",
					"bio": "Resume",
					"jobTitle": "Job Title",
					"email": "E-mail",
					"tel": "Telephone",
					"mobile": "Mobile",
					"website": "Website",
					"featured": "Featured",
					"visible": "Visible",
					"sort": "Sort"
				},
				"reviews": {
					"title": "Reviews",
					"add": "New review",
					"productId": "Product ID",
					"target": "Reviewed item",
					"reviewTitle": "Title",
					"reviewer": "Reviewer",
					"source": "Source",
					"review": "Review",
					"rating": "Rating",
					"status": "Status",
					"reviewDate": "Review Date",
					"featured": "Featured",
					"visible": "Visible",
					"statusPending": "Pending",
					"statusAccepted": "Accepted",
					"statusDeclined": "Declined"
				},
				"awards": {
					"title": "Awards",
					"add": "New award",
					"name": "Name",
					"description": "Description",
					"location": "Location",
					"date": "Date",
					"visible": "Visible",
					"sort": "Sort"
				}
			}
		}
	},
	"importExport": {
		"import": {
			"title": "Import data",
			"subtitle": "Upload an .xlsx file to bulk-import or remove data.",
			"modeTitle": "Import mode",
			"modeHelp": "Choose whether the file adds or removes the records it contains.",
			"modeAdd": "Add",
			"modeRemove": "Remove",
			"removeWarning": "In remove mode, the records contained in the file will be deleted. This action cannot be undone.",
			"templatesTitle": "Templates",
			"templatesHelp": "Download an empty .xlsx template with the correct columns for each import type.",
			"downloadTemplate": "Download template",
			"templateColumns": "Columns",
			"uploadTitle": "Upload file",
			"uploadHelp": "Pick an .xlsx file and press Upload.",
			"chooseFile": "Choose file",
			"noFile": "No file selected",
			"upload": "Upload",
			"uploadDone": "Upload completed",
			"allowedExtensions": "Allowed extensions: .xlsx",
			"recentTitle": "Recent imports",
			"recentHelp": "Results of recent import uploads.",
			"recentEmpty": "No recent imports.",
			"completed": "Completed",
			"failed": "Failed",
			"removeConfirm": "Are you sure you want to remove the records contained in the file?",
			"confirmRemoveCta": "Remove",
			"errorsTitle": "Import errors",
			"errorsCount": "errors",
			"noErrors": "No errors found.",
			"entityTitle": "Data type",
			"entityHelp": "Choose what the file contains: products (sheets per product data) or customers (Customers / Addresses sheets).",
			"entityProducts": "Products",
			"entityCustomers": "Customers"
		},
		"export": {
			"title": "Export data",
			"subtitle": "Pick a table, apply filters and download the data as an .xlsx file.",
			"step1Title": "Select the table you want to export",
			"step1Help": "Each time you change the table, the next steps show different options.",
			"entityLabel": "Table",
			"entityNone": "—",
			"entityProducts": "Products",
			"entityCustomers": "Customers",
			"entityOrders": "Orders",
			"step2Title": "Select the filters to apply",
			"step2Help": "Filters narrow the exported data. Apply only the filters you need for a faster export.",
			"step3Title": "Select what to export",
			"step3Help": "Each selection appears on a separate sheet in the Excel file.",
			"exportCta": "Export",
			"clearFilters": "Clear filters",
			"exportDone": "Export started",
			"selectEntityFirst": "Please select a table",
			"selectSomething": "Please select what to export",
			"activeCount_zero": "No filters selected",
			"activeCount_one": "1 filter selected",
			"activeCount_other": "{{count}} filters selected",
			"filters": {
				"search": "Search by name or code",
				"hasImage": "Has image",
				"statuses": "Statuses",
				"isVisible": "Is visible",
				"subTypes": "Sub-type",
				"priceFrom": "Amount from",
				"priceTo": "Amount to",
				"categories": "Categories",
				"manufacturers": "Manufacturers",
				"createdFrom": "Created from",
				"createdTo": "Created to",
				"orderSearch": "Order code, First name, Surname, Email, Mobile, Transaction code",
				"searchProductCode": "Search by product code",
				"searchGiftCard": "Search by gift card",
				"searchCoupon": "Search by coupon",
				"amountFrom": "Amount from",
				"amountTo": "Amount to",
				"isPaid": "Is paid",
				"hasEdited": "Has been edited",
				"containsPromotion": "Contains promotion policy",
				"containsCoupon": "Contains coupons",
				"containsGiftCard": "Contains gift card",
				"containsLoyalty": "Contains loyalty points",
				"isDraft": "Is draft",
				"isGuest": "Guest / Logged in",
				"searchProductName": "Search by product name",
				"searchManufacturerName": "Search by manufacturer name",
				"countries": "Countries",
				"orderStatuses": "Order statuses",
				"paymentTypes": "Payment types",
				"shippingTypes": "Shipping types",
				"methodOfPurchase": "Method of purchase",
				"takeAwayStores": "Take-away stores",
				"availabilityStatus": "Availability status",
				"quantityFrom": "Quantity from",
				"quantityTo": "Quantity to",
				"purchaseFrom": "Purchase date from",
				"purchaseTo": "Purchase date to",
				"customerSearch": "Search by name, email, code, mobile or VAT number",
				"isActive": "Active",
				"isConfirmed": "Confirmed",
				"receiveNewsletters": "Newsletter",
				"hasOrders": "Has orders",
				"customerCategories": "Customer categories",
				"customerTiers": "Tier",
				"genders": "Gender",
				"addressCountries": "Country (of address)",
				"registeredFrom": "Registered from",
				"registeredTo": "Registered to"
			},
			"triState": {
				"all": "All",
				"yes": "Yes",
				"no": "No",
				"guest": "Guest",
				"logged": "Logged in"
			},
			"selections": {
				"products": "Product",
				"categories": "Categories",
				"attributes": "Attributes",
				"statuses": "Statuses",
				"prices": "Prices",
				"dimensions": "Dimensions",
				"seoUrl": "SEO URL",
				"translations": "Translations",
				"variantPages": "Variant pages",
				"orders": "Orders",
				"orderLines": "Orders with products (Template 1)",
				"customers": "Customers",
				"addresses": "Addresses"
			},
			"customersImportNote": "Each selection is a separate sheet (Customers, Addresses). The same file can be imported back: customers are matched by email and addresses by email + title. The import never deletes customers or addresses."
		}
	},
	"modules": {
		"contests": {
			"title": "Contests",
			"add": "New Contest",
			"addTitle": "New Contest",
			"editTitle": "Edit Contest",
			"formSubtitle": "Contest details, content and participation lists.",
			"deleteTitle": "Delete contest",
			"deleteBody": "Delete contest “{{name}}”? This action cannot be undone.",
			"tabs": {
				"basic": "Basic Info",
				"body1": "Text (1)",
				"body2": "Text (2)",
				"more": "More"
			},
			"fields": {
				"name": "Name",
				"product": "Product",
				"startDate": "Start Date",
				"endDate": "End Date",
				"fee": "Entry fee",
				"visible": "Visible",
				"sort": "Sort",
				"body1": "Text (1)",
				"body2": "Text (2)",
				"proponents": "Proponents",
				"blacklist": "Blacklist"
			},
			"actions": {
				"draw": "Draw",
				"participations": "Participations",
				"winners": "Winners",
				"payments": "Payments"
			},
			"draw": {
				"title": "Draw:",
				"subtitle": "Run the draw and watch its progress.",
				"state": "State",
				"running": "Running",
				"completed": "Completed",
				"notRun": "Not run",
				"winnersCount": "Winners count",
				"start": "Start draw",
				"started": "Draw started",
				"winners": "Winners",
				"failures": "Failures",
				"progress": "Progress",
				"inProgress": "In progress…",
				"participations": "Participations",
				"proponents": "Proponents",
				"oldParticipations": "Old participations",
				"oldWinners": "Old winners"
			},
			"part": {
				"code": "Code",
				"barcode": "Barcode",
				"purchaseDate": "Purchase Date",
				"email": "E-mail",
				"name": "Name",
				"surname": "Surname"
			},
			"win": {
				"paid": "Paid",
				"synced": "Synced"
			},
			"pay": {
				"winner": "Winner",
				"paymentType": "Payment type",
				"success": "Success",
				"transactionId": "Transaction ID",
				"transactionStatus": "Transaction status",
				"updateDate": "Updated"
			}
		},
		"productTabs": {
			"title": "Product Tabs",
			"add": "New Tab",
			"addTitle": "New Product Tab",
			"editTitle": "Edit Tab",
			"formSubtitle": "Tab details, content and images.",
			"deleteTitle": "Delete tab",
			"deleteBody": "Delete tab “{{name}}”? This action cannot be undone.",
			"tabs": {
				"basic": "Basic Info",
				"body": "Body"
			},
			"fields": {
				"title": "Title",
				"code": "Code",
				"navigateUrl": "Navigate URL",
				"urlTarget": "URL Target",
				"rtl": "Right to left",
				"visible": "Visible",
				"sort": "Sort",
				"color": "Color",
				"image1": "Image 1",
				"image2": "Image 2"
			},
			"entry": {
				"listTitle": "Tab Entries",
				"add": "New Entry",
				"addTitle": "New Entry",
				"editTitle": "Edit Entry",
				"subtitle": "Product-tab entry.",
				"deleteTitle": "Delete entry",
				"deleteBody": "Delete this entry? This action cannot be undone.",
				"name": "Name",
				"code": "Code",
				"navigateUrl": "Navigate URL",
				"urlTarget": "URL Target",
				"mode": "Mode",
				"status": "Status",
				"category": "Category",
				"visible": "Visible",
				"sort": "Sort",
				"products": "Products",
				"productsSaveFirst": "Save the entry first to manage its products."
			}
		}
	},
	"bookings": {
		"list": {
			"title": "Bookings",
			"add": "New booking",
			"export": "Export Excel",
			"exported": "The export is ready",
			"searchPlaceholder": "Search name, email, phone, code, type…",
			"loadError": "Could not load the bookings.",
			"deleted": "The booking was deleted",
			"deleteTitle": "Delete booking",
			"deleteBody": "Delete booking {{code}}? This cannot be undone.",
			"deleteOnlyCancelled": "Only cancelled bookings can be deleted",
			"copyCode": "Click to copy",
			"codeCopied": "Code copied",
			"noCode": "No code",
			"filters": {
				"status": "Status",
				"anyStatus": "All statuses",
				"bookingType": "Booking type",
				"anyType": "All booking types",
				"store": "Pickup point",
				"anyStore": "All pickup points",
				"anyCustomer": "All customers",
				"fromDate": "From date",
				"toDate": "To date",
				"clear": "Clear filters"
			},
			"columns": {
				"code": "Code",
				"customer": "Customer",
				"bookingType": "Booking type",
				"store": "Pickup point",
				"status": "Status",
				"when": "Date & time",
				"representatives": "Representatives",
				"created": "Created"
			},
			"actions": {
				"preview": "Preview",
				"confirm": "Confirm",
				"cancel": "Cancel booking",
				"complete": "Complete"
			},
			"confirmAction": {
				"confirm": {
					"title": "Confirm booking",
					"body": "Confirm booking {{code}}? The customer is notified."
				},
				"cancel": {
					"title": "Cancel booking",
					"body": "Cancel booking {{code}}? The customer is notified."
				},
				"complete": {
					"title": "Complete booking",
					"body": "Mark booking {{code}} as completed?"
				}
			},
			"statusChanged": {
				"confirm": "The booking was confirmed",
				"cancel": "The booking was cancelled",
				"complete": "The booking was completed"
			},
			"preview": {
				"title": "Booking {{code}}",
				"subtitle": "Booking details",
				"customer": "Customer",
				"name": "Name",
				"email": "Email",
				"phone": "Phone",
				"booking": "Booking",
				"code": "Code",
				"status": "Status",
				"date": "Date",
				"time": "Time",
				"store": "Pickup point",
				"created": "Created",
				"type": "Booking type",
				"typeTitle": "Title",
				"kind": "Kind",
				"link": "Link",
				"open": "Open",
				"representatives": "Representatives",
				"noRepresentatives": "No representatives assigned",
				"saveNotes": "Save notes",
				"notesSaved": "Notes saved",
				"adminNotes": "Admin notes"
			}
		},
		"types": {
			"title": "Booking Types",
			"add": "New booking type",
			"untitled": "Untitled booking type",
			"notFound": "Booking type not found.",
			"saved": "Booking type saved",
			"closingBody_one": "{{count}} upcoming booking falls outside the new booking period. Saving cancels it and notifies the customer.",
			"closingBody_other": "{{count}} upcoming bookings fall outside the new booking period. Saving cancels them and notifies the customers.",
			"deleted": "Booking type deleted",
			"deleteTitle": "Delete booking type",
			"deleteBody": "Delete booking type “{{name}}”? A type that still has bookings, availability slots or exceptions cannot be deleted.",
			"statusVisible": "Visible",
			"statusHidden": "Hidden",
			"statusTitle": "Status",
			"scheduleTitle": "Schedule",
			"languageTitle": "Language",
			"languageBody": "Front label, short/long description, body and email text are saved for the current interface language ({{lang}}). Switch the interface language to edit another translation.",
			"frontLabelHelp": "Label shown to customers on the storefront (saved for the current language).",
			"bodyHelp": "Rich content shown on the booking page (saved for the current language).",
			"bodyPlaceholder": "Booking page content…",
			"emailDescriptionHelp": "Text included in booking emails (saved for the current language).",
			"emailDescriptionPlaceholder": "Email text…",
			"constraintsHelp": "Limit when this type can be booked. Leave empty for no restriction.",
			"maxDaysHelp": "Rolling window: how many days ahead customers can book (1–365).",
			"limitsHelp": "0 means no limit.",
			"storeHint": "Choosing a pickup point fills in its location; slots then only list that point's representatives.",
			"storeLockedHint": "Location fields follow the selected pickup point. Clear it to edit them manually.",
			"kinds": {
				"physical": "Physical",
				"online": "Online",
				"hybrid": "Hybrid",
				"delivery": "Delivery",
				"rental": "Rental",
				"contact": "Contact",
				"custom": "Custom"
			},
			"tabs": {
				"general": "General",
				"content": "Content",
				"constraints": "Date & time",
				"location": "Location",
				"links": "Online links",
				"limits": "Booking limits",
				"seo": "SEO",
				"image": "Image"
			},
			"image": "Service image",
			"uploadImage": "Upload image",
			"replaceImage": "Replace image",
			"imageHelp": "Shown on the storefront booking page and in the customer’s appointments.",
			"fields": {
				"title": "Title",
				"frontLabel": "Front label",
				"code": "Code",
				"kind": "Type",
				"shortDescription": "Short description",
				"longDescription": "Long description",
				"body": "Body",
				"emailDescription": "Email text",
				"validFromDate": "Valid from (date)",
				"validFromTime": "Valid from (time)",
				"validToDate": "Valid to (date)",
				"validToTime": "Valid to (time)",
				"maxDays": "Max days ahead",
				"store": "Pickup point",
				"locationName": "Location name",
				"locationUrl": "Location URL",
				"address": "Address",
				"address2": "Address 2",
				"area": "Area",
				"city": "City",
				"zip": "Postal code",
				"country": "Country",
				"region": "Region",
				"latitude": "Latitude",
				"longitude": "Longitude",
				"zoom": "Zoom link",
				"teams": "Teams link",
				"gmeet": "Google Meet link",
				"ytube": "YouTube link",
				"fb": "Facebook link",
				"insta": "Instagram link",
				"gurl": "Generic URL",
				"headerTitle": "Header title",
				"metaTitle": "Meta title",
				"canonicalUrl": "Canonical URL",
				"visible": "Visible",
				"sort": "Sort order"
			},
			"columns": {
				"bookingType": "Booking type",
				"store": "Pickup point",
				"stats": "Bookings",
				"constraints": "Constraints",
				"location": "Location",
				"limits": "Booking limits",
				"country": "Country",
				"region": "Region",
				"created": "Created",
				"updated": "Updated",
				"visible": "Visible",
				"sort": "Sort"
			},
			"constraints": {
				"none": "No constraints",
				"from": "From {{value}}",
				"until": "Until {{value}}",
				"daysAhead_one": "{{count}} day ahead",
				"daysAhead_other": "{{count}} days ahead"
			},
			"limits": {
				"maxb": "Max bookings",
				"maxbu": "Max bookings per customer",
				"maxbud": "Max per customer per day",
				"maxbuw": "Max per customer per week",
				"maxbum": "Max per customer per month",
				"maxbuy": "Max per customer per year",
				"maxbuShort": "Per customer",
				"maxbudShort": "Per day",
				"maxbuwShort": "Per week",
				"maxbumShort": "Per month",
				"maxbuyShort": "Per year"
			},
			"actions": {
				"slots": "Availability slots",
				"exceptions": "Exceptions",
				"rules": "Rules"
			},
			"rules": {
				"title": "Rules — {{name}}",
				"subtitle": "Override customer tiers stored in this booking type's rules. Leave empty for none.",
				"tiers": "Customer tiers",
				"tiersPlaceholder": "Choose tiers…",
				"saved": "Rules saved"
			},
			"validation": {
				"date": "Enter a valid date.",
				"time": "Enter a valid time (HH:mm).",
				"dateRange": "The end date must be after the start date.",
				"timePair": "Set both the start and end time, or leave both empty.",
				"timeRange": "Without validity dates, the end time must be after the start time.",
				"maxDays": "Enter a number of days between 1 and 365.",
				"limit": "Enter 0 or a positive whole number."
			}
		},
		"representatives": {
			"title": "Representatives",
			"add": "New representative",
			"addTitle": "New representative",
			"editTitle": "Edit representative",
			"formSubtitle": "Staff members who can be assigned to bookings.",
			"saved": "Representative saved",
			"deleted": "Representative deleted",
			"deleteTitle": "Delete representative",
			"deleteBody": "Delete representative \"{{name}}\"? This cannot be undone.",
			"storeLockedHint": "Location details follow the selected pickup point. Clear the pickup point to edit them manually.",
			"profile": "Profile",
			"viewMap": "View map",
			"today_one": "{{count}} today",
			"today_other": "{{count}} today",
			"upcoming_one": "{{count}} upcoming",
			"upcoming_other": "{{count}} upcoming",
			"sections": {
				"basic": "Basic information",
				"contact": "Contact",
				"location": "Location",
				"display": "Display"
			},
			"placeholders": {
				"title": "e.g. Dr.",
				"position": "e.g. Dermatologist"
			},
			"fields": {
				"title": "Title",
				"firstName": "First name",
				"lastName": "Last name",
				"position": "Position",
				"gender": "Gender",
				"email": "Email",
				"phone": "Phone",
				"profileUrl": "Profile URL",
				"store": "Pickup point",
				"locationName": "Location name",
				"locationUrl": "Location URL",
				"address": "Address",
				"address2": "Address line 2",
				"area": "Area",
				"city": "City",
				"zip": "Postal code",
				"country": "Country",
				"region": "Region",
				"latitude": "Latitude",
				"longitude": "Longitude",
				"visible": "Visible",
				"sort": "Sort order"
			},
			"columns": {
				"representative": "Representative",
				"store": "Pickup point",
				"stats": "Booking statistics",
				"schedule": "Schedule",
				"position": "Position",
				"contact": "Contact",
				"location": "Location",
				"country": "Country",
				"region": "Region",
				"city": "City",
				"email": "Email",
				"created": "Created",
				"updated": "Updated",
				"visible": "Visible",
				"sort": "Sort"
			},
			"stats": {
				"pending": "Pending bookings",
				"confirmed": "Confirmed bookings",
				"completed": "Completed bookings",
				"cancelled": "Cancelled bookings"
			}
		},
		"reports": {
			"title": "Booking Reports",
			"empty": "No bookings in this period",
			"error": "Could not load the report",
			"filters": {
				"status": "Status",
				"services": "Services",
				"stores": "Stores",
				"hint": "Bookings are counted by appointment date. The status filter does not apply to the KPIs and occupancy."
			},
			"kpis": {
				"total": "Total bookings",
				"confirmedRate": "Confirmed rate",
				"completionRate": "Completion rate",
				"cancellationRate": "Cancellation rate"
			},
			"occupancy": {
				"title": "Occupancy",
				"byService": "Occupancy by service",
				"byStore": "Occupancy by store",
				"booked": "Booked",
				"capacity": "Capacity",
				"summary": "{{booked}} booked of {{capacity}} available slots (cancelled bookings excluded)"
			},
			"byService": {
				"title": "Bookings by service",
				"subtitle": "Share of bookings per service"
			},
			"byStore": {
				"title": "Bookings by store",
				"subtitle": "Share of bookings per store"
			},
			"trend": "Bookings per day",
			"analytics": {
				"title": "Detailed analytics",
				"bookings": "Bookings",
				"created": "Created",
				"avgLeadTime": "Avg lead time (days)",
				"newCustomers": "New customers",
				"returningCustomers": "Returning customers",
				"repeatRate": "Repeat rate",
				"velocity": "Booking velocity",
				"velocityHint": "When the bookings of the period were created (per day)",
				"leadTime": "Lead time",
				"byDayOfWeek": "Bookings by day of week",
				"byHour": "Bookings by hour",
				"byRepresentative": "Bookings by representative",
				"lead": {
					"lead_same_day": "Same day",
					"lead_1_3": "1–3 days",
					"lead_4_7": "4–7 days",
					"lead_8_14": "8–14 days",
					"lead_15_30": "15–30 days",
					"lead_30_plus": "30+ days"
				},
				"dow": {
					"Monday": "Mon",
					"Tuesday": "Tue",
					"Wednesday": "Wed",
					"Thursday": "Thu",
					"Friday": "Fri",
					"Saturday": "Sat",
					"Sunday": "Sun"
				}
			}
		},
		"noAccess": "You do not have access to bookings.",
		"slots": {
			"title": "Availability slots — {{name}}",
			"subtitle": "Weekly time slots, per weekday and representative. Slots without representatives are generic and open to everyone.",
			"total_one": "{{count}} slot",
			"total_other": "{{count}} slots",
			"count_one": "{{count}} slot",
			"count_other": "{{count}} slots",
			"empty": "No availability slots yet. Add them with the manual or bulk creator.",
			"managedHint_one": "{{count}} date-specific slot generated by exceptions is not listed; it follows its exception.",
			"managedHint_other": "{{count}} date-specific slots generated by exceptions are not listed; they follow their exceptions.",
			"selectAll": "Select all slots",
			"select": "Select slot",
			"deleteSelected": "Delete selected ({{count}})",
			"generic": "Generic (all)",
			"maxBookings": "Max bookings",
			"sort": "Sort",
			"visible": "Visible",
			"revert": "Revert",
			"addTitle": "Add availability slots",
			"manual": "Manual",
			"bulk": "Bulk creator",
			"day": "Day of week",
			"weekdays": "Days of week",
			"startTime": "Start time",
			"endTime": "End time",
			"duration": "Slot duration (minutes)",
			"representatives": "Representatives",
			"optional": "optional",
			"genericPlaceholder": "Leave empty for a generic slot",
			"genericHint": "Leaving it empty creates a generic slot available to everyone.",
			"creatingGeneric": "No representative selected — creating a generic slot.",
			"generatePreview": "Generate preview",
			"willCreate_one": "{{count}} slot will be created",
			"willCreate_other": "{{count}} slots will be created",
			"andMore_one": "…and {{count}} more slot",
			"andMore_other": "…and {{count}} more slots",
			"createAll": "Create all ({{count}})",
			"created": "Slot created",
			"bulkCreated_one": "{{count}} slot created",
			"bulkCreated_other": "{{count}} slots created",
			"updated": "Slot updated",
			"deleted_one": "{{count}} slot deleted",
			"deleted_other": "{{count}} slots deleted",
			"confirmBulkTitle": "Create availability slots",
			"confirmBulkBody_one": "Create {{count}} availability slot?",
			"confirmBulkBody_other": "Create {{count}} availability slots?",
			"confirmDeleteTitle": "Delete availability slots",
			"confirmDeleteBody_one": "Delete {{count}} selected slot? This cannot be undone.",
			"confirmDeleteBody_other": "Delete {{count}} selected slots? This cannot be undone.",
			"validation": {
				"timeOrder": "The end time must be after the start time.",
				"maxBookings": "Max bookings must be at least 1."
			},
			"dayNames": {
				"monday": "Monday",
				"tuesday": "Tuesday",
				"wednesday": "Wednesday",
				"thursday": "Thursday",
				"friday": "Friday",
				"saturday": "Saturday",
				"sunday": "Sunday"
			},
			"daysShort": {
				"monday": "Mon",
				"tuesday": "Tue",
				"wednesday": "Wed",
				"thursday": "Thu",
				"friday": "Fri",
				"saturday": "Sat",
				"sunday": "Sun"
			}
		},
		"exceptions": {
			"title": "Exceptions — {{name}}",
			"subtitle": "Days or hours when the booking type, or one of its representatives, is unavailable or has special hours.",
			"scopes": {
				"booking": "Booking type exceptions",
				"representative": "Representative exceptions"
			},
			"total_one": "{{count}} exception",
			"total_other": "{{count}} exceptions",
			"empty": "No exceptions yet.",
			"selectAll": "Select all exceptions",
			"select": "Select exception",
			"deleteSelected": "Delete selected ({{count}})",
			"days_one": "{{count}} day",
			"days_other": "{{count}} days",
			"inactive": "Disabled",
			"maxBookingsShort": "Max {{count}}",
			"addTitle": "Add exception",
			"editTitle": "Edit exception",
			"new": "New",
			"editing": "Editing: {{name}}",
			"editRestricted": "Title, description, type, max bookings, status and (for hourly exceptions) the times can be changed. The date and mode cannot.",
			"editRestrictedRep": "Title, description, type, max bookings, status and (for hourly exceptions) the times can be changed. The date, mode and representative cannot.",
			"selectRepresentative": "Select representative…",
			"noRepresentatives": "Only representatives that have availability slots on this booking type can be selected.",
			"endDateHint": "Leave the end date empty for a single day; a range creates one exception per day.",
			"titlePlaceholder": "Optional title",
			"descriptionPlaceholder": "Optional description",
			"add": "Add exception",
			"update": "Update exception",
			"created": "Exception created",
			"updated": "Exception updated",
			"deleted_one": "{{count}} exception deleted",
			"deleted_other": "{{count}} exceptions deleted",
			"confirmDeleteTitle": "Delete exceptions",
			"confirmDeleteBody_one": "Delete {{count}} selected exception?",
			"confirmDeleteBody_other": "Delete {{count}} selected exceptions?",
			"conflictsTitle": "Existing bookings affected",
			"conflictsBody_one": "{{count}} upcoming booking falls inside this exception. Saving cancels it and notifies the customer.",
			"conflictsBody_other": "{{count}} upcoming bookings fall inside this exception. Saving cancels them and notifies the customers.",
			"cancelAndNotify": "Cancel and notify",
			"fields": {
				"representative": "Representative",
				"mode": "Exception mode",
				"startTime": "Start time",
				"endTime": "End time",
				"maxBookings": "Max bookings",
				"startDate": "Start date",
				"endDate": "End date (optional)",
				"title": "Title",
				"type": "Exception type",
				"description": "Description",
				"active": "Active exception"
			},
			"modes": {
				"full_day": "Full day",
				"available_hours": "Available hours only",
				"unavailable_hours": "Unavailable hours"
			},
			"modeHints": {
				"booking": {
					"full_day": "Blocks the entire day.",
					"available_hours": "Only these hours are available on the day.",
					"unavailable_hours": "These hours are unavailable on the day."
				},
				"representative": {
					"full_day": "The representative is unavailable all day.",
					"available_hours": "The representative is only available during these hours.",
					"unavailable_hours": "The representative is unavailable during these hours."
				}
			},
			"maxBookingsHint": {
				"booking": "Maximum concurrent bookings for this time range.",
				"representative": "Maximum concurrent bookings with this representative for this time range."
			},
			"types": {
				"National": "National holiday",
				"Religious": "Religious holiday",
				"Company": "Company holiday",
				"Maintenance": "Maintenance",
				"ScheduleChange": "Schedule change",
				"Custom": "Custom"
			},
			"validation": {
				"representative": "Select a representative.",
				"startDate": "Select a start date.",
				"endDate": "The end date cannot be before the start date.",
				"times": "Enter both start and end time.",
				"timeOrder": "The start time must be before the end time.",
				"maxBookings": "Max bookings must be at least 1."
			}
		},
		"status": {
			"pending": "Pending",
			"confirmed": "Confirmed",
			"completed": "Completed",
			"cancelled": "Cancelled"
		},
		"create": {
			"title": "New booking",
			"subtitle": "Customer, service, pickup point and an available slot.",
			"created": "Booking {{code}} created",
			"steps": {
				"customer": "Customer",
				"service": "Service",
				"slot": "Date & slot",
				"review": "Review"
			},
			"customer": "Customer",
			"service": "Service",
			"selectService": "Select a service…",
			"noServices": "There are no active booking types.",
			"store": "Pickup point",
			"selectStore": "Select a pickup point…",
			"noStore": "Not tied to a pickup point",
			"noStoresForService": "No pickup point offers this service.",
			"resolvedType": "Booking type",
			"prevWeek": "Previous week",
			"nextWeek": "Next week",
			"today": "Today",
			"constraints": {
				"title": "Booking period",
				"from": "From {{date}}",
				"to": "Until {{date}}",
				"maxDays": "Up to {{count}} days ahead"
			},
			"outsideRange": "Outside the allowed period",
			"noSlots": "No slots",
			"available_one": "{{count}} available",
			"available_other": "{{count}} available",
			"slotState": {
				"past": "Past",
				"unavailable": "Unavailable",
				"blocked": "Not bookable",
				"full": "Fully booked"
			},
			"limitTitle": "Booking restriction",
			"userStats": "Customer bookings — today: {{today}}, week: {{week}}, month: {{month}}",
			"valid": "Valid",
			"chooseRepresentative": "Choose a representative",
			"representative": "Representative",
			"noRepresentative": "No representative",
			"date": "Date",
			"time": "Time",
			"checkingConflicts": "Checking for conflicts…",
			"conflictTitle": "The customer has conflicting bookings:",
			"noConflicts": "No conflicts with the customer's other bookings",
			"notifyHint": "The booking is created as pending and the customer receives the booking email/SMS.",
			"submit": "Create booking",
			"limits": {
				"duplicate": "The customer has already booked this slot",
				"overlap": "This time overlaps with an existing booking of the customer",
				"daily": "The customer reached the daily booking limit ({{count}})",
				"weekly": "The customer reached the weekly booking limit ({{count}})",
				"monthly": "The customer reached the monthly booking limit ({{count}})",
				"yearly": "The customer reached the yearly booking limit ({{count}})",
				"global": "The overall booking limit for this type has been reached",
				"slot": "There are no free places at this time",
				"total": "The customer reached the booking limit for this service ({{count}})",
				"past": "This time has already passed",
				"date_constraint": "The date is outside the dates this service can be booked",
				"time_constraint": "The time is outside the hours this service can be booked",
				"invalid": "The booking request is not valid",
				"generic": "This booking is not possible right now"
			}
		},
		"validation": {
			"coordinate": "Enter a valid coordinate.",
			"url": "Enter a full link starting with http:// or https://."
		},
		"lookupDenied": {
			"stores": "Choosing a pickup point needs the Orders or Order Approval role.",
			"tiers": "Customer tiers need the System role.",
			"customers": "Searching customers needs the Customers role."
		}
	}
}
